export const resources = {
  en: {
    translation: {
      login: {
        title: 'Authentication',
        legend: "Don't have an account?",
        email_label: 'Email',
        email_required: 'Please input your email',
        email_placeholder: 'Email...',
        password_label: 'Password',
        password_required: 'Please input your password',
        password_placeholder: 'Password...',
        register: 'Register',
        submit: 'Authenticate',
        google_btn: 'Continue with Google',
        forgot: 'Forgot password',
      },
      forgot: {
        title: 'Forgot password',
        legend: 'Enter your email address and we will send you instructions to reset your password.',
        email_label: 'Email',
        email_required: 'Please input your email',
        email_placeholder: 'Email...',
        submit: 'Send',
      },
      password_bar: {
        bar_level_1: 'weak password',
        bar_level_2: 'weak password',
        bar_level_3: 'okay password',
        bar_level_4: 'good password',
        bar_level_5: 'strong password',
        password_must: 'Password must contain at least',
        must_characters: '12 character',
        must_uppercase: '1 uppercase',
        must_lowercase: '1 lowercase',
        must_number: '1 number',
        must_special: '1 special character e.g. !_@',
      },
      register: {
        title: 'Register',
        legend: 'Already have an account?',
        signin: 'Authenticate',
        submit: 'Register',
        name_required: 'Please input your name',
        name_label: 'Name',
        name_placeholder: 'Name...',
        email_required: 'Please input your email',
        email_not_valid: 'Email is not valid',
        email_label: 'Email',
        email_placeholder: 'Email...',
        password_label: 'Password',
        password_placeholder: 'Password...',
        password_required: 'Please input your password',
        password_whitespace: 'Password cannot have leading or trailing spaces',
        confirmation_required: 'Please confirm your password',
        confirmation_not_match: "Password confirmation doesn't match",
        confirmation_label: 'Confirm password',
        confirmation_placeholder: 'Password confirmation...',
        google_btn: 'Continue with Google',
        invitation_validating: 'Validating invitation code...',
        invitation_invalid: 'Invalid or expired invitation code.',
        invitation_valid: "You've been invited to join {0}.",
        invitation_validating_message: 'We are validating your invitation code. Please wait a moment...',
        invitation_invalid_message:
          'Your invitation code is invalid or has expired. Please contact your administrator.',
        invitation_valid_message: "You've been invited to join {0}. Please complete your registration below.",
        invitation_valid_message_part1: "You've been invited to join",
        invitation_valid_message_part2: '. Please complete your registration below.',
      },
      recovery: {
        title: 'Password Recovery',
        legend: "We've sent a verification code to your email. Please enter it below.",
        submit: 'Change',
        password_required: 'Please input your new password',
        new_password_label: 'New password',
        new_password_placeholder: 'Password...',
        confirmation_required: 'Please confirm your new password',
        confirmation_not_match: "Password confirmation doesn't match",
        confirmation_label: 'Confirm new password',
        confirmation_placeholder: 'Password confirmation...',
        title_verified: 'Password Changed! 🎉',
        legend_verified: 'You can now login.',
        login: 'Go to Login',
        resend: 'Resend Code',
      },
      verification: {
        title: 'Verification Code',
        legend: "We've sent a verification code to your email. Please enter it below.",
        title_verified: 'Code Verified! 🎉',
        legend_verified: 'You can now login.',
        login: 'Go to Login',
        resend: 'Resend Code',
      },
      callback: {
        title: 'Authenticating...',
        legend: 'Please wait while we verify your credentials. You will be redirected shortly.',
        login: 'Back to Login',
      },
      sidebar: {
        home: 'Home',
        diagnostics: 'Scenarios',
        help: 'Help',
        dashboard: 'Dashboard',
        company: 'Company',
        memories: 'Memories',
        profile: 'Profile',
        settings: 'Settings',
        logout: 'Logout',
        risk: 'Risk',
        more: 'more',
        schedule: 'Schedule',
        control_assessment: 'Audits',
        compliance_reports: 'Reports',
      },
      home: {
        title: 'Home',
        welcome_1: 'Welcome,',
        welcome_2: 'my name is',
        welcome_3: 'Ciphia',
        security_message: 'All the information will be protected and secured.',
        tour_intro: "Here's how Ciphia helps you reduce human risk,",
        tour_dashboard_title: 'Dashboard',
        tour_dashboard_desc: "See your team's risk score, trends, and priority areas at a glance.",
        tour_scenarios_title: 'Scenarios',
        tour_scenarios_desc:
          'Interactive scenarios that test your team against real threats, with training videos to reinforce learning.',
        tour_simulations_title: 'Simulations',
        tour_simulations_desc: 'Run phishing campaigns via Email or QR codes to test awareness.',
        tour_company_title: 'Company',
        tour_company_desc: 'Add your team members, configure groups, and manage integrations.',
        tour_control_audits_title: 'Audits',
        tour_control_audits_desc: 'Run interview-based control assessments and review AI-generated findings.',
        tour_compliance_reports_title: 'Reports',
        tour_compliance_reports_desc:
          'Build, refresh, and publish compliance reports for SOC 2, ISO, and Argentine frameworks.',
        tour_go_to_dashboard: 'Go to Dashboard',
      },
      company: {
        title: 'Company',
        section_title: 'Manage Company',
        active_users: 'Active Users',
        column_name: 'Name',
        column_email: 'Email',
        column_client: 'Client',
        search_placeholder: 'Search...',
        invite_admin: 'Invite Admin',
        invite_admin_title: 'Invite Admin to {{companyName}}',
        user_email: 'Admin Email',
        email_required: 'Please input the email of the admin',
        name_label: 'Name:',
        industry_label: 'Industry:',
        industry_placeholder: 'Select an industry',
        size_label: 'Size:',
        domain_verification_title: 'Domain Verification (DNS)',
        invite_error: 'Failed to send invitation.',
        invite_success: 'Invitation sent successfully!',
        invite_generic_error: 'An error occurred while sending the invitation.',
      },
      scenarios: {
        language_label: 'Email language',
        language_hint: 'Language for scenario notification emails',
      },
      atlas_onboarding: {
        title: 'Organizational Mapping',
        description:
          'You have been invited to complete your organizational profile. It takes a few minutes and helps us understand the structure of the organization.',
        optin_line1:
          'Ciphia is an operational and human risk analysis platform that helps organizations strengthen their security posture.',
        optin_line2:
          'By continuing, you agree that your answers will be processed and analyzed using artificial intelligence for the sole purpose of assessing and improving the security of the organization.',
        optin_line3: 'Your data is treated confidentially and is not shared with third parties.',
        cta: 'Accept and start',
        expired_title: 'Link expired',
        expired_subtitle: 'This link has expired. Ask your administrator for a new invitation.',
        invalid_title: 'Invalid link',
        invalid_subtitle: 'This link is not valid. Check that the URL is correct or ask for a new invitation.',
        completed_title: 'Completed',
        completed_subtitle:
          'Thank you for completing the interview. This helps improve the security posture of the organization.',
        interview_completed: 'Interview completed',
        interview_completed_hint: 'You can finish whenever you are ready.',
        finalize: 'Finish',
        confirm_and_finish: 'Confirm and finish',
        findings: 'Findings',
        people: 'People',
        groups: 'Groups',
        relations: 'Relations',
        avatar_you: 'You',
        self_label: 'Me',
        input_placeholder: 'Type your answer...',
        send_sr: 'Send',
        block_role: 'Role',
        block_hierarchy: 'Hierarchy',
        block_relations: 'Relations',
        review_title: 'Interview summary',
        review_subtitle: 'Review the extracted information. If something is not correct, write below to fix it.',
        review_your_info: 'Your information',
        review_department: 'Department',
        review_departments: 'Departments mentioned',
        review_responsibilities: 'Responsibilities',
        review_people: 'People mentioned',
        review_relations: 'Relations',
        review_correction_hint: 'Something wrong? Write the correction and we will apply it.',
        review_correction_placeholder: 'E.g. Renata is COO, not CTO...',
        rel_reports_to_first: 'report to',
        rel_reports_to_third: 'reports to',
        rel_works_in_first: 'work in',
        rel_works_in_third: 'works in',
        rel_works_with_first: 'work with',
        rel_works_with_third: 'works with',
        rel_collaborates_with_first: 'collaborate with',
        rel_collaborates_with_third: 'collaborates with',
        rel_manages_first: 'manage',
        rel_manages_third: 'manages',
        rel_belongs_to_first: 'belong to',
        rel_belongs_to_third: 'belongs to',
        rel_has_role_first: 'have role',
        rel_has_role_third: 'has role',
        rel_member_of_first: 'am a member of',
        rel_member_of_third: 'is a member of',
      },
      atlas: {
        send_invitations: 'Send invitations',
        send_onboarding: 'Send onboarding',
        pending_changes: 'There are pending changes in the graph',
        discard: 'Discard',
        apply_changes: 'Apply changes',
        col_consent: 'Consent',
        col_status: 'Atlas status',
        col_relations: 'Relations',
        status_merged: 'Completed',
        status_in_progress: 'In progress',
        status_pending: 'Pending',
        status_not_started: 'Not started',
        consent: {
          title: 'Atlas: Organizational Map',
          accept: 'Accept and start',
          decline: 'Decline',
          understood: 'Got it',
          declined_title: 'Atlas not enabled',
          declined_message: 'You can change your decision from your profile at any time.',
        },
        relations: {
          REPORTS_TO: { out: 'reports to', in: 'manages' },
          COLLABORATES_WITH: { out: 'collaborates with', in: 'collaborates with' },
          BELONGS_TO: { out: 'belongs to', in: 'includes' },
        },
        status: {
          completed: 'Completed',
          not_started: 'Not started',
        },
        card: {
          relations: 'Relations',
          role: 'Role',
          department: 'Department',
          risk: 'Risk',
          consent: 'Consent',
          onboarding: 'Onboarding',
          type: 'Type',
          type_employee: 'Employee',
          type_group: 'Group',
          type_company: 'Company',
          type_candidate: 'Candidate',
          type_department: 'Group/Department',
          undefined: 'Undefined',
          yes: 'Yes',
          no: 'No',
          link_to_employee: 'Link to an existing employee',
          search_employee: 'Search employee...',
          link: 'Link',
        },
      },
      employee_form: {
        role: 'Role',
        role_required: 'Role is required',
        role_placeholder: 'E.g. Software Engineer',
        group: 'Group',
        group_required: 'Group is required',
        group_placeholder: 'Select a group',
        fail_save: 'Failed to save employee',
        first_name: 'First Name',
        first_name_placeholder: 'Enter first name',
        first_name_required: 'Please enter first name',
        last_name: 'Last Name',
        last_name_placeholder: 'Enter last name',
        last_name_required: 'Please enter last name',
        email: 'Email',
        email_placeholder: 'Enter email address',
        email_required: 'Please enter email',
        email_invalid: 'Please enter a valid email',
        add_title: 'Add New Employee',
        edit_title: 'Edit Employee',
      },
      employee_management: {
        company_id_missing: 'Company ID not available for fetching employees',
        service_unavailable: 'Get employees service not available',
        fetch_error: 'Error fetching employees:',
        load_failed: 'Failed to load employees',
        load_error_generic: 'An unexpected error occurred while loading employees',
        company_id_not_found: 'Company ID not found',
        create_service_unavailable: 'Employee creation service not available',
        create_failed: 'Failed to create employee',
        create_success: 'Employee created successfully!',
        create_error_generic: 'An unexpected error occurred while creating the employee',
        no_selection: 'No employee selected for editing',
        update_service_unavailable: 'Employee update service not available',
        update_failed: 'Failed to update employee',
        update_success: 'Employee updated successfully!',
        update_error_generic: 'An unexpected error occurred while updating the employee',
        delete_service_unavailable: 'Employee deletion service not available',
        delete_title: 'Delete Employee',
        delete_confirm: 'Are you sure you want to delete this employee?',
        yes: 'Yes',
        no: 'No',
        delete_failed: 'Failed to delete employee',
        delete_success: 'Employee deleted successfully!',
        delete_error_generic: 'An unexpected error occurred while deleting the employee',
        employees_title: 'Employees ({{count}})',
        add_employee: 'Add Employee',
        no_employees: 'No employees found',
        col_name: 'Name',
        col_email: 'Email',
        col_job_title: 'Job Title',
        col_department: 'Department',
        col_employment_type: 'Employment Type',
        col_actions: 'Actions',
        tooltip_edit: 'Edit employee',
        tooltip_delete: 'Delete employee',
        import_csv: 'Import CSV',
        groups: 'Groups',
        col_status: 'Status',
        toggle_enabled: 'Employee enabled successfully',
        toggle_disabled: 'Employee disabled successfully',
        toggle_failed: 'Failed to toggle employee status',
        toggle_error: 'Error toggling employee status',
        toggle_limit_reached: 'Cannot enable - employee limit reached',
        col_group: 'Group',
      },
      verified_domains: {
        title: 'Verified Domains',
        description:
          'Add domains that employees can use for their email addresses. Only emails from verified domains can be added.',
        placeholder: 'e.g., example.com',
        add: 'Add',
        empty: 'No verified domains configured. Add domains to allow employee emails.',
        domain_added: 'Domain added successfully',
        domain_removed: 'Domain removed successfully',
        add_error: 'Failed to add domain',
        remove_error: 'Failed to remove domain',
        validation_disabled_notice: 'Domain validation has been disabled by system administrator.',
      },
      employee_risk_dashboard: {
        page_title_brand: 'Ciphia',
        page_title: 'Dashboard',
        page_helmet_title: 'Ciphia Dashboard',
        no_risk_data_title: 'No Risk Data Available',
        no_risk_data_desc: 'Employee risk assessments will appear here once scenarios are completed',
        company_risk: 'Company Risk',
        total_employees: 'Total Employees',
        high_risk: 'High Risk',
        medium_risk: 'Medium Risk',
        low_risk: 'Low Risk',
        risk_assessment_title: 'Risk Assessment',
        filter_all: 'All',
        filter_high: 'High Risk',
        filter_medium: 'Medium Risk',
        filter_low: 'Low Risk',
        no_employees_found: 'No employees found for selected filter',
        try_different_filter: 'Try selecting a different risk level',
        risk_score: 'Risk Score: {{score}}',
        score: 'Score: {{score}}',
        scenarios: 'Scenarios: {{count}}',
        phishing_count: 'Simulations: {{count}}',
        never: 'Never',
        risk: 'Risk:',
        employees: 'employees',
        total: 'Total',
        group_risk_title: 'Risk by Group',
        diagnostic_history: 'Scenario History',
        no_history: 'No scenario history available.',
        col_date: 'Date',
        col_scenario: 'Scenario',
        col_risk_score: 'Score',
        col_risk_level: 'Risk Level',
        col_passed: 'Result',
        passed: 'Passed',
        failed: 'Failed',
        no_history_table: 'No scenario history',
        risk_level_high: 'High',
        risk_level_medium: 'Medium',
        risk_level_low: 'Low',
        category_Identity___Access_Security: 'Identity & Access',
        category_Network___Infrastructure_Security: 'Network & Infrastructure',
        category_Device___Data_Protection: 'Device & Data Protection',
        category_Human_Centric_Security: 'Human Factor',
        risk_distribution_title: 'Risk Distribution',
        category_risk_profile: 'Risk Profile',
        risk_trend_title: 'Risk Trend',
        view_plan: 'View plan →',
        no_trend_data: 'No trend data available yet',
        no_category_data: 'No category data yet',
        complete_scenarios: 'Complete scenarios to see risk by category',
        categories: {
          account_password: 'Account & Password Security',
          phishing_email: 'Phishing & Email Safety',
          phishing_awareness: 'Phishing Simulation Behavior',
          device_security: 'Device Security',
          data_privacy: 'Data Handling & Privacy',
          safe_browsing_saas: 'Safe Browsing & SaaS Usage',
          ai_emerging_threats: 'AI & Emerging Threats',
        },
        disabled_indicator: 'Disabled',
        show_disabled: 'Show disabled',
        hide_disabled: 'Hide disabled',
        filter_include_disabled: 'Include disabled employees',
        cta_launch_diagnostic: 'Launch Diagnostic',
        cta_launch_simulation: 'Launch Simulation',
        cta_launch_control_audit: 'Launch Audit',
        send_training: 'Send Training',
        // Phishing stats
        dashboard_phishing_title: 'Latest Phishing Simulation',
        dashboard_phishing_fall_rate: 'Fall Rate',
        dashboard_phishing_sent: 'Sent',
        dashboard_phishing_clicked: 'Clicked',
        dashboard_phishing_fell: 'Fell',
        dashboard_phishing_channel: 'Channel',
        dashboard_phishing_no_data: 'No completed phishing simulations',
        // Control vulnerabilities
        dashboard_control_vulns_title: 'Latest Control Vulnerabilities',
        dashboard_control_vulns_unfixed: '{{count}} unfixed',
        dashboard_control_vulns_no_data: 'No control assessments completed',
      },
      diagnostic_conversation: {
        select_option_placeholder: 'Please select an option above',
        textarea_placeholder: 'Type your message...',
        send_message: 'Send message',
        load_problem: 'There was a problem loading the scenario conversation.',
        load_error: 'Cannot load conversation',
        diagnostic: 'Scenario',
        thinking: 'Thinking...',
        your_selection: 'Your selection',
        error: 'Error',
      },
      posture: {
        improved_title: 'Great job!',
        improved:
          "Your security posture has improved. You're getting stronger at protecting yourself and your organization. Keep it up!",
        worsened_title: 'Keep learning!',
        worsened:
          "Your security posture has decreased. But don't worry, this is part of the learning process! Watch this short video to strengthen your skills.",
        worsened_super:
          "Your security posture has decreased. But don't worry, this is part of the learning process! Pay attention to these topics in your daily routine and you'll see improvement.",
        video_intro: 'This short video will help reinforce what you just learned.',
        video_completed: "Thanks for watching! You're building stronger security habits with every step.",
        learning_recap: 'Key Takeaways',
      },
      training: {
        header: 'Training',
        completed_title: 'Training Completed!',
        completed_sub: 'Your progress was saved. You can close this window now.',
        error_legend: 'There was a problem loading the training.',
        load_error: 'Cannot load video',
      },
      super_scenario: {
        results_title: 'Your results by category',
        result_title_singular: 'Your result in this category',
        generating_feedback: 'Generating recommendations...',
        recommendations: 'Recommendations',
      },
      diagnostic_results: {
        not_found: 'Scenario not found',
        not_found_desc: 'The requested scenario could not be found.',
        back_to_diagnostics: 'Back to Scenarios',
        loading_error: 'Failed to load scenario data',
        export_success: 'Results exported successfully',
        title: 'Scenario Results: {{topic}}',
        created_on: 'Created on {{date}}',
        completed_on: 'Completed on {{date}}',
        performance_records: '{{count}} performance records',
        view_analytics: 'View Analytics',
        export_results: 'Export Results',
        status_completed: 'Completed',
        status_in_progress: 'In Progress',
        total_participants: 'Total Participants',
        completion_rate: 'Completion Rate',
        participation_rate: 'Participation Rate',
        stat_completed: 'Completed',
        tab_overview: 'Overview',
        tab_participants: 'Participants',
        tab_performance: 'Performance Analytics',
        card_participation: 'Participation Overview',
        card_progress: 'Progress Details',
        no_participation_data: 'No participation data available',
        label_overall_completion: 'Overall Completion',
        label_completed: 'Completed',
        label_in_progress: 'In Progress',
        label_not_started: 'Not Started',
        participants_count: '{{count}} participants',
        card_diagnostic_info: 'Scenario Information',
        label_topic: 'Topic:',
        label_client: 'Client:',
        label_status: 'Status:',
        label_created: 'Created:',
        label_started: 'Started:',
        label_finished: 'Finished:',
        label_additional_info: 'Additional Information:',
        no_additional_info: 'No additional information provided.',
        card_participant_details: 'Participant Details',
        btn_performance: 'Performance',
        btn_view_results: 'View Results',
        label_duration: 'Duration: {{minutes}}m',
        label_retries: 'Retries: {{count}}',
        label_videos: 'Videos: {{count}}',
        card_user_scores: 'User Scores & Completion Times',
        chart_videos_watched: 'Videos Watched',
        chart_watch_time: 'Total Watch Time (s)',
        no_video_data: 'No video engagement data available',
        card_scenario_steps: 'Scenario Steps Analysis',
        chart_passed: 'Passed',
        chart_failed: 'Failed',
        no_step_data: 'No step analysis data available',
        tab_insights: 'AI Insights',
        card_overall_insights: 'Overall Scenario Insights',
        card_individual_insights: 'Individual Participant Insights',
        default_participant: 'Participant {{index}}',
        card_risk_distribution: 'Risk Distribution',
        no_performance_data: 'No performance data available',
        no_risk_data: 'No risk data available',
        card_video_engagement: 'Video Engagement',
        chart_score: 'Score (%)',
        chart_time: 'Time (min)',
        risk_low: 'Low Risk',
        risk_medium: 'Medium Risk',
        risk_high: 'High Risk',
        drawer_title: 'Performance Details - {{user}}',
        card_overall_performance: 'Overall Performance',
        stat_final_score: 'Final Score',
        stat_risk_level: 'Risk Level',
        stat_completion_time: 'Completion Time',
        card_step_performance: 'Step Performance',
        stat_steps_passed: 'Steps Passed',
        stat_steps_failed: 'Steps Failed',
        stat_success_rate: 'Success Rate',
        label_failed_steps: 'Failed Steps:',
        card_engagement_metrics: 'Engagement Metrics',
        stat_videos_watched: 'Videos Watched',
        stat_retries: 'Retries',
        stat_hints_used: 'Hints Used',
        card_improvement_areas: 'Areas for Improvement',
        card_recommended_training: 'Recommended Training',
        modal_analytics_title: 'Comprehensive Analytics Dashboard',
        btn_close: 'Close',
      },
      dashboard: {
        title: 'Dashboard',
        origin_title: 'Origin',
        explanation_title: 'Explanation',
        mark_as: 'Mark as {{done}}',
        analyzing: 'Analyzing',
        mitigation_plan: 'Mitigation Plan',
        explanation: 'Explanation',
        origin: 'Origin',
        description: 'Description',
        categories_title: 'Categories & Vulnerabilities ({{qty}})',
        analyzed: '# of Analysis',
        fixed_qty: '# of Fixed',
        found: '# of Found',
        risk: 'Risk',
        fixed: 'Fixed',
        not_fixed: 'Not Fixed',
        suggestions_title: 'Generating...',
        suggestions_legend: 'Please wait while we generate your custom suggestions.',
        no_vulnerabilities: 'No vulnerabilities found',
        delete_title: 'Delete the vulnerability',
        delete_content: 'Are you sure to delete this vulnerability?',
        delete_ok: 'Yes',
        delete_cancel: 'No',
        delete: 'Delete',
        mark_fixed: 'Mark as Fixed',
        mark_not_fixed: 'Mark as Not Fixed',
        description_title: 'Description',
        suggestions_actions_title: 'Suggested Actions',
        action: 'Action',
        empty_vulnerabilities: 'No Vulnerabilities',
        new_diagnostic: '+ Scenario',
      },
      create_diagnostic: {
        title: 'Scenario',
        legend:
          'Create interactive security scenarios by choosing a topic and selecting team members. The system will engage each participant in a realistic conversation, evaluate their responses, and assign training videos when needed to reinforce key concepts.',
        client_label: 'Select where to start the conversation.',
        emails_label: 'Emails of the users you want to collect input.',
        emails_required: 'Please input the emails of the users',
        emails_placeholder: 'Emails separated by space...',
        emails_invalid: 'Invalid Emails',
        topic_label: 'Topic you want Ciphia to discuss. E.g. Passwords Security, Phishing, etc.',
        topic_required: 'Please input the title of the topic',
        topic_placeholder: 'Title of the topic (one topic per scenario)...',
        additional_label: 'Additional information about the Security topic you want to analyze. (Optional)',
        additional_required: 'Please input the topic',
        additional_placeholder: 'About the topic or desirable outcomes of the conversation...',
        submit: 'Create Scenario',
      },
      diagnostic: {
        feedback_link: 'Feedback',
        support_link: 'Support',
        feedback_title: 'Send feedback',
        support_title: 'Get support',
        feedback_description: 'Share your thoughts about this training experience.',
        support_description: 'Describe the issue you are experiencing and we will get back to you.',
        feedback_placeholder: 'Type your message here...',
        feedback_success: 'Thank you for your message!',
        feedback_error: 'Failed to send. Please try again.',
        title: 'Scenarios',
        title_single: 'Scenario',
        legend:
          'Every week, employees get a short security scenario in their inbox. AI adapts each one to their role, seniority and past mistakes.',
        diagnostic_title: 'Scenarios ({{qty}})',
        no_diagnostics: 'No scenarios found',
        no_diagnostics_title: 'Nothing scheduled yet',
        no_diagnostics_desc:
          'Schedule a weekly slot and the first scenario goes out on the next Monday. Or hit "Run now" from any schedule to test end-to-end today.',
        schedule_first_cta: 'Schedule your first',
        create_first: 'Create your first scenario',
        users_title: 'Users',
        target_all: 'All',
        target_employees: 'Specific employees',
        additional_information_title_link: 'Additionals',
        additional_information_title: 'Additional Information',
        finished: 'Finished',
        started: 'Started',
        not_started: 'Not Started',
        not_found: 'Not Found',
        finish: 'Finish',
        start: 'Start',
        results: 'View Insights',
        add_diagnostic: '+ New',
        started_at: 'Started at {{date}}',
        finished_at: 'Finished at {{date}}',
        results_title: 'Scenario Insights',
        results_loading_title: 'Generating...',
        results_loading_legend: 'Please wait while we analyze the results for the scenario.',
        delete_title: 'Delete the scenario',
        delete_content: 'Are you sure to delete this scenario?',
        delete_ok: 'Yes',
        delete_cancel: 'No',
        weekly_rotation_label: 'Weekly schedule',
        weekly_rotation_tooltip: 'Enable weekly scheduled scenarios',
        weekly_rotation_disabled: 'Weekly scenarios disabled',
        weekly_rotation_enabled: 'Weekly scenarios enabled',
        manage_schedules: 'Manage Schedules',
        language_label: 'Email Language',
        language_hint: 'Language for scenario notification emails',
      },
      schedules: {
        weekly_schedules: 'Weekly schedules',
        executed_this_week: 'Executed this week',
        page_helmet_title: 'Schedules',
        title: 'Scheduled Trainings',
        add_schedule: 'Add Schedule',
        load_failed: 'Failed to load schedules',
        update_failed: 'Failed to update schedule',
        update_success: 'Schedule updated',
        create_failed: 'Failed to create schedule',
        create_success: 'Schedule created',
        delete_failed: 'Failed to delete schedule',
        delete_success: 'Schedule deleted',
        unexpected_error: 'An unexpected error occurred',
        count_schedules: '{{active}}/{{limit}} schedules',
        executions_this_week: 'Executions this week: {{count}}/{{limit}}',
        delete_modal_title: 'Delete Schedule',
        delete_modal_ok: 'Delete',
        delete_modal_content: 'Are you sure you want to delete "{{name}}"?',
        delete_modal_content_fallback: 'Are you sure you want to delete this schedule?',
        run_now_confirm_title: 'Run scenario now?',
        run_now_confirm_content:
          'This runs the same delivery the cron would trigger — an AI-adapted scenario goes to every target employee now instead of on the next slot. Weekly execution count still applies.',
        run_now_confirm_ok: 'Run now',
        run_now_enqueued: 'Scenario enqueued — messages will arrive shortly.',
        run_now_failed: 'Could not enqueue the scenario. Please try again.',
        limit_exceeded_title: 'Weekly limit exceeded',
        limit_exceeded_desc: 'Some schedules are paused. Deactivate or delete excess schedules, or upgrade your plan.',
        calendar: {
          columns: { day: 'Day', time: 'Time', target: 'Target', name: 'Name', active: 'Active' },
          empty: 'No scheduled scenarios yet',
          create_first: 'Create your first schedule',
          no_schedules: 'No schedules',
          one_time_schedules: 'One-time Schedules',
          completed: 'Completed',
          scheduled_for: 'Scheduled for',
          no_recurring: 'No recurring schedules yet',
          add_recurring: 'Add Recurring Schedule',
          targets: {
            all_employees: 'All Employees',
            groups: '{{count}} Groups',
          },
          tooltips: {
            over_weekly_limit: 'Over weekly limit',
            pause: 'Pause',
            activate: 'Activate',
          },
        },
        modal: {
          create_title: 'New Scheduled Scenario',
          edit_title: 'Edit Schedule',
          schedule_type: {
            recurring: 'Recurring (weekly)',
            once: 'One-time',
          },
          fields: {
            name_label: 'Name (Optional)',
            name_placeholder: 'e.g., Weekly Security Training',
            schedule_type_label: 'Schedule Type',
            day_label: 'Day',
            day_placeholder: 'Select day',
            time_label: 'Time',
            time_placeholder: 'Select time',
            date_label: 'Date',
            date_placeholder: 'Select date',
            execute_at_label: 'Send Date & Time',
            timezone_label: 'Timezone',
            timezone_placeholder: 'Select timezone',
            target_audience_label: 'Target Audience',
            target_groups_label: 'Target Groups',
            target_employees_label: 'Target Employees',
            delivery_channel_label: 'Delivery Channel',
            language_label: 'Email Language',
            scenario_label: 'Scenario',
            scenario_placeholder: 'Random (automatic selection)',
            scenario_tooltip: 'Select a specific scenario or leave empty for random selection',
            adapt_scenarios_label: 'AI Scenario Adaptation',
            adapt_scenarios_tooltip:
              'Uses AI to customize the scenario introduction for the target group industry and department. Questions and scoring remain identical.',
          },
          validation: {
            select_one_group: 'Select at least one group',
            select_one_employee: 'Select at least one employee',
          },
          target: {
            all: 'All Employees',
            groups: 'Specific Groups{{suffix}}',
            employees: 'Specific Employees{{suffix}}',
            pro_only: 'Pro/Enterprise only',
          },
          delivery: {
            web: 'Web (Email Link)',
          },
          note: {
            title: 'Note:',
            body: "At execution time, the system will automatically select a scenario that the target employees haven't completed yet.",
          },
          actions: {
            delete: 'Delete',
            run_now: 'Run now',
            save_changes: 'Save Changes',
            create: 'Create Schedule',
          },
          section: {
            when: 'When',
            who: 'Who',
            what: 'What',
          },
          group_item: '{{name}} ({{count}} employees)',
        },
      },
      training_page: {
        sidebar_title: 'Training',
        page_helmet_title: 'Training',
        title: 'Training',
        groups_title: 'Groups by Risk',
        employees_title: 'Employees by Risk',
        group_column: 'Group',
        employee_column: 'Employee',
        email_column: 'Email',
        risk_score_column: 'Risk Score',
        risk_level_column: 'Risk Level',
        highest_risk_category_column: 'Highest Risk Category',
        employees_column: 'Employees',
        send_training: 'Send Training',
        no_category_data: 'No data',
        no_group_data: 'No groups with risk data yet',
        no_employee_data: 'No employees with risk data yet',
        schedule_modal_title: 'Schedule Training',
        schedule_modal_category_label: 'Category',
        schedule_modal_category_placeholder: 'Select a category',
        schedule_modal_video_label: 'Video',
        schedule_modal_video_placeholder: 'Random (auto-select)',
        schedule_modal_video_random: 'Random (auto-select)',
        schedule_modal_date_label: 'Date',
        schedule_modal_time_label: 'Time',
        schedule_modal_name_label: 'Name (optional)',
        schedule_modal_name_placeholder: 'e.g. Phishing Training Q1',
        schedule_modal_language_label: 'Language',
        schedule_modal_target_label: 'Target Audience',
        schedule_modal_target_all: 'All Employees',
        schedule_modal_target_groups: 'Specific Group',
        schedule_modal_target_employees: 'Specific Employees',
        schedule_modal_submit: 'Schedule Training',
        schedule_modal_cancel: 'Cancel',
        create_success: 'Training scheduled successfully',
        create_failed: 'Failed to schedule training',
        load_failed: 'Failed to load training data',
        history_title: 'Training History',
        history_name: 'Name',
        history_target: 'Target',
        history_category: 'Category',
        history_scheduled: 'Scheduled For',
        history_status: 'Status',
        history_completion: 'Completion',
        history_no_data: 'No training schedules yet',
        history_target_all: 'All Employees',
        history_target_group: 'Group: {{name}}',
        history_target_employees: '{{count}} employee(s)',
        group_completion: 'Training Completion',
        group_no_training: 'No training data',
        status_pending: 'Pending',
        status_processing: 'Processing',
        status_sent: 'Sent',
        status_completed: 'Completed',
        status_failed: 'Failed',
        status_cancelled: 'Cancelled',
      },
      common: {
        send: 'Send',
        yes: 'Yes',
        no: 'No',
        required: 'Required',
        cancel: 'Cancel',
        delete: 'Delete',
        ai_powered_badge: 'AI-powered',
        days: {
          monday: 'Monday',
          tuesday: 'Tuesday',
          wednesday: 'Wednesday',
          thursday: 'Thursday',
          friday: 'Friday',
          saturday: 'Saturday',
          sunday: 'Sunday',
        },
      },
      activation: {
        pending_title: 'Your account is pending activation',
        pending_body: 'A Ciphia operator will enable your workspace and reach out to you shortly.',
      },
      addons_page: {
        title_brand: 'Ciphia',
        title: 'Add-ons',
        subtitle: 'Premium services to take your security to the next level',
        services: {
          compliance: {
            title: 'Compliance',
            description:
              'Track your compliance readiness for SOC 2, ISO 27001, and GDPR with unified Core 40 controls.',
            features: [
              'SOC 2 Type I readiness',
              'ISO 27001 compliance tracking',
              'GDPR requirements checklist',
              'Evidence & documentation management',
            ],
          },
          phishing: {
            title: 'Simulations',
            description:
              'Custom phishing campaigns tailored to your organization to test and improve employee awareness.',
            features: [
              'Realistic email templates',
              'Detailed click & report analytics',
              'Employee risk scoring',
              'Customized to your industry',
            ],
          },
          pentesting: {
            title: 'Pentesting',
            description: 'Professional penetration testing by certified security experts to identify vulnerabilities.',
            features: [
              'Web application testing',
              'Network security assessment',
              'Detailed vulnerability report',
              'Remediation guidance',
            ],
          },
          training: {
            title: 'Training',
            description: 'Live training sessions with cybersecurity professionals tailored to your team.',
            features: ['Customized curriculum', 'Interactive workshops', 'Q&A sessions', 'Hands-on exercises'],
          },
        },
        active: 'Active',
        contact_sales: 'Contact Sales',
        go_to: 'Go to {{title}}',
      },
      phishing: {
        // Phishing messages
        load_failed: 'Failed to load phishing data',
        phishing_created: 'Phishing simulation created successfully',
        email_campaign_created: 'Email campaign created successfully',
        email_campaign_create_failed: 'Failed to create email campaign',

        // Delete campaign
        delete_title: 'Delete Simulation',
        delete_confirm: 'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
        delete_ok: 'Delete',
        delete_failed: 'Failed to delete campaign',
        deleted: 'Simulation deleted',

        // Archive campaign
        archive_title: 'Archive Simulation',
        archive_confirm: 'Are you sure you want to archive "{{name}}"? You can unarchive it later.',
        archive_ok: 'Archive',
        archive_failed: 'Failed to archive campaign',
        archived: 'Simulation archived',

        // Unarchive campaign
        unarchive_failed: 'Failed to unarchive campaign',
        unarchived: 'Simulation unarchived',

        // Finish campaign
        finish_title: 'Finish Simulation',
        finish_confirm: 'Are you sure you want to finish "{{name}}"? This will stop tracking any further interactions.',
        finish_ok: 'Finish Simulation',
        finish_failed: 'Failed to finish campaign',
        finished: 'Simulation finished',

        // Launch campaign
        launch_title: 'Launch Simulation',
        launch_confirm:
          'Are you sure you want to launch "{{name}}"? This will send phishing messages to {{count}} employees.',
        launch_confirm_qr:
          'Are you sure you want to launch "{{name}}"? This will activate the QR phishing landing page.',
        launch_ok: 'Launch',
        launch_failed: 'Failed to launch campaign',
        launched: 'Simulation launched successfully',
        complete_failed: 'Failed to complete campaign',
        completed: 'Campaign completed',

        // Domain verification
        domains_load_failed: 'Failed to load domains',
        domain_enter_required: 'Please enter a domain',
        domain_add_failed: 'Failed to add domain',
        domain_added: 'Domain added. Please add the TXT record to verify ownership.',
        domain_verify_failed: 'Verification failed',
        domain_verified: 'Domain verified successfully!',
        domain_verify_check_dns: 'Domain verification failed. Please check your DNS settings.',
        domain_delete_title: 'Delete Domain',
        domain_delete_confirm: 'Are you sure you want to delete "{{domain}}"?',
        domain_delete_failed: 'Failed to delete domain',
        domain_deleted: 'Domain deleted',
        copied_to_clipboard: '{{label}} copied to clipboard',

        // Custom templates
        template_button_required: 'Landing HTML must contain {{BUTTON}} placeholder',
        template_update_failed: 'Failed to update template',
        template_updated: 'Template updated',
        template_create_failed: 'Failed to create template',
        template_created: 'Template created',
        template_delete_failed: 'Failed to delete template',
        template_deleted: 'Template deleted',

        // Bot config / slug
        slug_min_length: 'Slug must be at least 3 characters',
        slug_update_failed: 'Failed to update slug',
        slug_updated: 'Company URL slug updated',

        // Modal messages
        campaign_name_required: 'Please enter a campaign name',
        image_only_error: 'You can only upload image files!',
        icon_uploaded: 'Icon uploaded successfully',
        favicon_uploaded: 'Favicon uploaded successfully',
        logo_uploaded: 'Logo uploaded successfully',
        landing_button_required: 'Landing page HTML must contain {{BUTTON}} placeholder',
      },
      phishing_ui: {
        sender_domain_label: 'Sender domain',
        sender_domain_hint:
          'Ciphia default works out of the box. Verify your own domain in Company Settings for a more realistic test.',
        // Page
        page_title: 'Simulations',
        page_description:
          'Phish your own team, safely. Launch email or QR campaigns, see who clicks, and turn every miss into a training moment.',

        // Tabs
        tab_email: 'Email',

        // Company Slug Section
        company_url_slug: 'Company URL Slug',
        slug_description: 'This slug appears in phishing URLs to make them look more legitimate (e.g., /t/',
        slug_placeholder: 'company-name',
        generate_from_company: 'Generate from company name',
        save: 'Save',
        slug_warning: 'Set a URL slug before launching simulations',

        // Domain Verification Section
        domain_verification_title: 'Domain Verification',
        domain_verification_description:
          'Verify domain ownership to ensure email deliverability for phishing simulations.',
        add_domain: 'Add Domain',
        domain_placeholder: 'example.com',
        domain_col: 'Domain',
        status_col: 'Status',
        txt_record_col: 'TXT Record',
        status_pending: 'Pending',
        status_verified: 'Verified',
        status_failed: 'Failed',
        verify_btn: 'Verify',
        dns_instructions_title: 'How to add TXT Record (DNS Instructions)',
        dns_instructions_description: 'To verify domain ownership, add a TXT record to your DNS configuration:',
        dns_general_instructions: 'General Instructions:',
        dns_name_host: 'Name/Host:',
        dns_type: 'Type:',
        dns_value: 'Value:',
        dns_ttl: 'TTL:',
        dns_propagation_note:
          'DNS changes may take up to 24-48 hours to propagate, though they often complete within minutes.',
        whitelist_title: 'Email Whitelist Instructions (Prevent Spam Filtering)',
        whitelist_warning_title: "Configure your email provider's whitelist",
        whitelist_warning_description:
          'Before launching email phishing campaigns, configure your email provider to allow emails from notifyinbox.com to reach employee inboxes.',

        // Simulations List
        simulations_title: 'Simulations',
        show_archived: 'Show archived',
        new_simulation: 'New Simulation',
        no_simulations: 'No simulations yet',
        create_first_simulation: 'Create Your First Simulation',
        no_archived_simulations: 'No archived simulations',
        col_simulation: 'Simulation',
        col_status: 'Status',
        col_targets: 'Targets',
        col_launched: 'Launched',
        col_created: 'Created',
        archived_tag: 'Archived',
        status_draft: 'Draft',
        status_scheduled: 'Scheduled',
        status_running: 'Running',
        status_completed: 'Completed',
        action_view_stats: 'View Stats',
        action_edit: 'Edit',
        action_launch: 'Launch',
        action_unarchive: 'Unarchive',
        action_delete: 'Delete',
        action_finish: 'Finish',
        action_archive: 'Archive',

        // Stats Modal
        phishing_statistics: 'Phishing Statistics',
        stat_total: 'Total',
        stat_sent: 'Sent',
        stat_clicked: 'Clicked',
        stat_fell: 'Fell',
        campaign_metrics: 'Campaign Metrics',
        click_rate: 'Click Rate',
        scan_rate: 'Scan Rate',
        medium_risk: 'Medium Risk',
        fell_rate: 'Fell Rate',
        high_risk: 'High Risk',
        template_label: 'Template:',
        variant_label: 'Variant:',
        launched_label: 'Launched:',
        not_launched: 'Not launched',
        status_label: 'Status:',
        target_details: 'Target Details',
        col_employee: 'Employee',
        col_sent: 'Sent',
        col_clicked: 'Clicked',
        col_outcome: 'Outcome',
        no_stats: 'No statistics available',
        status_pending_label: 'Pending',
        status_sent_label: 'Sent',
        status_clicked_label: 'Clicked',
        status_fell_label: 'Fell',

        // Stats Page
        stats_page_title: 'Simulation Statistics',
        back_to_phishing: 'Back to Phishing',
        launch_campaign: 'Launch Campaign',
        finish_campaign: 'Finish Campaign',
        archive: 'Archive',
        campaign_risk: 'Campaign Risk',
        total_targets: 'Total Targets',
        messages_sent: 'Messages Sent',
        clicked_link: 'Clicked Link',
        fell_for_phishing: 'Fell for Phishing',
        fell: 'Fell',
        qr_scans: 'QR Scans',
        risk_distribution: 'Risk Distribution',
        risk_rates: 'Risk Rates',
        users_clicked_link: 'Users who clicked the link',
        users_scanned_qr: 'Users who scanned the QR code',
        users_fell: 'Users who fell for phishing',
        campaign_details: 'Campaign Details',
        template: 'Template',
        variant: 'Variant',
        launched: 'Launched',
        target_results: 'Target Results',
        filter_all: 'All',
        filter_high: 'High',
        filter_medium: 'Medium',
        filter_low: 'Low',
        no_targets_filter: 'No targets found for selected filter',
        campaign_not_found: 'Campaign not found or no statistics available',
        finish_confirm_stats:
          'Are you sure you want to finish this campaign? This will stop tracking any further interactions.',
        launch_confirm_stats:
          'Are you sure you want to launch this campaign? This will send phishing messages to {{count}} employees.',
        archive_confirm_stats: 'Are you sure you want to archive this campaign? You can unarchive it later.',
        finish_success: 'Campaign finished successfully',

        // Campaign Modal
        create_campaign: 'Create Campaign',
        schedule_campaign: 'Schedule Campaign',
        edit_campaign: 'Edit Campaign',
        step_template: 'Template',
        step_targets: 'Targets',
        step_review: 'Review',
        cancel: 'Cancel',
        back: 'Back',
        next: 'Next',
        schedule_date: 'Schedule for',
        schedule_placeholder: 'Leave empty to launch manually',
        campaign_name: 'Campaign Name',
        campaign_name_placeholder: 'e.g., Q1 2025 Security Test',
        template_type: 'Template Type',
        core_templates: 'Core Templates',
        custom_templates: 'Custom Templates',
        select_template: 'Select Template',
        select_variant: 'Select Variant',
        select_custom_template: 'Select Custom Template',
        no_custom_templates: 'No custom templates yet',
        create_custom_template: 'Create Custom Template',
        manage_custom_templates: 'Manage Custom Templates',
        landing_tag: '+ Landing',

        // Target Step
        target_selection: 'Target Selection',
        all_employees: 'All Employees',
        specific_group: 'Specific Group',
        specific_groups: 'Specific Groups',
        specific_employees: 'Specific Employees',
        select_group: 'Select Group',
        select_groups: 'Select Groups',
        select_employees: 'Select Employees',
        search_employees: 'Search and select employees',
        employees_targeted: '{{count}} employee(s) will be targeted',

        // Review Step
        campaign_summary: 'Campaign Summary',
        channel_label: 'Channel:',
        template_name_label: 'Template:',
        variant_name_label: 'Variant:',
        bot_name_label: 'Bot Name:',
        targets_label: 'Targets:',
        employees_count: '{{count}} employees',
        landing_page_label: 'Landing Page:',
        yes: 'Yes',
        no: 'No',

        // Bot Appearance
        bot_appearance: 'Bot Appearance',
        bot_name: 'Bot Name',
        bot_name_placeholder: 'e.g., Security Alert',
        bot_icon: 'Bot Icon (optional)',
        upload_icon: 'Upload Icon',

        // Landing Page
        landing_page_config: 'Landing Page Configuration',
        language: 'Language',
        page_title_label: 'Page Title',
        page_title_placeholder: 'Login',
        favicon_label: 'Favicon (optional)',
        upload_favicon: 'Upload Favicon',
        logo_label: 'Logo (optional)',
        upload_logo: 'Upload Logo',

        // Email Campaign Modal
        create_email_simulation: 'Create Email Simulation',
        edit_email_simulation: 'Edit Email Simulation',
        select_email_template: 'Select Email Template',
        select_template_placeholder: 'Select a template',
        sender_email_address: 'Sender Email Address',
        sender_suggestions: 'Suggested: security, it-support, helpdesk, admin',
        sender_display_name: 'Sender Display Name',
        sender_display_hint: 'This name appears in the "From" field:',
        email_subject: 'Email Subject',
        email_subject_placeholder: 'Action Required: Password Reset',
        email_language: 'Email Language',
        email_language_hint: 'Language for the phishing email content',
        select_recipients: 'Select Target Recipients',
        all_employees_count: 'All Employees ({{count}})',
        select_group_option: 'Select Group',
        select_groups_option: 'Select Groups',
        select_employees_option: 'Select Individual Employees',
        employees_receive_email: '{{count}} employee(s) will receive the phishing email',
        channel: 'Channel',
        from_label: 'From:',
        subject_label: 'Subject:',
        recipients_label: 'Recipients:',
        email_preview: 'Email Preview',
        save_changes: 'Save Changes',

        // QR Phishing
        tab_qr: 'QR Code',
        qr_description:
          'Create QR code phishing simulations. Print and distribute QR codes to test employee awareness.',
        create_qr_simulation: 'Create QR Simulation',
        edit_qr_simulation: 'Edit QR Simulation',
        qr_codes_title: 'QR Codes',
        qr_codes_description:
          'Download and print QR codes for distribution. Each employee receives a unique tracking QR code.',
        download_all_qr: 'Download All QR Codes',
        download_qr: 'Download QR',
        qr_code_for: 'QR Code for {{name}}',
        no_qr_codes: 'No QR codes generated yet',
        qr_codes_ready: 'QR codes are ready for download',
        qr_campaign_info:
          'QR campaigns generate a single company-wide QR code. Anyone who scans it will see a phishing landing page where they enter their email.',
        print_qr_codes: 'Print QR Codes',
        qr_generated: '{{count}} QR code(s) generated',
        view_qr_codes: 'View QR Codes',
        // Company-wide QR
        qr_company_wide_title: 'Company-Wide QR',
        qr_company_wide_description:
          "This QR code will work for anyone who scans it. When launched, you'll get a single QR image to download and print/share. Users who scan it will see a phishing page that asks for their email.",
        landing_page_title_optional: 'Landing Page Title (optional)',
        qr_landing_title_help: 'Custom title shown on the landing page. If empty, a default will be used.',
        qr_logo_optional: 'Company Logo (optional)',
        qr_logo_help: 'Logo shown at the top of the landing page. Max 2MB.',
        qr_stats_block_title: 'QR Code',
        qr_stats_scan_hint: 'Scan or share this code. Every scan is recorded below.',
        qr_copy_url: 'Copy scan URL',
        qr_url_copied: 'URL copied to clipboard',
        qr_copy_url_failed: 'Failed to copy URL',
        section: {
          campaign: 'Campaign',
          landing_optional: 'Landing page (optional)',
        },

        // Phase 109 — AI phishing admin preview namespace.
        // Plan 07 performs the full localization pass; this scaffold uses
        // UI-SPEC Copywriting Contract strings verbatim so plans 03-06 can
        // reference `t('phishing_ui.ai.*')` without runtime errors.
        ai: {
          // Tab & section labels
          tab_preview: 'Preview',
          iframe_title: 'Phishing email preview',

          // Mode toggle (UI-01)
          mode_question: 'How should emails be generated?',
          mode_template: 'Template',
          mode_template_helper: 'Send the same template to everyone',
          mode_ai: 'AI Powered',
          mode_ai_helper: 'Personalize every email per employee',

          // Eligibility (UI-02)
          eligibility_chip_eligible: 'Atlas',
          eligibility_chip_ineligible: 'No Atlas',
          eligibility_tooltip_ineligible:
            '{{name}} has no manager or collaborators in Atlas — will receive the fallback template instead',
          eligibility_counter: '{{n}} of {{total}} employees eligible for AI',
          eligibility_error:
            "Couldn't load eligibility. You can continue without it; ineligible employees will get the fallback template.",

          // Header counters (D-04)
          progress_counter: '{{processed}} of {{total}} processed',
          review_counter: '{{count}} need human review',
          status_processing: 'Processing in progress…',
          launch_tooltip_disabled: 'Processing in progress — try again in a moment',

          // Admin-edited marker (PREV-07)
          admin_edited: 'Admin edited',
          admin_edited_banner_absolute: 'Edited by admin on {{date}}',

          // Verdict tooltips (UI-04)
          verdict_tone_match: 'Tone match',
          verdict_leak_risk: 'Leak risk',
          verdict_injection_risk: 'Injection risk',
          verdict_language_consistency: 'Language consistency',
          verdict_personalization_overfit: 'Personalization overfit',
          verdict_quality_issues: 'Quality notes',
          verdict_value_aligned: 'aligned',
          verdict_value_mismatch: 'mismatch',
          verdict_value_none: 'none',
          verdict_value_low: 'low',
          verdict_value_medium: 'medium',
          verdict_value_high: 'high',
          verdict_value_consistent: 'consistent',
          verdict_value_inconsistent: 'inconsistent',

          // Status icons
          status_ready: 'Ready',
          status_needs_review: 'Needs review',
          status_failed: 'Failed',
          status_fallback: 'Fallback template',
          status_generating: 'Generating…',
          status_paused: 'Paused',
          status_sent: 'Sent',
          status_clicked: 'Clicked',
          status_fell: 'Fell for it',

          // Actions
          action_regenerate: 'Regenerate',
          action_mark_ready: 'Mark ready',
          action_edit: 'Edit',
          action_save_approve: 'Save & approve',
          action_cancel_edit: 'Cancel edit',
          action_close: 'Close',
          action_launch: 'Launch campaign',
          action_regenerate_all_flagged: 'Regenerate all flagged',
          action_open_details: 'Open details',
          action_complete: 'Complete campaign',
          action_cancel_complete: 'Keep running',
          complete_confirm_title: 'Complete this campaign?',
          complete_confirm_body:
            'No further events (sent / clicked / fell) will be recorded after this. The campaign will move to Completed and cannot be reopened.',

          // Form labels (edit mode)
          subject_label: 'Subject',
          body_label: 'Body (HTML)',
          live_preview: 'Live preview',

          // Empty states
          empty_pending: 'Generation will begin shortly. Targets will appear here as they are processed.',
          empty_no_eligible:
            'No targets are eligible for AI generation. Cancel this campaign and try again with employees who have Atlas relationships.',
          empty_eligibility_none:
            'None of the selected employees are eligible for AI — consider switching to Template mode or selecting different employees.',

          // Error toasts
          error_regenerate: "Couldn't regenerate — check connection and try again",
          error_edit_save: "Couldn't save — your changes are still in the editor",
          error_mark_ready: "Couldn't mark as ready — try again in a moment",
          error_polling_lost: 'Lost connection to the preview. Refresh to reconnect.',

          // Destructive confirmations (D-03)
          launch_confirm_title: 'Launch campaign?',
          launch_confirm_body: '{{flagged}} flagged emails will be skipped. Launch {{approved}} approved emails?',
          regenerate_bulk_confirm_body: 'Regenerate {{count}} flagged emails? Their current content will be discarded.',
          cancel_edit_confirm: 'Discard your edits?',

          // Skipped_no_atlas fallback copy
          skipped_no_atlas_explanation:
            'This target has no Atlas relationships and will receive the fallback template: {{templateName}}',

          // Fallback template selector (UI-01 AI mode)
          fallback_template_label: 'Fallback template for non-eligible employees',

          // Spanish dialect register (Phase 110 — only shown when language === 'es' in AI mode)
          spanish_variant_label: 'Spanish dialect',
          spanish_variant_neutral: 'Neutral (pan-Hispanic, "tú")',
          spanish_variant_rioplatense: 'Rioplatense (AR/UY, "vos")',
          spanish_variant_hint:
            'Pick the register the AI should write in. Neutral fits general Latin-American + Spain audiences; Rioplatense is Argentine/Uruguayan voseo.',

          // Pause / resume AI generation (Phase 110)
          action_pause: 'Pause generation',
          action_resume: 'Resume generation',
          pause_success: 'AI generation paused. In-flight targets will finish; no new pickups.',
          resume_success: 'AI generation resumed.',
          pause_error: 'Could not pause generation.',
          resume_error: 'Could not resume generation.',

          // Simplified pass/fail verdict (Phase 110 polish)
          verdict_pass: 'Passes',
          verdict_fail: 'Fails',
          verdict_pending: 'Pending',
          verdict_card_title: 'Verification',
          action_back: 'Back',

          // Flagged review banner (detail modal)
          flagged_review_banner: 'This email was flagged — review before approving',

          // Preview table column headers (PREV-01) — dedicated to ai namespace
          // so the existing phishing_ui.col_* keys keep their Stats-tab semantics.
          col_employee: 'Employee',
          col_subject: 'Subject',
          col_sender: 'Sender',
          col_template: 'Template',
          col_verdict: 'Verification',
          col_status: 'Status',
          col_actions: 'Actions',

          // Toolbar + header counters (wired from AiPhishingPreviewTab)
          bulk_regenerate_flagged: 'Regenerate all flagged',

          // Phase 110 D-01/D-03 — derived lifecycle vocabulary (6 AI-mode states).
          // Source of truth for badge / subtitle / button copy. Mirrored 1:1 in ES.
          lifecycle_not_started: 'Not started',
          lifecycle_generating: 'Generating content',
          lifecycle_in_review: 'Pending review',
          lifecycle_ready: 'Ready to launch',
          lifecycle_started: 'Running',
          lifecycle_finished: 'Finished',

          // Phase 110 D-05 — editable scheduledAt (PATCH endpoint + DatePicker).
          scheduled_at_editable_label: 'Scheduled start',
          scheduled_at_save: 'Save',
          scheduled_at_min_hint: 'Must be at least 1 minute from now',
          scheduled_at_error_started: 'Cannot reschedule: campaign is already running',
          scheduled_at_error_finished: 'Cannot reschedule: campaign is finished',
        },
      },
      contact_modal: {
        // Enterprise/Sales
        enterprise_title: 'Contact Sales',
        enterprise_description: 'Interested in our Enterprise plan? Our team will get back to you within 24 hours.',
        enterprise_success: 'Thank you! Our sales team will contact you shortly.',
        enterprise_placeholder: 'Tell us about your security training needs...',
        // Support
        support_title: 'Get Support',
        support_description: 'Having an issue? Describe your problem and our support team will help you.',
        support_success: "Support request submitted. We'll get back to you soon.",
        support_placeholder: 'Describe your issue...',
        // Feedback
        feedback_title: 'Send Feedback',
        feedback_description: "We'd love to hear from you! Share your thoughts, suggestions, or ideas.",
        feedback_success: 'Thank you for your feedback!',
        feedback_placeholder: 'Share your feedback...',
        // Contact
        contact_title: 'Contact Us',
        contact_description: "Have a question? We'd love to hear from you.",
        contact_success: "Thank you! We'll get back to you soon.",
        contact_placeholder: 'Your message...',
        // Addon
        addon_title: 'Request Add-on Service',
        addon_description: 'Interested in this premium service? Our team will contact you to discuss your needs.',
        addon_success: 'Thank you! Our team will contact you shortly.',
        addon_placeholder: 'Tell us about your needs...',
        // Partner
        partner_title: 'Partnership Inquiry',
        partner_description:
          'Interested in partnering with Ciphia? Tell us about your organization and partnership ideas.',
        partner_success: 'Thank you! Our partnerships team will contact you shortly.',
        partner_placeholder: 'Tell us about your partnership ideas...',
        // Sample Report
        sample_report_title: 'Get a Sample Report',
        sample_report_description:
          "See what a Human Risk Assessment looks like. Enter your email and we'll send you an example report.",
        sample_report_success: 'Thank you! Check your inbox for the sample report.',
        sample_report_placeholder: "Any specific areas you'd like to see covered?",
        // Form fields
        form_email: 'Email',
        form_emailRequired: 'Please enter your email',
        form_emailInvalid: 'Please enter a valid email',
        form_name: 'Name (optional)',
        form_namePlaceholder: 'Your name',
        form_message: 'Message',
        form_submit: 'Submit',
        form_error: 'Failed to submit. Please try again.',
        form_companyName: 'Company Name',
        form_companyNameRequired: 'Please enter your company name',
        form_companyNamePlaceholder: 'Your company',
        form_employeeCount: 'Number of Employees',
        form_employeeCountRequired: 'Please enter the number of employees',
        form_employeeCountPlaceholder: 'e.g. 50',
        // Add-on service names
        addonService_pentesting: 'Pentesting',
        addonService_training: 'Expert Training',
        addonService_compliance: 'Compliance Certification',
      },
      admin_campaigns: {
        // Campaign edit/create
        load_failed: 'Failed to load discovery',
        logo_image_only: 'You can only upload image files!',
        logo_uploaded: 'Logo uploaded successfully',
        logo_upload_failed: 'Failed to upload logo',
        name_required: 'Discovery name is required',
        company_name_required: 'External company name is required',
        contact_email_required: 'Contact email is required',
        create_failed: 'Failed to create discovery',
        created: 'Discovery created successfully',
        update_failed: 'Failed to update discovery',
        saved: 'Discovery saved successfully',
        user_add_failed: 'Failed to add user',
        user_added: 'User added',
        user_remove_failed: 'Failed to remove user',
        user_removed: 'User removed',
        import_failed: 'Failed to import users',
        import_success: 'Imported {{created}} users, {{skipped}} skipped',
        user_already_exists: 'This email is already added.',
        link_generate_failed: 'Failed to generate link',
        link_generated: 'Public link generated and copied to clipboard',
        link_disable_failed: 'Failed to disable link',
        link_disabled: 'Public link disabled',
        link_copied: 'Link copied to clipboard',
        start_title: 'Start Discovery',
        start_confirm:
          "Are you sure you want to start this discovery? Once started, you won't be able to edit it or add more users. The scenario and email phishing will be launched according to their scheduled dates.",
        start_confirm_users:
          'Are you sure you want to start "{{name}}"? Scenarios and phishing emails will be sent at their scheduled times to {{count}} users.',
        start_ok: 'Start',
        start_failed: 'Failed to start discovery',
        started: 'Discovery started successfully',
        complete_title: 'Complete Discovery',
        complete_confirm: 'Are you sure you want to mark this discovery as completed?',
        complete_confirm_name: 'Are you sure you want to mark "{{name}}" as completed?',
        complete_ok: 'Complete',
        complete_failed: 'Failed to complete discovery',
        completed: 'Discovery completed',
        archive_title: 'Archive Discovery',
        archive_confirm:
          'Are you sure you want to archive "{{name}}"? The discovery will be hidden from the list but data will be preserved.',
        archive_ok: 'Archive',
        archive_failed: 'Failed to archive discovery',
        archived: 'Discovery archived',
        custom_template_created: 'Custom template created successfully',
        create_template_failed: 'Failed to create template',
        general_logo_uploaded: 'Logo uploaded',
        general_logo_upload_failed: 'Failed to upload logo',
        no_valid_users: 'No valid users to import',
      },
      // Alias for admin_discoveries namespace (code uses admin_discoveries.*)
      admin_discoveries: {
        load_failed: 'Failed to load discovery',
        logo_image_only: 'You can only upload image files!',
        logo_uploaded: 'Logo uploaded successfully',
        logo_upload_failed: 'Failed to upload logo',
        name_required: 'Discovery name is required',
        company_name_required: 'External company name is required',
        contact_email_required: 'Contact email is required',
        create_failed: 'Failed to create discovery',
        created: 'Discovery created successfully',
        update_failed: 'Failed to update discovery',
        saved: 'Discovery saved successfully',
        user_add_failed: 'Failed to add user',
        user_added: 'User added',
        user_remove_failed: 'Failed to remove user',
        user_removed: 'User removed',
        user_already_exists: 'This email is already added.',
        import_failed: 'Failed to import users',
        import_success: 'Imported {{created}} users, {{skipped}} skipped',
        link_generate_failed: 'Failed to generate link',
        link_generated: 'Public link generated and copied to clipboard',
        link_disable_failed: 'Failed to disable link',
        link_disabled: 'Public link disabled',
        link_copied: 'Link copied to clipboard',
        start_title: 'Start Discovery',
        start_confirm:
          "Are you sure you want to start this discovery? Once started, you won't be able to edit it or add more users.",
        start_confirm_users:
          'Are you sure you want to start "{{name}}"? Scenarios and phishing emails will be sent at their scheduled times to {{count}} users.',
        start_ok: 'Start',
        start_failed: 'Failed to start discovery',
        started: 'Discovery started successfully',
        complete_title: 'Complete Discovery',
        complete_confirm: 'Are you sure you want to mark this discovery as completed?',
        complete_confirm_name: 'Are you sure you want to mark "{{name}}" as completed?',
        complete_ok: 'Complete',
        complete_failed: 'Failed to complete discovery',
        completed: 'Discovery completed',
        archive_title: 'Archive Discovery',
        archive_confirm:
          'Are you sure you want to archive "{{name}}"? The discovery will be hidden from the list but data will be preserved.',
        archive_ok: 'Archive',
        archive_failed: 'Failed to archive discovery',
        archived: 'Discovery archived',
        custom_template_created: 'Custom template created successfully',
        create_template_failed: 'Failed to create template',
        general_logo_uploaded: 'Logo uploaded',
        general_logo_upload_failed: 'Failed to upload logo',
        no_valid_users: 'No valid users to import',
      },
      group_manager: {
        load_failed: 'Failed to load groups',
        create_success: 'Group created',
        create_failed: 'Failed to create group',
        update_success: 'Group updated',
        update_failed: 'Failed to update group',
        delete_success: 'Group deleted',
        delete_failed: 'Failed to delete group',
        delete_title: 'Delete Group',
        delete_confirm: 'Delete "{{name}}"?',
        delete_ok: 'Delete',
        default_cannot_delete: 'Default groups cannot be deleted',
        has_employees: 'Cannot delete a group with employees',
        unexpected_error: 'An unexpected error occurred',
      },
      admin_management: {
        title: 'Administrators ({{count}})',
        invite_admin: 'Invite Admin',
        no_admins: 'No admins found',
        load_failed: 'Failed to load admins',
        load_error: 'An unexpected error occurred while loading admins',
        promote_title: 'Promote to Manager Admin',
        promote_confirm: 'Are you sure you want to promote {{name}} to Manager Admin?',
        promote_note: 'They will be able to manage other admins.',
        promote_ok: 'Promote',
        promote_failed: 'Failed to promote admin',
        promote_success: '{{name}} has been promoted to Manager Admin',
        demote_title: 'Demote to Admin',
        demote_confirm: 'Are you sure you want to demote {{name}} to regular Admin?',
        demote_note: 'They will lose admin management privileges.',
        demote_ok: 'Demote',
        demote_failed: 'Failed to demote admin',
        demote_success: '{{name}} has been demoted to Admin',
        remove_title: 'Remove Admin Access',
        remove_confirm: 'Are you sure you want to remove admin access for {{name}}?',
        remove_note: 'They will no longer be able to access admin features.',
        remove_ok: 'Remove',
        remove_failed: 'Failed to remove admin',
        remove_success: 'Admin access removed for {{name}}',
        invite_failed: 'Failed to send invitation',
        invite_success: 'Invitation sent to {{email}}',
        unexpected_error: 'An unexpected error occurred',
        col_name: 'Name',
        col_email: 'Email',
        col_role: 'Role',
        col_actions: 'Actions',
      },
      compliance: {
        load_failed: 'Failed to load compliance data',
        status_updated: 'Status updated',
        status_update_failed: 'Failed to update status',
        note_added: 'Note added',
        note_add_failed: 'Failed to add note',
      },
      compliance_wizard: {
        load_failed: 'Failed to load wizard questions',
        submit_success: 'Assessment completed!',
        submit_failed: 'Failed to submit assessment',
        back_to_compliance: 'Back to Compliance',
        title: 'Compliance Assessment',
        subtitle: 'Answer the following questions to assess your readiness for SOC 2, ISO 27001, and GDPR',
        question_of: 'Question {{current}} of {{total}}',
        saving: 'Saving...',
        complete: '% Complete',
        answer_yes: 'Yes',
        answer_partial: 'Partially',
        answer_no: 'No',
        desc_yes: 'Fully implemented',
        desc_partial: 'Partially implemented',
        desc_no: 'Not implemented',
        add_notes_evidence: 'Add notes or evidence (optional)',
        note: 'Note',
        note_placeholder: 'Add any relevant notes about this control...',
        evidence: 'Evidence',
        evidence_desc_placeholder: "Describe the evidence (e.g., 'Security policy document')",
        evidence_url_placeholder: 'Link to evidence (optional, e.g., Google Drive URL)',
        collapse: 'Collapse',
        previous: 'Previous',
        next: 'Next',
        submit_assessment: 'Submit Assessment',
        items: '{{count}} items',
        item: '1 item',
        questions_remaining: '{{count}} questions remaining',
        complete_title: 'Assessment Complete!',
        complete_subtitle:
          'Your compliance assessment has been saved. View your dashboard to see your progress across all frameworks.',
        view_dashboard: 'View Dashboard',
        all_assessed: 'All controls have been assessed!',
        all_assessed_subtitle: "You've already completed the compliance wizard.",
        go_to_dashboard: 'Go to Dashboard',
      },
      legal: {
        pdf_error: 'Error generating PDF. Please try again.',
      },
      email_collection: {
        add_user_required: 'Please add at least one user with name and email',
      },
      campaign_stats: {
        load_failed: 'Failed to load campaign statistics',
        unexpected_error: 'An unexpected error occurred',
        finish_confirm:
          'Are you sure you want to finish this campaign? This will stop tracking any further interactions.',
        finish_success: 'Campaign completed successfully',
        launch_confirm:
          'Are you sure you want to launch this campaign? This will send phishing messages to {{count}} employees.',
        archive_confirm:
          'Are you sure you want to archive this campaign? You can unarchive it later from the campaigns list.',
      },
      diagnostic_analytics: {
        load_failed: 'Failed to load diagnostic analytics',
        results_load_failed: 'Failed to load diagnostic results',
        export_failed: 'Failed to export data',
        export_success: 'Data exported successfully',
      },
      csv_import: {
        validation_failed: 'File validation failed',
        parse_failed: 'Failed to parse CSV',
        read_failed: 'Failed to read file',
        import_failed: 'Failed to import employees',
      },
      // Diagnostic Insights Modal
      diagnostic_insights: {
        category_breakdown: 'Risk by category',
        title: 'Scenario Insights',
        analyzing: 'Analyzing Results',
        analyzing_desc: 'This may take a moment as we process the assessment data...',
        no_insights: 'No insights available',
        completion_rate: 'Completion Rate',
        participation: 'Participation',
        avg_risk_score: 'Avg Risk Score',
        summary: 'Summary',
        no_summary: 'No summary available',
        areas_to_improve: 'Areas to Improve',
        strengths: 'Strengths',
        total_participants: 'Total Participants',
        completed: 'Completed',
        in_progress: 'In Progress',
        not_started: 'Not Started',
        high_risk: 'High Risk',
        medium_risk: 'Medium Risk',
        low_risk: 'Low Risk',
        employees: 'employees',
        no_completed_yet: 'No completed assessments yet',
        risk_not_available: 'Risk distribution not available',
      },
      // Risk Level tags
      risk_level: {
        high: 'High',
        medium: 'Medium',
        low: 'Low',
        not_assessed: 'Not Assessed',
      },
      // Avatar menu
      avatar_menu: {
        support: 'Support',
        feedback: 'Feedback',
        contact: 'Contact',
        language: 'Language',
      },
      // Compliance page
      compliance_page: {
        title: 'Compliance',
        dashboard: 'Dashboard',
        checklist: 'Checklist',
        status_done: 'Done',
        status_partial: 'Partial',
        status_pending: 'Pending',
        status_not_assessed: 'Not Assessed',
        risk_level: 'Risk Level',
        risk_high: 'High',
        risk_medium: 'Medium',
        risk_low: 'Low',
        overall_compliance: 'Overall Compliance',
        controls_assessed: 'Controls Assessed',
        high_risk_count: 'High Risk',
        filter_all: 'All',
        filter_compliant: 'Done',
        filter_partial: 'Partial',
        filter_non_compliant: 'Pending',
        filter_not_assessed: 'Not Assessed',
        no_controls: 'No controls found',
        add_evidence: 'Add Evidence',
        add_note: 'Add Note',
        evidence_description: 'Description',
        evidence_url: 'URL',
        evidence_url_optional: 'URL (optional)',
        evidence_placeholder: 'Describe the evidence...',
        url_placeholder: 'https://drive.google.com/...',
        example: 'Example:',
        note_placeholder: 'Enter your note...',
        note_add_placeholder: 'Add a note...',
        save: 'Save',
        cancel: 'Cancel',
        view_details: 'View Details',
        mark_as: 'Mark as',
        framework: 'Framework',
        category: 'Category',
        control: 'Control',
        description: 'Description',
        description_text:
          'Track your compliance readiness for SOC 2, ISO 27001, and GDPR with unified Core 40 controls',
        status: 'Status',
        actions: 'Actions',
        evidence: 'Evidence',
        notes: 'Notes',
        no_evidence: 'No evidence added',
        no_notes: 'No notes added',
        start_wizard: 'Start Wizard',
        compliance_score: 'Compliance Score',
        controls: 'controls',
        of: 'of',
        assessed: 'assessed',
        assessment: 'Assessment',
        resume_assessment: 'Resume Assessment',
        start_assessment: 'Start Assessment',
        loading: 'Loading compliance data...',
        compliance_label: 'COMPLIANCE',
        compliant_label: 'COMPLIANT',
        partial_label: 'PARTIAL',
        pending_label: 'PENDING',
        docs: 'Docs',
        progress_by_category: 'Progress by Category',
        chat_with_assistant: 'Chat with Assistant',
        human_risk_title: 'Compliance for Human Risk',
        human_risk_toggle: 'Human Risk Controls Only',
        human_risk_stats_label: 'HUMAN RISK',
        human_risk_description: 'Controls related to employee security awareness and behavior',
        all_controls: 'All Controls',
      },
      // Compliance chat
      compliance_chat: {
        title: 'Compliance Assistant',
        greeting: `Hello **{{name}}**
I'm your Compliance Assistant. I can help you understand compliance frameworks like SOC 2, ISO 27001, and GDPR.

Ask me about specific controls, best practices, or how to implement compliance measures in your organization.

**How can I help you today?**`,
      },
      // Interview chat UI
      interview: {
        header: 'Interview',
        title: 'Security Interview',
        type_message: 'Type your answer...',
        send: 'Send',
        thinking: 'Thinking...',
        progress: 'Question {{current}} of {{total}}',
        wrapping_up: 'Wrapping up',
        completed_title: 'Interview Complete',
        completed_message:
          "Thank you for completing this interview. Your input is very valuable for improving the organization's security.",
        error_generic: 'Something went wrong. Please try again.',
        error_too_fast: 'Please wait for the previous response before sending another message.',
        error_expired: 'This interview link has expired or is invalid.',
        error_already_complete: 'This interview has already been completed.',
        avatar_you: 'You',
      },
      // Admin discoveries - columns and labels
      admin_discoveries_ui: {
        title: 'Discovery',
        legend:
          "Run full security assessments combining scenarios, phishing simulations, and process analysis in a single discovery. Get a comprehensive view of your organization's security posture.",
        create: 'Create Discovery',
        col_name: 'Name',
        col_external_company: 'External Company',
        col_contact: 'Contact',
        col_status: 'Status',
        col_users: 'Users',
        col_scenario: 'Scenario',
        col_email_template: 'Email Template',
        col_paid: 'Paid',
        col_actions: 'Actions',
        status_not_started: 'Not Started',
        status_in_progress: 'In Progress',
        status_completed: 'Completed',
        not_selected: 'Not Selected',
        yes: 'Yes',
        no: 'No',
        tooltip_view: 'View Details',
        tooltip_edit: 'Edit',
        tooltip_start: 'Start Discovery',
        tooltip_complete: 'Complete Discovery',
        tooltip_archive: 'Archive',
        filter_all: 'All Status',
        // Detail page
        detail_title: 'Discovery Details',
        detail_subtitle: 'Details',
        back: 'Back',
        edit: 'Edit',
        start_campaign: 'Start Discovery',
        complete_campaign: 'Complete Discovery',
        campaign_details: 'Discovery Details',
        discovery_details: 'Discovery Details',
        external_company: 'External Company',
        contact_email: 'Contact Email',
        language: 'Language',
        language_spanish: 'Spanish',
        language_english: 'English',
        paid: 'Paid',
        scenario: 'Scenario',
        created: 'Created',
        launched: 'Launched',
        completed: 'Completed',
        internal_notes: 'Internal Notes',
        email_phishing: 'Email Phishing',
        email_template: 'Email Template',
        target_departments: 'Target Departments',
        all_departments: 'All Departments',
        scheduled: 'Scheduled',
        not_scheduled: 'Not scheduled',
        public_link: 'Public Link',
        copy_link: 'Copy link',
        share_link_desc: 'Share this link to collect participant emails',
        disable_link: 'Disable Link',
        generate_link_desc: 'Generate a public link to collect participant emails',
        generate_public_link: 'Generate Public Link',
        statistics: 'Statistics',
        total_users: 'Total Users',
        scenario_progress: 'Scenario Progress',
        finished: 'Finished',
        in_progress: 'In Progress',
        pending: 'Pending',
        average_risk_score: 'Average Risk Score',
        email_phishing_progress: 'Email Phishing Progress',
        fell: 'Fell',
        clicked: 'Clicked',
        sent: 'Sent',
        by_department: 'By Department',
        participants: 'Participants',
        add_user: 'Add User',
        import_csv: 'Import CSV',
        overview: 'Overview',
        users: 'Users',
        scenario_results: 'Scenario Results',
        phishing_results: 'Phishing Results',
        // Table columns
        name: 'Name',
        email: 'Email',
        department: 'Department',
        source: 'Source',
        scenario_status: 'Scenario Status',
        phishing_status: 'Phishing Status',
        actions: 'Actions',
        risk: 'Risk',
        remove_user: 'Remove user?',
        remove: 'Remove',
        cancel: 'Cancel',
        discovery_not_found: 'Discovery not found',
        campaign_not_found: 'Campaign not found',
        // Alerts
        alert_configure_email: 'Configure email template in Edit to enable phishing',
        alert_set_launch_date: 'Set a launch date in Edit to schedule phishing',
        alert_will_launch: 'Email phishing will launch automatically at the scheduled time',
        alert_launched: 'Email phishing has been launched',
        // Blocked reasons
        blocked_no_users: 'Add at least one user to start the discovery',
        blocked_no_config: 'Select a scenario or email template to start the discovery',
        blocked_no_scenario_date: 'Set a scenario launch date before starting the discovery',
        blocked_no_email_date: 'Set an email phishing launch date before starting the discovery',
        // Form
        full_name: 'Full name',
        please_enter_name: 'Please enter name',
        please_enter_email: 'Please enter email',
        please_enter_valid_email: 'Please enter a valid email',
        department_optional: 'Department (optional)',
        // Edit page
        create_title: 'New',
        edit_title: 'Edit',
        save: 'Save',
        saving: 'Saving...',
        basic_info: 'Basic Information',
        campaign_name: 'Discovery Name',
        campaign_name_placeholder: 'Enter discovery name',
        external_company_name: 'External Company Name',
        external_company_placeholder: 'Client company name',
        contact_email_placeholder: 'client@company.com',
        select_language: 'Select language',
        mark_paid: 'Mark as Paid',
        internal_notes_placeholder: 'Notes visible only to admins...',
        scenario_config: 'Scenario Configuration',
        select_scenario: 'Select Scenario',
        no_scenario: 'No scenario (skip)',
        scenario_launch_date: 'Scenario Launch Date',
        email_phishing_config: 'Email Phishing Configuration',
        select_email_template: 'Select Email Template',
        no_email_template: 'No email template (skip)',
        email_launch_date: 'Email Launch Date',
        select_departments: 'Select Departments',
        all_users: 'All users',
        // Edit page alerts
        alert_in_progress_edit: 'This discovery is in progress and cannot be edited.',
        alert_completed_edit: 'This discovery is completed and cannot be edited.',
        alert_unsaved_changes: 'You have unsaved changes',
        // Domain verification
        domain_verification: 'Domain Verification (Optional)',
        domain_verification_optional: 'Domain verification is optional for discoveries',
        domain_verification_desc:
          'If you want to send emails from a custom domain instead of notifyinbox.com, you can verify your domain here. This is the same configuration used across all discoveries.',
        // Import modal
        import_title: 'Import Users from CSV',
        import_download_template: 'Download Template',
        import_users: 'Import {{count}} Users',
        import_csv_format: 'CSV Format',
        import_csv_desc:
          'CSV file should have columns: name, email, department (optional). First row can be header or data.',
        import_valid_departments: 'Valid departments',
        import_drag_text: 'Click or drag CSV file to upload',
        import_drag_hint: 'Support for single CSV file',
        import_valid_users: 'valid users',
        import_invalid_rows: 'invalid rows',
        import_file_empty: 'File is empty',
        import_invalid_row: 'Invalid row format',
        import_missing_name: 'Missing name',
        import_invalid_email: 'Invalid email',
        import_no_valid_users: 'No valid users found in the file',
        import_parse_failed: 'Failed to parse CSV file',
        import_read_failed: 'Failed to read file',
        import_valid: 'Valid',
        // List page
        filter_by_status: 'Filter by status',
        new_discovery: 'New Discovery',
        new_campaign: 'New Campaign',
        no_discoveries_found: 'No discoveries found',
        no_campaigns_found: 'No campaigns found',
        // General info section
        general_info: 'General Information',
        campaign_name_label: 'Discovery Name',
        external_company_label: 'External Company Name',
        contact_email_label: 'Contact Email',
        external_company_industry_label: 'Company Industry',
        external_company_industry_placeholder: 'Select industry...',
        company_logo: 'Company Logo',
        change_logo: 'Change Logo',
        upload_logo: 'Upload Logo',
        logo_recommendation: 'Recommended: 200x200px, PNG or JPG, max 2MB',
        // Scenario section
        scenario_config_title: 'Scenario',
        select_scenario_label: 'Select Scenario',
        no_scenarios_available: 'No scenarios available',
        scenario_launch_date_label: 'Scenario Launch Date',
        select_launch_date: 'Select launch date',
        required_when_scenario: 'Required when scenario is selected',
        select_scenario_hint: 'Select a scenario to configure the assessment for this discovery.',
        launched_at: 'Launched At',
        // AI Scenario Adaptation
        adapt_scenarios_label: 'AI Scenario Adaptation',
        adapt_scenarios_desc: 'Adapt scenario content to match the participant department context',
        adapt_scenarios_tooltip:
          'Uses AI to customize the scenario introduction for the target group. Questions and scoring remain identical.',
        adaptation_department_label: 'Target Role / Department',
        adaptation_department_placeholder: 'e.g. Engineering, HR, Finance...',
        adaptation_department_hint:
          'The scenario will be adapted for this department. Leave empty for a general adaptation.',
        // Email phishing section
        email_phishing_config_title: 'Email Phishing',
        select_email_template_label: 'Select Email Template',
        create_custom: 'Create Custom',
        no_email_templates: 'No email templates available',
        subject_label: 'Subject',
        from_label: 'From',
        target_departments_label: 'Target Departments (leave empty for all)',
        add_users_to_see_departments: 'Add users to the discovery to see available departments',
        email_launch_date_label: 'Email Phishing Launch Date',
        required_when_email: 'Required when email template is selected',
        select_email_hint: 'Select an email template to configure phishing simulation for this discovery.',
        // Users section
        campaign_participants: 'Discovery Participants',
        users_count: '{{count}} users',
        public_link_title: 'Public Link',
        share_link_client: 'Share this link with the client to collect participant emails',
        generate_link_client: 'Generate a public link to let the client add participants directly',
        disable: 'Disable',
        download_template: 'Download Template',
        no_participants_yet: 'No participants added yet',
        select_department_optional: 'Select department (optional)',
        // Assessment config section
        assessment_config_title: 'Process Assessment',
        assessment_config_description: 'Select processes to assess and configure interview settings.',
        process_jml: 'Joiners, Movers, Leavers (JML)',
        process_privileged_access: 'Privileged Access Management',
        process_account_recovery: 'Account Recovery',
        process_change_to_prod: 'Change to Production',
        process_external_sharing: 'External Data Sharing',
        process_incident_reporting: 'Incident Reporting',
        process_payment_processing: 'Payment Processing',
        process_vendor_management: 'Vendor Management',
        process_data_privacy: 'Data Privacy & Personal Data',
        assessment_language: 'Interview Language',
        assessment_launch_date: 'Assessment Launch Date',
        assessment_launched_info: 'Assessment has been launched and can no longer be modified.',
        // Assessment results tab
        assessment_results: 'Assessment Results',
        assessment_progress: 'Assessment Progress',
        assessment_not_started: 'Not Started',
        assessment_in_progress: 'In Progress',
        assessment_completed: 'Completed',
        assessment_total: 'Total Assignments',
        assessment_completion_rate: 'Completion Rate',
        assessment_per_process_chart: 'Completion by Process',
        assessment_view_transcript: 'View Transcript',
        assessment_reassign: 'Reassign',
        assessment_reassign_title: 'Reassign Process',
        assessment_reassign_confirm:
          'This will delete all existing interview data for this assignment and start fresh. Continue?',
        assessment_reassign_success: 'Process reassigned successfully',
        assessment_reassign_select_user: 'Select new participant',
        assessment_transcript_title: 'Interview Transcript',
        assessment_no_transcript: 'No transcript available for this interview.',
        assessment_no_results: 'No assessment results yet. Launch the assessment first.',
        assessment_add_assignment: 'Add Assignment',
        assessment_select_employee: 'Select employee',
        assessment_select_process: 'Select process',
        assessment_assign_button: 'Assign',
        assessment_assigned_success: 'Assignment created successfully',
        assessment_already_assigned: 'This employee is already assigned to this process',
        // Findings placeholder
        assessment_findings: 'Security Assessment',
        assessment_findings_placeholder:
          'Findings generation will be available after the evaluation service is configured.',
        assessment_generate_findings: 'Analyze Process',
        assessment_regenerate_findings: 'Re-analyze',
        assessment_findings_instructions: 'Additional information about this process (optional)',
        assessment_additional_info_title: 'Additional Information',
        assessment_additional_info_description:
          'Provide any additional context about this process that may not have been captured during the interview. This information will be considered in the analysis.',
        assessment_additional_info_placeholder:
          'E.g.: The approval process also involves a second review by the IT manager for privileged access requests...',
        assessment_findings_not_available:
          'Findings generation is not yet available. This feature will be enabled in a future update.',
        assessment_findings_summary: 'Executive Summary',
        assessment_findings_gaps: 'Security Vulnerability Assessment by Process Step',
        assessment_findings_recommendations: 'Recommendations',
        assessment_findings_evidence: 'Evidence',
        assessment_findings_observation: 'Observed',
        assessment_findings_gap: 'Gap',
        assessment_findings_severity: 'Severity',
        assessment_findings_generated_at: 'Generated',
        assessment_findings_generated_with: 'Generated with instructions',
        assessment_findings_generating: 'Analyzing security vulnerabilities...',
        assessment_findings_error: 'Failed to generate findings',
        assessment_findings_select_assignment: 'Select a completed assignment to generate findings',
        assessment_findings_no_completed: 'No completed assignments available for findings generation',
        assessment_findings_vulnerability: 'Vulnerability',
        assessment_findings_threat: 'Threat',
        assessment_findings_risk_score: 'Risk Score',
        assessment_findings_likelihood: 'Likelihood',
        assessment_findings_impact: 'Impact',
        assessment_findings_process: 'Process Analyzed',
        assessment_findings_overall_risk: 'Overall Risk Level',
        assessment_findings_top_vulnerabilities: 'Top Vulnerabilities',
        assessment_findings_mitigated_threats: 'Mitigated Threats',
        severity_critical: 'Critical',
        severity_high: 'High',
        severity_medium: 'Medium',
        severity_low: 'Low',
        severity_not_described: 'Not described',
        likelihood_very_likely: 'Very Likely',
        likelihood_likely: 'Likely',
        likelihood_possible: 'Possible',
        likelihood_unlikely: 'Unlikely',
        likelihood_na: 'N/A',
        impact_critical: 'Critical',
        impact_high: 'High',
        impact_medium: 'Medium',
        impact_low: 'Low',
        impact_na: 'N/A',
        // canStart assessment
        blocked_no_assessment_date: 'Set an assessment launch date to start',
        // Arm toggle UI (OPTA-01/02/03/04)
        arm_scenario_enabled: 'Scenario',
        arm_phishing_enabled: 'Email Phishing',
        arm_assessment_enabled: 'Process Assessment',
        arm_disabled_hint: 'This arm is disabled and will not run in this discovery.',
        arm_no_date_warning: 'No launch date set — this arm will not auto-execute without a date.',
        blocked_no_arms:
          'Configure at least one arm (Scenario, Email Phishing, QR Phishing, or Assessment) to start the discovery.',
        start_blocked_no_arms: 'Configure at least one arm to start the discovery.',
        // QR Phishing
        qr_phishing_config_title: 'QR Phishing',
        qr_phishing_config_description:
          'Enable to generate a QR code when the discovery launches. No additional configuration needed.',
        qr_phishing_launch_date: 'QR Phishing Launch Date',
        qr_phishing_launched_info: 'QR phishing has been launched and can no longer be modified.',
        qr_phishing: 'QR Phishing',
        qr_phishing_progress: 'QR Phishing Progress',
        qr_phishing_results: 'QR Phishing Results',
        scans: 'Scans',
        qr_code: 'QR Code',
        download_qr: 'Download QR Code',
        qr_scan_count: 'QR Scans',
        captured_email: 'Captured Email',
        qr_total_targets: 'Total Targets',
        qr_fell: 'Fell for QR Phishing',
        qr_status: 'Status',
        // Missing keys
        start_discovery: 'Start Discovery',
        complete_discovery: 'Complete Discovery',
        discovery_participants: 'Discovery Participants',
        // Source tag translations
        source_manual: 'Manual',
        source_csv: 'CSV',
        source_public_link: 'Public Link',
        // Scenario section super tags
        discovery_assessment: 'Discovery',
        discovery_description: '6 security categories',
        // Assessment section control/user assignment
        assessment_processes_label: 'Controls & Assignments',
        assessment_assign_users_hint:
          'Select controls and assign users. If no users are assigned, all users will be assessed at launch.',
        assessment_select_user: 'Select user...',
        assessment_add_users_first: 'Add participants to assign them',
      },
      control_assessment: {
        compliance_label: 'Compliance',
        compliance_no_data: 'Compliance: not assessed',
        compliance_criteria_breakdown: 'Criteria breakdown',
        compliance_popover_title: 'Compliance assessment',
        page_title: 'Audits',
        legend:
          'Assign a control to a subject-matter expert. They answer a short AI interview from their inbox. Ciphia generates findings you can act on.',
        empty_title: 'No audits yet',
        empty_body:
          'Pick a control (SOC 2, ISO 27001, or NIST), pick who knows about it, and Ciphia takes it from there.',
        empty_cta: 'Create your first audit',
        section: {
          basics: 'Basics',
          interviews: 'Interviews',
          delivery: 'Delivery',
        },
        next_step: {
          launch_title: 'Send the interviews',
          launch_body: "{{count}} assignment(s) haven't been sent yet. Launch to email the interview link.",
          wait_title: 'Waiting on the team',
          wait_body: "{{done}} of {{total}} interviews complete. Nudge whoever hasn't responded, or wait.",
          analyze_title: 'Analyze the finished interviews',
          analyze_body: '{{count}} interview(s) ready. Click the beaker icon on the row to generate findings.',
          refine_title: 'Refine with the auditor',
          refine_body: '{{count}} assignment(s) still have failing criteria. Open the auditor drawer to iterate.',
          done_title: 'Audit complete',
          done_body: 'Every criterion is met. You can archive this audit or move on.',
        },
        new_assessment: 'New audit',
        name: 'Name',
        name_placeholder: 'E.g.: Q1 2026 JML Audit',
        processes: 'Controls',
        select_processes: 'Select control',
        employees: 'Employees',
        employee: 'Employee',
        assigned_to: 'Assigned to',
        select_employees: 'Select employees',
        select_employee: 'Select employee',
        // Per-pair assignment table (Phase 134+).
        assignments_label: 'Interview assignments',
        assignments_help:
          'Each row creates one interview. Assign different controls to different people, or the same control to multiple people.',
        assignments_required: 'Add at least one interview assignment.',
        assignments_duplicate: 'You assigned the same control to the same person twice. Remove the duplicate.',
        col_control: 'Control',
        col_employee: 'Person',
        add_assignment: 'Add interview',
        remove_assignment: 'Remove this row',
        language: 'Language',
        status: 'Status',
        created: 'Created',
        launch_date: 'Launch date',
        actions: 'Actions',
        launch: 'Launch',
        schedule: 'Schedule',
        view: 'View detail',
        not_started: 'Not started',
        in_progress: 'In progress',
        completed: 'Completed',
        total_assignments: 'Total assignments',
        completed_assignments: 'Completed',
        create_success: 'Assessment created successfully',
        launch_success: 'Assessment launched successfully',
        launch_confirm: 'Interview emails will be sent to the selected employees. Continue?',
        no_assessments: 'No assessments created',
        findings: 'Findings',
        no_findings: 'No findings generated yet',
        no_findings_auto_hint:
          'Findings are computed automatically once the interview completes and after each evidence change.',
        no_findings_no_interview: 'The interview has not been completed yet.',
        no_findings_ready_to_generate: 'The interview is complete. Generate findings to compute results.',
        no_findings_generating: 'Generating findings — this can take up to a minute.',
        generate_findings_button: 'Generate findings',
        regenerate_findings_button: 'Regenerate findings',
        regenerate_timeout: 'Generation is taking longer than expected. Refresh in a minute.',
        generate_findings: 'Analyze interview',
        back: 'Back',
        finding_open: 'Open',
        finding_fixed: 'Fixed',
        mark_fixed: 'Mark as fixed',
        reopen: 'Reopen',
        severity: 'Severity',
        observation: 'Observation',
        gap: 'Gap',
        finding_status: 'Status',
        overall_risk: 'Overall Risk',
        unfixed_count: 'Unfixed findings',
        toggle_success: 'Finding status updated',
        schedule_date: 'Schedule for',
        schedule_placeholder: 'Leave empty to launch now',
        scheduled_success: 'Assessment scheduled successfully',
        scheduled: 'Scheduled',
        delete: 'Delete',
        delete_confirm_title: 'Delete assessment',
        delete_confirm_content: 'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
        delete_confirm_content_fallback:
          'Are you sure you want to delete this assessment? This action cannot be undone.',
        delete_success: 'Assessment deleted',
        delete_error: 'Error deleting assessment',
        scheduled_info: 'This assessment is scheduled to launch on {{date}}',
        pending_launch: 'This assessment has not been launched yet',
        view_transcript: 'View interview',
        no_transcript: 'No transcript available',
        transcript_employee: 'Employee',
        transcript_interviewer: 'Interviewer',
        findings_confirm_title: 'Analyze interview',
        findings_confirm_content:
          'The interview will be reviewed to identify findings. This may take a moment. Continue?',
        recommendation: 'Recommendation',
        refine_with_auditor_button: 'Refine with auditor',
        refine_with_auditor_aria_label: 'Open auditor dialog to refine findings',
        view_findings_tooltip: 'View findings',
        generate_findings_tooltip: 'Analyze interview',
        bulk_generate_button_aria: 'Analyze all pending interviews',
        bulk_generate_tooltip: 'Analyze all pending',
        bulk_generate_title: 'Analyze interviews in bulk',
        bulk_generate_intro: '{{count}} pending interviews will be analyzed. This may take a few minutes.',
        bulk_generate_no_pending: 'No completed interviews to analyze.',
        bulk_generate_action: 'Analyze {{count}} interviews',
        bulk_reanalyze_intro:
          'All interviews are already analyzed. Re-analyzing will overwrite the existing findings for {{count}} interviews.',
        bulk_reanalyze_action: 'Re-analyze {{count}} interviews',
        bulk_reanalyze_confirm_title: 'Re-analyze interviews?',
        bulk_reanalyze_confirm_body:
          'This will discard the current findings for {{count}} interviews and replace them with a fresh LLM analysis. The change is permanent.',
        bulk_reanalyze_confirm_ok: 'Yes, re-analyze',
        bulk_reanalyze_confirm_cancel: 'Cancel',
        bulk_generate_in_progress: 'Analyzing ({{completed}}/{{total}})…',
        bulk_generate_current: 'Currently: {{name}}',
        bulk_generate_done: 'Done. {{succeeded}} analyzed, {{failed}} failed.',
        bulk_generate_close: 'Close',
        bulk_generate_already_label: 'Already analyzed',
        bulk_generate_pending_label: 'Pending',
        bulk_generate_state_queued: 'In queue',
        bulk_generate_state_generating: 'Analyzing',
        bulk_generate_state_done: 'Done',
        bulk_generate_state_failed: 'Failed',
        bulk_generate_queue_hint:
          'Interviews are analyzed one at a time. The list updates as each one finishes. The analysis keeps running even if you close this tab.',
        bulk_generate_enqueue_error: 'Could not start bulk analysis. Please try again.',
        status_awaiting_findings: 'Awaiting findings',
        status_findings_ready: 'Findings ready',
        status_awaiting_findings_tooltip: '{{pending}} of {{total}} completed interviews still need findings',
        findings_language_label: 'Findings language',
        add_interviews_tooltip: 'Add more interviews',
        add_interviews_title: 'Add interviews to this assessment',
        add_interviews_description:
          'Enroll additional employees on the existing controls of this assessment. Each new employee receives the interview email.',
        add_interviews_controls_label: 'Controls in this assessment',
        add_interviews_employee_placeholder: 'Pick the employees to enroll',
        add_interviews_submit: 'Add {{count}} interview(s)',
        add_interviews_success: 'Interviews added',
        add_interviews_error: 'Could not add interviews. Please try again.',
        // Phase 135 — per-pair AddInterviewsModal (Form.List of {control,employee}).
        add_interviews_assignments_label: 'Interviews to send',
        add_interviews_assignments_help:
          'Each row sends one new interview. Combine controls and people freely; duplicates of the same pair are not allowed.',
        add_interviews_assignments_required: 'Add at least one interview.',
        add_interviews_assignments_duplicate:
          'You added the same control for the same person twice. Remove the duplicate.',
        add_interviews_control_placeholder: 'Select control',
        add_interviews_add_row: 'Add interview',
        add_interviews_scheduled_at_label: 'Schedule for (optional)',
        add_interviews_submit_now: 'Send batch',
        add_interviews_schedule: 'Schedule batch',
        // Phase 135 — assignments inner table: per-row Active switch + Batch column.
        assignments_active_label: 'Active',
        assignments_batch_label: 'Batch',
        assignments_sent_at_label: 'Sent at',
        criteria_progress_label: 'Criteria',
        criteria_progress_tooltip: 'Criteria met out of total criteria for this control.',
        toggle_active_confirm_title: 'Replace the currently active interview?',
        toggle_active_confirm_body:
          'Activating this row will deactivate the other interview for the same person on the same control.',
        toggle_active_confirm_ok: 'Activate',
        toggle_active_error: 'Could not update the active flag. Please try again.',
        // Phase 135 — parent assessment list: archive / unarchive flow + show-archived toggle.
        show_archived_label: 'Show archived',
        archived_tag: 'Archived',
        archive: 'Archive',
        archive_tooltip: 'Archive this assessment',
        archive_confirm_title: 'Archive this assessment?',
        archive_confirm_body: 'It will be hidden from the active list but kept readable in past reports for audit.',
        archive_success: 'Assessment archived',
        archive_error: 'Could not archive the assessment. Please try again.',
        unarchive: 'Unarchive',
        unarchive_tooltip: 'Restore this assessment to the active list',
        unarchive_confirm_title: 'Unarchive this assessment?',
        unarchive_confirm_body: 'It will return to the active list.',
        unarchive_success: 'Assessment restored',
        unarchive_error: 'Could not restore the assessment. Please try again.',
      },
      compliance_reports: {
        builder: {
          cover_section_title: 'Cover page',
          cover_field_prepared_by: 'Prepared by',
          cover_field_prepared_for: 'Prepared for',
          cover_field_confidentiality: 'Confidentiality',
          page_title: 'Reports',
          legend:
            'Turn one security audit into a compliance-ready report. Ciphia writes the narrative, cites the evidence, and flags anything missing.',
          create_draft_button: 'New report',
          create_draft_submit: 'Create report',
          list_col_title: 'Title',
          list_col_period: 'Period',
          list_col_audit: 'Audit',
          list_audit_unknown: 'No audit',
          list_col_progress: 'Coverage',
          list_action_edit: 'Edit',
          list_empty: 'No reports yet',
          list_empty_desc:
            'Pick a completed audit and Ciphia will draft the whole report — narrative, evidence citations, deviation log.',
          create_draft_modal_title: 'New report',
          create_draft_modal_help: 'Pick one audit. Ciphia builds the report from its evidence and interview.',
          field_period_start: 'Period start',
          field_period_end: 'Period end',
          field_title: 'Report title',
          field_language: 'Language',
          field_language_option_es: 'Spanish',
          field_language_option_en: 'English',
          period_preset_today: 'Today',
          period_preset_last_30: 'Last 30 days',
          period_preset_last_90: 'Last 90 days',
          period_preset_this_quarter: 'This quarter',
          period_preset_this_year: 'This year',
          period_preset_last_year: 'Last year',
          field_source_assessment: 'Source audit',
          field_source_assessment_tooltip:
            'The report will read evidence and findings from this audit. Any control not covered lands in the deviation log.',
          field_source_assessment_placeholder: 'Pick the audit this report is based on',
          field_source_assessments: 'Source security audits',
          field_source_assessments_tooltip:
            'The report will analyze evidence from these audits. Controls without a covered audit will appear in the deviation log.',
          field_source_assessments_placeholder: 'Select audits to feed this report',
          field_source_assessments_empty_title: 'No audits available yet',
          field_source_assessments_empty_desc: 'Run at least one audit from the Audits page before creating a report.',
          validation_period_required: 'Both start and end dates are required',
          validation_assessments_required: 'Select at least one security audit to base the report on',
          validation_assessment_required: 'Pick an audit to base this report on.',
          validation_title_min: 'Give this report a name.',
          validation_title_max: 'Title cannot exceed 200 characters',
          version_editing_label: 'Editing v{{version}}',
          section_narrative: 'Narrative',
          section_exception_log: 'Exception / Deviation Log',
          button_save_edit: 'Save edit',
          button_preview: 'Preview',
          button_versions: 'Versions',
          autosave_pending: 'Saving…',
          autosave_saved: 'Saved',
          autosave_failed: 'Save failed',
          button_edit_narrative: 'Edit',
          button_save_narrative: 'Save',
          button_cancel_edit: 'Cancel',
          // Phase 143 Wave 4 (D-10) :: findings-driven control card body
          // (drawer-mode :: still consumed by the slimmed SectionFindingsBody).
          findings_criteria_met_heading: 'Criteria met',
          findings_criteria_breakdown_heading: 'Per-criterion breakdown',
          findings_status_met: 'Met',
          findings_status_partial: 'Partial',
          findings_status_failed: 'Failed',
          findings_status_not_applicable: 'Not applicable',
          // Phase 143 Wave 4 (D-03) :: methodology card (deterministic, read-only).
          methodology_section_title: 'Methodology',
          methodology_sampling_approach_label: 'Sampling approach',
          methodology_subservice_orgs_label: 'Sub-service organizations',
          meta_field_empty: 'Not yet provided',
          quality_badge_pass: 'AI verification: passed',
          quality_badge_warning: 'AI verification: review recommended',
          quality_badge_fail: 'AI verification: issues detected',
          quality_badge_none: 'Not verified',
          quality_popover_title: 'AI verification breakdown',
          quality_popover_description: 'The AI checked this narrative across six dimensions before saving the draft.',
          quality_dim_unfounded_claims: 'Claims grounded in evidence',
          quality_dim_missing_citations: 'Citations match the evidence',
          quality_dim_softening_language: 'No softening of risks',
          quality_dim_tone_marketing: 'Professional tone (no marketing speak)',
          quality_dim_contradicts_facts: 'Consistent with the evidence',
          quality_dim_hallucinated_entities: 'No fabricated entities',
          quality_status_pass: 'Pass',
          quality_status_warning: 'Warning',
          quality_status_fail: 'Fail',
          breadcrumb_root: 'Compliance reports',
          citations_section_title: 'References',
          citations_aria_label: 'Citation {{index}}',
          section_number_aria: 'Section {{number}}',
          exception_log_section_title: 'Exceptions and deviations',
          exception_log_complete_title: 'No deviations recorded',
          exception_log_complete_description: 'No controls were hidden or excluded from this report for the period.',
          no_evidence_for_control: 'No evidence has been attached for this control yet.',
          exception_log_empty: 'No controls hidden or excluded for this period.',
          exception_log_reason_no_audit: 'No audit was conducted for this control.',
          exception_log_reason_no_risk_data: 'No risk metrics are available for this control.',
          // Phase 143 Wave 5 (D-16) :: hidden-by-admin reasonKey row.
          exception_log_reason_hidden_by_admin: 'Hidden by admin from the main body. Surfaced here for completeness.',
          // Phase 143 Wave 5 (D-04 + D-07) :: header "Analyze Report" button + 4-state machine copy.
          generate_ai_button_label: 'Analyze Report',
          generate_ai_button_loading: 'Analyzing...',
          generate_ai_button_tooltip_ready:
            'Generates the executive summary, risk assessment, and AI narratives. Only regenerates new or modified sections.',
          generate_ai_button_tooltip_fresh: 'All sections are up to date with the latest evidence.',
          reanalyze_confirm_title: 'Re-analyze this report?',
          reanalyze_confirm_body:
            'The previous analysis will be replaced. Current narrative and recommendations will be lost.',
          reanalyze_confirm_ok: 'Yes, re-analyze',
          reanalyze_confirm_cancel: 'Cancel',
          header_analyzed_at: 'Analyzed on {{date}}',
          header_not_analyzed: 'Not analyzed yet',
          generate_ai_toast_success: 'AI sections generated successfully.',
          generate_ai_toast_error: 'Could not finish generating. Some sections may need a retry.',
          generate_ai_error_network: 'Network error while contacting the AI service. Try again.',
          generate_ai_error_throttled: 'AI service is busy. Wait a moment and try again.',
          // Phase 143 Wave 5 (D-15) :: hide-control toggle toast feedback.
          section_hidden_toast: 'Control hidden from the main body. Listed in the deviation log.',
          section_unhidden_toast: 'Control restored to the main body.',
          section_regenerate_error: 'Could not regenerate this section. Try again.',
          section_hide_error: 'Could not change the section visibility. Try again.',
          exception_log_column_control: 'Control',
          exception_log_column_reason: 'Why it is in scope but not evidenced',
          exception_log_column_action: 'Action',
          exception_log_action_start_audit: 'Start interview',
          exception_log_no_action_for_control:
            'This control is not evidenced via process audit. Add an evidence file or capture training data.',
          exception_log_no_risk_data_tooltip:
            'Risk metrics come from phishing simulations and scenario campaigns. Run a campaign to populate this control.',
          preview_pdf_button: 'Generate PDF',
          preview_pdf_error: 'Could not render the PDF preview. Try again or check the report draft.',
          welcome_mat_title: 'Before generating your first compliance report',
          welcome_mat_description:
            'Compliance narratives are sourced from process audits (interviews where you describe how each control is operated). Without at least one audit, the report will be mostly empty. We recommend running your first interview now — it takes a few minutes per process.',
          welcome_mat_primary_cta: 'Run my first process audit',
          welcome_mat_secondary_cta: 'Create empty draft anyway',
          field_state_option_draft: 'Draft',
          field_state_option_published: 'Published',
          versions_modal_title: 'Version history',
          versions_modal_empty: 'No prior versions yet.',
          versions_entry_archived_at: 'Archived on {{date}}',
          preview_iframe_title: 'Report preview',
          // Phase 145 Wave 1 :: 5-KPI lead matching PDF Sect 1 verbatim
          // (D-07). Order: Overall Human Risk Score / Employees Evaluated
          // / Phishing Click Rate / Phishing Fell Rate / Coverage.
          kpi: {
            human_risk_score_label: 'Overall Human Risk Score',
            human_risk_score_subtitle: 'Level: {{level}}',
            employees_evaluated_label: 'Employees Evaluated',
            employees_evaluated_subtitle: 'Total in scope',
            phishing_click_rate_label: 'Phishing Click Rate',
            phishing_click_rate_short: 'Click Rate',
            phishing_click_rate_subtitle: 'Across campaign targets',
            phishing_fell_rate_label: 'Phishing Fell Rate',
            phishing_fell_rate_short: 'Fell Rate',
            phishing_fell_rate_subtitle: 'Entered credentials',
            phishing_exposure_label: 'Phishing Exposure',
            coverage_label: 'Control Coverage',
            coverage_subtitle: 'Mandatory criteria met across audited processes',
            empty_value: 'No data',
          },
          rationale: {
            edit_hint: 'Click to edit',
            save: 'Save',
            cancel: 'Cancel',
            save_error: 'Could not save edit',
            cannot_be_empty: 'Text cannot be empty',
            empty: 'Run Analyze Report to generate this section.',
          },
          section_visibility: {
            show_in_pdf: 'Show in PDF',
            hide_from_pdf: 'Hide from PDF',
            hidden_badge: 'Hidden from PDF',
            toggle_error: 'Could not toggle section visibility',
          },
          // Phase 144 :: section headers (1.2 / 1.3)
          section: {
            executive_overview_title: '1. Executive Overview',
            control_audits_title: 'Control Audits',
            exception_log_title: 'Exception Log',
            toc_aria_label: 'Table of contents',
            // Phase 145 §4 :: Process Security Assessment wrapper (PDF Sect 3).
            // ProcessSecurityAssessmentSection composes ControlAuditsSection
            // (variant='embedded') and supplies the PDF-aligned title + intro.
            process_security_assessment: {
              title: '7. Process Security Assessment',
              intro: 'Status of process controls assessed during the reporting period.',
              empty: 'No controls assessed yet.',
            },
            // Phase 145 §2 :: Organizational Risk Posture (replaces v1 Risk Analysis)
            organizational_risk_posture: {
              title: '2. Organizational Risk Posture',
              score_header: 'Company Risk',
              level_label: 'Level: {{level}}',
              distribution: 'Risk Distribution by Band',
              band: {
                high: 'High',
                medium: 'Medium',
                low: 'Low',
              },
              empty: 'Not enough data to evaluate the posture yet.',
              bands_as_pct: '{{pct}}%',
              bands_as_count: '{{count}} ({{pct}}%)',
            },
            // Phase 145 §6 :: Behavioral Risk Categories (PDF demo Sect 6).
            // Data-only table sourced from CompanyModelEntity.categoryRisks.
            behavioral_risk_categories: {
              title: '4. Behavioral Risk Categories',
              col_category: 'Category',
              col_score: 'Score',
              col_level: 'Level',
              empty: 'No categories evaluated yet.',
              level_high: 'High',
              level_medium: 'Medium',
              level_low: 'Low',
            },
            // Phase 145 §5 :: Department Risk Analysis (PDF demo Sect 4).
            // Data-only 3-column table sourced from EmployeeService
            // .getGroupRiskBreakdown via the orchestrator transform; per-band
            // counts NEVER reach this surface (T-145-05 / D-11).
            department_risk: {
              title: '3. Department Risk Analysis',
              col_group: 'Department',
              col_score: 'Average Risk Score',
              col_top_category: 'Top Exposed Category',
              no_category: 'No standout category',
              empty: 'No departments evaluated yet.',
            },
            // Phase 145 §6 :: Phishing Simulation Results (PDF demo Sect 7,
            // unified per D-06 across email + QR + Slack vectors). Aggregate
            // KPI tiles + deterministic banded insight. Bands gated on
            // fellRate: high >= 10%, moderate >= 5%, low < 5%.
            phishing_simulation_results: {
              title: '5. Phishing Simulation Results',
              kpi: {
                campaigns: 'Campaigns in period',
                targets: 'Total targets',
                clicked: 'Total clicks',
                fell: 'Total falls',
              },
              insight: {
                high: 'A fell rate of {{pct}}% indicates high exposure. A single compromised account can expose the rest of the environment.',
                moderate:
                  'A fell rate of {{pct}}% signals moderate exposure. Reinforcing training and simulations reduces risk.',
                low: 'A fell rate of {{pct}}% reflects controlled exposure. Maintaining a simulation cadence sustains the level.',
              },
              empty: 'No campaigns in this period.',
            },
            // Phase 146 W3 §7 :: QR Phishing Simulation (NEW section, v3 only).
            // Composer-emitted prose until W4 wires the 4-stat header + 2 rate bars.
            qr_phishing_simulation: {
              title: '6. QR Phishing Simulation',
              intro: 'Aggregate indicators for the QR phishing campaign during the reporting period.',
              empty: 'No QR campaign data was captured for this period yet.',
            },
            // Phase 145 §7 (plan 07b) :: Expert Review (PDF demo Sect 9).
            // 3 chip-headed admin cards backed by the `__expert_review__`
            // narrative sentinel. Titles are locked (D-14); body is admin
            // editable via finalEdited (D-16).
            expert_review: {
              title: '8. Expert Review',
              empty: 'Expert review will appear after generation.',
              card: {
                training: {
                  title: 'Targeted Behavioral Training',
                },
                simulations: {
                  title: 'Continuous Simulation Campaigns',
                },
                process_controls: {
                  title: 'Process Verification Controls',
                },
              },
            },
            // Phase 147 v2 :: Final Recommendations (4th card of Expert Review).
            // Editable; data sourced from the policy catalog + LLM-authored
            // motivation. Title/clauses/frameworks come from the catalog
            // (language-resolved); only motivation is LLM-emitted.
            policy_recommendations: {
              title: 'Final Recommendations',
              empty: 'No policy recommendations triggered for this period.',
              motivation_label: 'Why for this organization',
              clauses_label: 'Key clauses',
              frameworks_label: 'Framework references',
            },
          },
          // Phase 145 §6 :: localized category labels. Keys are the slugs
          // emitted by CategoryRiskService.slugifyCategoryKey; unmapped
          // slugs fall back to the raw display name via i18next defaultValue.
          category: {
            ai_and_emerging_threats: 'AI and Emerging Threats',
            ai_emerging_threats: 'AI and Emerging Threats',
            email_and_phishing_security: 'Email and Phishing Security',
            phishing_and_email_safety: 'Phishing and Email Safety',
            phishing_email: 'Phishing and Email Safety',
            phishing_awareness: 'Phishing Simulation Behavior',
            device_security: 'Device Security',
            data_handling_and_privacy: 'Data Handling and Privacy',
            data_privacy: 'Data Handling and Privacy',
            secure_navigation: 'Secure Navigation and SaaS Usage',
            safe_browsing_saas: 'Secure Navigation and SaaS Usage',
            account_and_password_security: 'Accounts and Password Security',
            account_password_security: 'Accounts and Password Security',
          },
          // Phase 144 / Phase 146 :: AI insight cards. The Executive
          // synthesis + Risk synthesis card pair was dropped (the v3
          // composer emits per-section rationale that the dedicated
          // section components render). Remaining keys cover the
          // control drawer + organizational risk surfaces.
          ai_insight: {
            control_drawer_card_title: 'AI Insight',
            edit_button_aria: 'Edit this insight',
            cancel_button_label: 'Cancel',
            save_button_label: 'Save',
            empty_organizational_risk_posture_title: 'Analysis pending',
            empty_organizational_risk_posture_body:
              'Click "Analyze Report" above to synthesize the organizational risk posture for this period.',
            empty_control_drawer_title: 'Insight pending',
            empty_control_drawer_body: 'Click "Analyze Report" above to synthesize a brief insight for this control.',
            zero_evidence_control_drawer_title: 'No evidence captured for this control',
            zero_evidence_control_drawer_body:
              'No interview transcripts, findings or criteria assessments for this control fall within the report period. Run an audit interview covering this control to generate an insight.',
          },
          // Phase 144 :: charts (2.2)
          chart: {
            atlas_title: 'Risk by Team',
            atlas_caption: 'Larger teams are bigger boxes. Red boxes carry the highest risk, yellow medium, green low.',
            atlas_legend_size: 'Box size = team size',
            atlas_legend_color: 'Box color = team risk',
            atlas_empty: 'No organizational groups modeled yet. Load the structure in Atlas.',
            employee_risk_title: 'Per-Employee Risk',
            employee_risk_caption: 'Distribution of employees by risk level over the period.',
            employee_risk_x_axis: 'Risk level',
            employee_risk_y_axis: 'Employees',
            employee_risk_empty: 'No per-employee risk data for this period yet.',
            risk_level_low: 'Low',
            risk_level_medium: 'Medium',
            risk_level_high: 'High',
            phishing_title: 'Phishing Awareness',
            phishing_caption: 'Fall rate on simulated phishing campaigns during the period.',
            phishing_value_label: 'Fall rate',
            phishing_reference_label: 'Previous period',
            phishing_empty: 'No phishing campaigns executed in this period yet.',
          },
          // Phase 144 :: control audit tiles (3.1)
          tile: {
            criteria_count: '{{met}}/{{total}} criteria',
            status_met: 'Met',
            status_partial: 'Partial',
            status_failed: 'Failed',
            status_pending: 'Pending',
            status_hidden: 'Hidden',
            body_pending: 'Not analyzed',
            body_hidden: 'Hidden',
            body_all_met_one: 'All criteria met',
            body_all_met_other: 'All {{count}} criteria met',
            body_failed_evidence_one: '1 criterion without evidence',
            body_failed_evidence_other: '{{count}} criteria without evidence',
            body_partial_mix: '{{met}} of {{total}} met',
            ratio_caption: '{{met}}/{{total}} criteria',
            hide_action_aria: 'Hide from main body',
            unhide_action_aria: 'Restore to main body',
          },
          // Phase 144 :: drill-down drawer (3.2)
          drawer: {
            criteria_met_label_one: '1 of 1 criterion met',
            criteria_met_label_other: '{{met}} of {{total}} criteria met',
            criteria_met_label_all: 'All {{total}} criteria met',
            criteria_met_label_none: '{{total}} criteria without evidence',
            criteria_met_label: '{{met}}/{{total}} criteria met',
            compliance_label: 'Compliance: {{percent}}%',
            description_heading: 'Control description',
            evidence_heading: 'Linked evidence',
            evidence_more: '+{{count}} more',
            evidence_empty: 'No linked evidence yet.',
            close_aria: 'Close',
          },
        },
      },
      auditor_dialog: {
        title: 'Internal auditor',
        subtitle:
          'Ask the auditor about criteria, evidence, and findings. Upload or remove evidence from the evidence list on this page.',
        language_hint: 'Conversation in {{language}}',
        language_hint_label: { en: 'English', es: 'Spanish' },
        empty_state: {
          title: 'No messages yet',
          body: 'Send a message to start the conversation. The auditor will respond automatically.',
        },
        role: {
          admin: 'You',
          auditor: 'Auditor',
        },
        input: {
          placeholder: 'Type your question for the auditor...',
          send: 'Send',
        },
        soft_cap: {
          warning_30: '{{count}} of {{cap}} replies used. Wrap up the conversation soon.',
          warning_50: 'Reply limit reached. Close the drawer and continue working from the evidence list.',
        },
        error: {
          send_failed: 'Could not send message. Try again.',
        },
      },
      control_findings_card: {
        empty_state: {
          description:
            'Findings are organized by criterion, not by process step. Each card represents one criterion the auditor checks against your interview.',
        },
        description_label: 'What this criterion checks',
        rationale_label: 'Why this status',
        rationale_pending: 'No rationale was recorded for this criterion yet.',
        evidence_quote_label: 'What the employee said',
        expand_details: 'Show details',
        status: {
          met: 'Met',
          partial: 'Partial',
          failed: 'Failed',
          not_applicable: 'N/A',
          insufficient_evidence: 'Insufficient evidence',
        },
        severity: {
          mandatory: 'Mandatory',
          customary: 'Customary',
          nice_to_have: 'Nice to have',
        },
        framework_label_soc2: 'SOC 2',
        framework_label_iso27001: 'ISO 27001',
        framework_label_nist_csf: 'NIST CSF',
        manual_override_badge: 'Manual',
        override_button: 'Override',
        override_set_met: 'Mark as Met',
        override_set_partial: 'Mark as Partial',
        override_set_failed: 'Mark as Failed',
        override_set_na: 'Mark as N/A',
        override_clear: 'Clear override',
        override_apply_success: 'Manual override applied',
        override_clear_success: 'Override cleared',
        override_failure: 'Override failed',
        override_modal: {
          title: 'Change criterion status',
          status_label: 'Status to apply',
          status_met: 'Met',
          status_partial: 'Partial',
          status_failed: 'Failed',
          status_not_applicable: 'Not applicable',
          status_clear: 'Clear (revert to system)',
          justification_label: 'Justification (required)',
          justification_placeholder: 'For example: compensating control X covers this point',
          justification_min: 'Enter at least 5 characters',
          submit: 'Confirm',
          cancel: 'Cancel',
        },
        override_history: {
          title: 'Override history',
          empty: 'No prior overrides',
          action_set: 'Status applied',
          action_clear: 'Status reverted to system',
          actor_label: 'By',
          timestamp_label: 'When',
          justification_label: 'Justification',
        },
      },
      findings_summary_card: {
        overall_status: {
          compliant: 'Compliant',
          partial: 'Partial',
          non_compliant: 'Non-compliant',
          pending: 'Pending',
        },
        kpi_met: 'Met',
        kpi_partial: 'Partial',
        kpi_failed: 'Failed',
        kpi_not_applicable: 'Not applicable',
        score_label: 'Compliance score',
        score_unavailable: 'No evidence points yet',
        criteria_label: 'Evidence points',
        last_evaluated_at: 'Last evaluated on {{date}}',
        framework_refs_label: 'Frameworks',
        what_this_means_label: 'What this control means',
      },
      auditor_drawer: {
        empty_state_heading: 'Ask the auditor',
        empty_state_bullet_ask: 'What would close the failed criteria?',
        empty_state_bullet_clarify: 'Which finding should I fix first, and why?',
      },
      findings: {
        view_interview_tooltip: 'View interview',
      },
    },
    routes: {
      home: 'Home',
      login: 'Login',
      register: 'Register',
      forgot: 'Forgot Password',
      recovery: 'Password Recovery',
      verification: 'Verification',
      auth_callback: 'Auth Callback',
      company: 'Company',
      dashboard: 'Dashboard',
      create_diagnostic: 'Create Scenario (Expert)',
      create_yaml_diagnostic: 'Create Scenario (YAML)',
      diagnostics: 'Scenarios',
      schedules: 'Agenda',
      addons: 'Add-ons',
      compliance: 'Compliance',
      compliance_wizard: 'Compliance Wizard',
    },
    layout: {
      platform: 'Platform',
    },
    atlas_onboarding: {
      title: 'Organizational Mapping',
      description:
        'You have been invited to complete your organizational profile. This process will take a few minutes and will help us better understand the structure of the organization.',
      optin_line1:
        'Ciphia is an operational and human risk analysis platform that helps organizations strengthen their security posture.',
      optin_line2:
        'By continuing, you agree that your responses will be processed and analyzed using artificial intelligence solely to evaluate and improve the security of the organization.',
      optin_line3: 'Your data will be treated confidentially and will not be shared with third parties.',
      cta: 'Accept and start',
      expired_title: 'Link expired',
      expired_subtitle: 'This link has expired. Request a new invitation from your administrator.',
      invalid_title: 'Invalid link',
      invalid_subtitle: 'This link is not valid. Verify that the URL is correct or request a new invitation.',
      completed_title: 'Completed',
      completed_subtitle:
        'Thank you for completing the interview. This will help strengthen the security posture of the organization.',
      interview_completed: 'Interview completed',
      interview_completed_hint: 'You can finalize when you are ready.',
      finalize: 'Finalize',
      confirm_and_finish: 'Confirm and finish',
      findings: 'Findings',
      people: 'People',
      groups: 'Groups',
      relations: 'Relations',
      avatar_you: 'You',
      self_label: 'I',
      input_placeholder: 'Write your answer...',
      send_sr: 'Send',
      block_role: 'Role',
      block_hierarchy: 'Hierarchy',
      block_relations: 'Relations',
      review_title: 'Interview Summary',
      review_subtitle: 'Review the extracted information. If something is incorrect, write below to correct it.',
      review_your_info: 'Your information',
      review_department: 'Department',
      review_responsibilities: 'Responsibilities',
      review_people: 'People mentioned',
      review_relations: 'Relations',
      review_correction_hint: 'Something incorrect? Write the correction and we will incorporate it.',
      review_correction_placeholder: 'E.g.: Renata is COO, not CTO...',
      rel_reports_to_first: 'report to',
      rel_reports_to_third: 'reports to',
      rel_works_in_first: 'work in',
      rel_works_in_third: 'works in',
      rel_works_with_first: 'work with',
      rel_works_with_third: 'works with',
      rel_collaborates_with_first: 'collaborate with',
      rel_collaborates_with_third: 'collaborates with',
      rel_manages_first: 'manage',
      rel_manages_third: 'manages',
      rel_belongs_to_first: 'belong to',
      rel_belongs_to_third: 'belongs to',
      rel_has_role_first: 'have role',
      rel_has_role_third: 'has role',
      rel_member_of_first: 'am a member of',
      rel_member_of_third: 'is a member of',
    },
    atlas: {
      send_invitations: 'Send Invitations',
      pending_changes: 'There are pending changes in the graph',
      discard: 'Discard',
      apply_changes: 'Apply changes',
      relations: {
        REPORTS_TO: { out: 'reports to', in: 'is the manager of' },
        COLLABORATES_WITH: { out: 'collaborates with', in: 'collaborates with' },
        BELONGS_TO: { out: 'belongs to', in: 'includes' },
      },
      status: {
        completed: 'Completed',
        not_started: 'Not started',
      },
      card: {
        relations: 'Relations',
        role: 'Role',
        department: 'Department',
        risk: 'Risk',
        consent: 'Consent',
        onboarding: 'Onboarding',
        type: 'Type',
        type_employee: 'Employee',
        type_group: 'Group',
        type_company: 'Company',
        type_candidate: 'Candidate',
        type_department: 'Group/Department',
        undefined: 'Not defined',
        yes: 'Yes',
        no: 'No',
        link_to_employee: 'Link to existing employee',
        search_employee: 'Search employee...',
        link: 'Link',
      },
    },
  },
  es: {
    translation: {
      login: {
        title: 'Autenticación',
        legend: '¿No tienes una cuenta?',
        email_label: 'Correo electrónico',
        email_required: 'Por favor ingresa tu correo',
        email_placeholder: 'Correo...',
        password_label: 'Contraseña',
        password_required: 'Por favor ingresa tu contraseña',
        password_placeholder: 'Contraseña...',
        register: 'Registrarse',
        submit: 'Autenticar',
        google_btn: 'Continuar con Google',
        forgot: 'Olvidé mi contraseña',
      },
      forgot: {
        title: 'Recuperar contraseña',
        legend: 'Ingresa tu correo y te enviaremos instrucciones para restablecer tu contraseña.',
        email_label: 'Correo electrónico',
        email_required: 'Por favor ingresa tu correo',
        email_placeholder: 'Correo...',
        submit: 'Enviar',
      },
      password_bar: {
        bar_level_1: 'contraseña débil',
        bar_level_2: 'contraseña débil',
        bar_level_3: 'contraseña aceptable',
        bar_level_4: 'buena contraseña',
        bar_level_5: 'contraseña fuerte',
        password_must: 'La contraseña debe contener al menos',
        must_characters: '12 caracteres',
        must_uppercase: '1 mayúscula',
        must_lowercase: '1 minúscula',
        must_number: '1 número',
        must_special: '1 carácter especial ej. !_@',
      },
      register: {
        title: 'Registro',
        legend: '¿Ya tienes una cuenta?',
        signin: 'Autenticar',
        submit: 'Registrarse',
        name_required: 'Por favor ingresa tu nombre',
        name_label: 'Nombre',
        name_placeholder: 'Nombre...',
        email_required: 'Por favor ingresa tu correo',
        email_not_valid: 'El correo no es válido',
        email_label: 'Correo electrónico',
        email_placeholder: 'Correo...',
        password_label: 'Contraseña',
        password_placeholder: 'Contraseña...',
        password_required: 'Por favor ingresa tu contraseña',
        password_whitespace: 'La contraseña no puede tener espacios al inicio o final',
        confirmation_required: 'Por favor confirma tu contraseña',
        confirmation_not_match: 'La confirmación de contraseña no coincide',
        confirmation_label: 'Confirmar contraseña',
        confirmation_placeholder: 'Confirmación de contraseña...',
        google_btn: 'Continuar con Google',
        invitation_validating: 'Validando código de invitación...',
        invitation_invalid: 'Código de invitación inválido o expirado.',
        invitation_valid: 'Has sido invitado a unirte a {0}.',
        invitation_validating_message: 'Estamos validando tu código de invitación. Por favor espera...',
        invitation_invalid_message:
          'Tu código de invitación es inválido o ha expirado. Por favor contacta a tu administrador.',
        invitation_valid_message: 'Has sido invitado a unirte a {0}. Por favor completa tu registro abajo.',
        invitation_valid_message_part1: 'Has sido invitado a unirte a',
        invitation_valid_message_part2: '. Por favor completa tu registro abajo.',
      },
      recovery: {
        title: 'Recuperación de contraseña',
        legend: 'Hemos enviado un código de verificación a tu correo. Por favor ingrésalo abajo.',
        submit: 'Cambiar',
        password_required: 'Por favor ingresa tu nueva contraseña',
        new_password_label: 'Nueva contraseña',
        new_password_placeholder: 'Contraseña...',
        confirmation_required: 'Por favor confirma tu nueva contraseña',
        confirmation_not_match: 'La confirmación de contraseña no coincide',
        confirmation_label: 'Confirmar nueva contraseña',
        confirmation_placeholder: 'Confirmación de contraseña...',
        title_verified: '¡Contraseña cambiada! 🎉',
        legend_verified: 'Ahora puedes iniciar sesión.',
        login: 'Ir a Login',
        resend: 'Reenviar código',
      },
      verification: {
        title: 'Código de verificación',
        legend: 'Hemos enviado un código de verificación a tu correo. Por favor ingrésalo abajo.',
        title_verified: '¡Código verificado! 🎉',
        legend_verified: 'Ahora puedes iniciar sesión.',
        login: 'Ir a Login',
        resend: 'Reenviar código',
      },
      callback: {
        title: 'Autenticando...',
        legend: 'Por favor espera mientras verificamos tus credenciales. Serás redirigido en breve.',
        login: 'Volver a Login',
      },
      sidebar: {
        home: 'Inicio',
        diagnostics: 'Escenarios',
        help: 'Ayuda',
        dashboard: 'Dashboard',
        company: 'Compañía',
        memories: 'Memorias',
        profile: 'Perfil',
        settings: 'Configuración',
        logout: 'Cerrar sesión',
        risk: 'Riesgo',
        more: 'más',
        schedule: 'Agenda',
        control_assessment: 'Auditorías',
        compliance_reports: 'Reportes',
      },
      home: {
        title: 'Inicio',
        welcome_1: 'Bienvenido,',
        welcome_2: 'mi nombre es',
        welcome_3: 'Ciphia',
        security_message: 'Toda la información estará protegida y segura.',
        tour_intro: 'Así es como Ciphia te ayuda a reducir el riesgo humano,',
        tour_dashboard_title: 'Dashboard',
        tour_dashboard_desc: 'Visualiza el score de riesgo de tu equipo, tendencias y áreas prioritarias.',
        tour_scenarios_title: 'Escenarios',
        tour_scenarios_desc:
          'Escenarios interactivos que evalúan a tu equipo ante amenazas reales, con videos para reforzar el aprendizaje.',
        tour_simulations_title: 'Simulaciones',
        tour_simulations_desc: 'Ejecuta campañas de phishing por Email o códigos QR para medir conciencia.',
        tour_company_title: 'Compañía',
        tour_company_desc: 'Agrega a los miembros de tu equipo, configura grupos y administra integraciones.',
        tour_control_audits_title: 'Auditorías',
        tour_control_audits_desc:
          'Realizá assessments de controles basados en entrevistas y revisá findings generados por IA.',
        tour_compliance_reports_title: 'Reportes',
        tour_compliance_reports_desc:
          'Generá, actualizá y publicá reportes de compliance para SOC 2, ISO y marcos argentinos.',
        tour_go_to_dashboard: 'Ir al Dashboard',
      },
      company: {
        title: 'Compañía',
        section_title: 'Administrar Compañía',
        active_users: 'Usuarios Activos',
        column_name: 'Nombre',
        column_email: 'Correo',
        column_client: 'Cliente',
        search_placeholder: 'Buscar...',
        invite_admin: 'Invitar Admin',
        invite_admin_title: 'Invitar Admin a {{companyName}}',
        user_email: 'Correo del Admin',
        email_required: 'Por favor ingresa el correo del administrador',
        name_label: 'Nombre:',
        industry_label: 'Industria:',
        industry_placeholder: 'Seleccionar industria',
        size_label: 'Tamaño:',
        domain_verification_title: 'Verificación de Dominio (DNS)',
        invite_error: 'Error al enviar la invitación.',
        invite_success: '¡Invitación enviada exitosamente!',
        invite_generic_error: 'Ocurrió un error al enviar la invitación.',
      },
      dashboard: {
        title: 'Tablero',
        origin_title: 'Origen',
        explanation_title: 'Explicación',
        mark_as: 'Marcar como {{done}}',
        analyzing: 'Analizando',
        mitigation_plan: 'Plan de Mitigación',
        explanation: 'Explicación',
        origin: 'Origen',
        description: 'Descripción',
        categories_title: 'Categorías y Vulnerabilidades ({{qty}})',
        analyzed: '# de Análisis',
        fixed_qty: '# de Corregidos',
        found: '# de Encontrados',
        risk: 'Riesgo',
        fixed: 'Corregido',
        not_fixed: 'No Corregido',
        suggestions_title: 'Generando...',
        suggestions_legend: 'Por favor espera mientras generamos tus sugerencias personalizadas.',
        no_vulnerabilities: 'No se encontraron vulnerabilidades',
        delete_title: 'Eliminar vulnerabilidad',
        delete_content: '¿Estás seguro de eliminar esta vulnerabilidad?',
        delete_ok: 'Sí',
        delete_cancel: 'No',
        delete: 'Eliminar',
        mark_fixed: 'Marcar como Corregido',
        mark_not_fixed: 'Marcar como No Corregido',
        description_title: 'Descripción',
        suggestions_actions_title: 'Acciones Sugeridas',
        action: 'Acción',
        empty_vulnerabilities: 'Sin Vulnerabilidades',
        new_diagnostic: '+ Escenario',
      },
      create_diagnostic: {
        title: 'Escenario',
        legend:
          'Crea escenarios interactivos de seguridad eligiendo un tema y seleccionando miembros del equipo. El sistema iniciará una conversación realista con cada participante, evaluará sus respuestas y asignará videos de capacitación cuando sea necesario para reforzar conceptos clave.',
        client_label: 'Selecciona dónde iniciar la conversación.',
        emails_label: 'Correos de los usuarios que quieres consultar.',
        emails_required: 'Por favor ingresa los correos de los usuarios',
        emails_placeholder: 'Correos separados por espacio...',
        emails_invalid: 'Correos inválidos',
        topic_label: 'Tema que quieres que Ciphia discuta. Ej. Seguridad de Contraseñas, Phishing, etc.',
        topic_required: 'Por favor ingresa el título del tema',
        topic_placeholder: 'Título del tema (un tema por escenario)...',
        additional_label: 'Información adicional sobre el tema de seguridad que quieres analizar. (Opcional)',
        additional_required: 'Por favor ingresa el tema',
        additional_placeholder: 'Sobre el tema o resultados deseados de la conversación...',
        submit: 'Crear Escenario',
      },
      diagnostic: {
        feedback_link: 'Comentarios',
        support_link: 'Soporte',
        feedback_title: 'Enviar comentarios',
        support_title: 'Obtener soporte',
        feedback_description: 'Comparte tu opinión sobre esta experiencia de capacitación.',
        support_description: 'Describe el problema que estás teniendo y te responderemos.',
        feedback_placeholder: 'Escribe tu mensaje aquí...',
        feedback_success: '¡Gracias por tu mensaje!',
        feedback_error: 'No se pudo enviar. Inténtalo de nuevo.',
        title: 'Escenarios',
        title_single: 'Escenario',
        legend:
          'Cada semana, los empleados reciben un escenario de seguridad corto en su bandeja. La IA lo adapta al rol, seniority y errores pasados de cada persona.',
        diagnostic_title: 'Escenarios ({{qty}})',
        no_diagnostics: 'No se encontraron escenarios',
        no_diagnostics_title: 'Todavía no hay nada programado',
        no_diagnostics_desc:
          'Programá un horario semanal y el primer escenario sale el próximo lunes. O tocá "Ejecutar ahora" desde cualquier programación para probar end-to-end hoy.',
        schedule_first_cta: 'Programar primer escenario',
        create_first: 'Crea tu primer escenario',
        users_title: 'Usuarios',
        target_all: 'Todos',
        target_employees: 'Empleados específicos',
        additional_information_title_link: 'Adicionales',
        additional_information_title: 'Información Adicional',
        finished: 'Finalizado',
        started: 'Iniciado',
        not_started: 'No Iniciado',
        not_found: 'No Encontrado',
        finish: 'Finalizar',
        start: 'Iniciar',
        results: 'Resultados',
        add_diagnostic: '+ Nuevo',
        started_at: 'Iniciado el {{date}}',
        finished_at: 'Finalizado el {{date}}',
        results_title: 'Insights del Escenario',
        results_loading_title: 'Generando...',
        results_loading_legend: 'Por favor espera mientras analizamos los resultados del escenario.',
        delete_title: 'Eliminar escenario',
        delete_content: '¿Estás seguro de eliminar este escenario?',
        delete_ok: 'Sí',
        delete_cancel: 'No',
        weekly_rotation_label: 'Agenda semanal',
        weekly_rotation_tooltip: 'Habilitar escenarios semanales programados',
        weekly_rotation_disabled: 'Escenarios semanales deshabilitados',
        weekly_rotation_enabled: 'Escenarios semanales habilitados',
        manage_schedules: 'Editar Programación',
        language_label: 'Idioma del Email',
        language_hint: 'Idioma para los emails de notificación del escenario',
      },
      data_table: {
        search_placeholder: 'Buscar...',
      },

      routes: {
        home: 'Inicio',
        login: 'Iniciar Sesión',
        register: 'Registrarse',
        forgot: 'Recuperar Contraseña',
        recovery: 'Recuperación de Contraseña',
        verification: 'Verificación',
        auth_callback: 'Callback de Autenticación',
        company: 'Compañía',
        dashboard: 'Dashboard',
        create_diagnostic: 'Crear Escenario (Experto)',
        create_yaml_diagnostic: 'Crear Escenario (YAML)',
        diagnostics: 'Escenarios',
        schedules: 'Agenda',
        addons: 'Add-ons',
        compliance: 'Compliance',
        compliance_wizard: 'Asistente de Cumplimiento',
      },
      layout: {
        platform: 'Plataforma',
      },
      scenarios: {
        language_label: 'Idioma del email',
        language_hint: 'Idioma de los emails de notificación de escenarios',
      },
      employee_form: {
        role: 'Rol',
        role_required: 'El rol es obligatorio',
        role_placeholder: 'Ej: Software Engineer',
        group: 'Grupo',
        group_required: 'El grupo es obligatorio',
        group_placeholder: 'Seleccionar grupo',
        fail_save: 'Error al guardar empleado',
        first_name: 'Nombre',
        first_name_placeholder: 'Ingresa el nombre',
        first_name_required: 'Por favor ingresa el nombre',
        last_name: 'Apellido',
        last_name_placeholder: 'Ingresa el apellido',
        last_name_required: 'Por favor ingresa el apellido',
        email: 'Correo',
        email_placeholder: 'Ingresa el correo',
        email_required: 'Por favor ingresa el correo',
        email_invalid: 'Por favor ingresa un correo válido',
        add_title: 'Agregar Nuevo Empleado',
        edit_title: 'Editar Empleado',
      },
      employee_management: {
        company_id_missing: 'ID de compañía no disponible para obtener empleados',
        service_unavailable: 'Servicio de empleados no disponible',
        fetch_error: 'Error al obtener empleados:',
        load_failed: 'Error al cargar empleados',
        load_error_generic: 'Ocurrió un error inesperado al cargar empleados',
        company_id_not_found: 'ID de compañía no encontrado',
        create_service_unavailable: 'Servicio de creación de empleados no disponible',
        create_failed: 'Error al crear empleado',
        create_success: '¡Empleado creado exitosamente!',
        create_error_generic: 'Ocurrió un error inesperado al crear el empleado',
        no_selection: 'Ningún empleado seleccionado para editar',
        update_service_unavailable: 'Servicio de actualización de empleados no disponible',
        update_failed: 'Error al actualizar empleado',
        update_success: '¡Empleado actualizado exitosamente!',
        update_error_generic: 'Ocurrió un error inesperado al actualizar el empleado',
        delete_service_unavailable: 'Servicio de eliminación de empleados no disponible',
        delete_title: 'Eliminar Empleado',
        delete_confirm: '¿Estás seguro de que quieres eliminar este empleado?',
        yes: 'Sí',
        no: 'No',
        delete_failed: 'Error al eliminar empleado',
        delete_success: '¡Empleado eliminado exitosamente!',
        delete_error_generic: 'Ocurrió un error inesperado al eliminar el empleado',
        employees_title: 'Empleados ({{count}})',
        add_employee: 'Agregar Empleado',
        no_employees: 'No se encontraron empleados',
        col_name: 'Nombre',
        col_email: 'Correo',
        col_job_title: 'Puesto',
        col_department: 'Departamento',
        col_employment_type: 'Tipo de Empleo',
        col_actions: 'Acciones',
        tooltip_edit: 'Editar empleado',
        tooltip_delete: 'Eliminar empleado',
        import_csv: 'Importar CSV',
        groups: 'Grupos',
        col_status: 'Estado',
        toggle_enabled: 'Empleado habilitado exitosamente',
        toggle_disabled: 'Empleado deshabilitado exitosamente',
        toggle_failed: 'Error al cambiar estado del empleado',
        toggle_error: 'Error al cambiar estado del empleado',
        toggle_limit_reached: 'No se puede habilitar - límite de empleados alcanzado',
        col_group: 'Grupo',
      },
      verified_domains: {
        title: 'Dominios Verificados',
        description:
          'Agrega dominios que los empleados pueden usar para sus direcciones de email. Solo se pueden agregar emails de dominios verificados.',
        placeholder: 'ej., ejemplo.com',
        add: 'Agregar',
        empty: 'No hay dominios verificados. Agrega dominios para permitir emails de empleados.',
        domain_added: 'Dominio agregado exitosamente',
        domain_removed: 'Dominio eliminado exitosamente',
        add_error: 'Error al agregar dominio',
        remove_error: 'Error al eliminar dominio',
        validation_disabled_notice: 'La validación de dominios fue deshabilitada por el administrador del sistema.',
      },
      employee_risk_dashboard: {
        page_title_brand: 'Ciphia',
        page_title: 'Dashboard',
        page_helmet_title: 'Ciphia Dashboard',
        no_risk_data_title: 'No hay datos de riesgo disponibles',
        no_risk_data_desc:
          'Las evaluaciones de riesgo de los empleados aparecerán aquí una vez que se completen los escenarios',
        company_risk: 'Riesgo Total',
        total_employees: 'Empleados',
        high_risk: 'Riesgo Alto',
        medium_risk: 'Riesgo Medio',
        low_risk: 'Riesgo Bajo',
        risk_assessment_title: 'Eval. de Riesgo',
        filter_all: 'Todos',
        filter_high: 'Alto',
        filter_medium: 'Medio',
        filter_low: 'Bajo',
        no_employees_found: 'No se encontraron empleados para el filtro seleccionado',
        try_different_filter: 'Intenta seleccionar un nivel de riesgo diferente',
        risk_score: 'Puntaje de Riesgo: {{score}}',
        score: 'Puntaje: {{score}}',
        scenarios: 'Escenarios: {{count}}',
        phishing_count: 'Simulaciones: {{count}}',
        never: 'Nunca',
        risk: 'Riesgo:',
        employees: 'empleados',
        total: 'Total',
        group_risk_title: 'Riesgo por Grupo',
        diagnostic_history: 'Historial de Escenarios',
        no_history: 'No hay historial de escenarios disponible.',
        col_date: 'Fecha',
        col_scenario: 'Escenario',
        col_risk_score: 'Puntaje',
        col_risk_level: 'Nivel',
        col_passed: 'Resultado',
        passed: 'Aprobado',
        failed: 'Fallido',
        no_history_table: 'Sin historial de escenarios',
        risk_level_high: 'Alto',
        risk_level_medium: 'Medio',
        risk_level_low: 'Bajo',
        category_Identity___Access_Security: 'Identidad y acceso',
        category_Network___Infrastructure_Security: 'Red e infraestructura',
        category_Device___Data_Protection: 'Dispositivos y datos',
        category_Human_Centric_Security: 'Factor humano',
        risk_distribution_title: 'Distribución',
        category_risk_profile: 'Perfil de Riesgo',
        risk_trend_title: 'Tendencia de Riesgo',
        view_plan: 'Ver plan →',
        no_trend_data: 'Todavía no hay datos de tendencia disponibles',
        no_category_data: 'Sin datos de categorías aún',
        complete_scenarios: 'Completa escenarios para ver riesgo por categoría',
        categories: {
          account_password: 'Cuentas y contraseñas',
          phishing_email: 'Phishing y seguridad del email',
          phishing_awareness: 'Comportamiento ante simulaciones de phishing',
          device_security: 'Seguridad del dispositivo',
          data_privacy: 'Manejo de datos y privacidad',
          safe_browsing_saas: 'Navegación segura y uso de SaaS',
          ai_emerging_threats: 'IA y amenazas emergentes',
        },
        disabled_indicator: 'Deshabilitado',
        show_disabled: 'Mostrar deshabilitados',
        hide_disabled: 'Ocultar deshabilitados',
        filter_include_disabled: 'Incluir deshabilitados',
        cta_launch_diagnostic: 'Lanzar diagn\u00f3stico',
        cta_launch_simulation: 'Lanzar simulaci\u00f3n',
        cta_launch_control_audit: 'Lanzar Auditoría',
        send_training: 'Enviar capacitaci\u00f3n',
        // Phishing stats
        dashboard_phishing_title: '\u00daltima Simulaci\u00f3n de Phishing',
        dashboard_phishing_fall_rate: 'Tasa de Ca\u00edda',
        dashboard_phishing_sent: 'Enviados',
        dashboard_phishing_clicked: 'Clicados',
        dashboard_phishing_fell: 'Ca\u00eddos',
        dashboard_phishing_channel: 'Canal',
        dashboard_phishing_no_data: 'No hay simulaciones de phishing completadas',
        // Control vulnerabilities
        dashboard_control_vulns_title: 'Últimas Vulnerabilidades de Controles',
        dashboard_control_vulns_unfixed: '{{count}} sin corregir',
        dashboard_control_vulns_no_data: 'No hay evaluaciones de controles realizadas',
      },
      diagnostic_conversation: {
        textarea_placeholder: 'Escribe tu mensaje...',
        select_option_placeholder: 'Por favor selecciona una opción arriba',
        send_message: 'Enviar mensaje',
        load_problem: 'Hubo un problema al cargar la conversación del escenario.',
        load_error: 'No se puede cargar la conversación',
        diagnostic: 'Escenario',
        thinking: 'Pensando...',
        your_selection: 'Tu selección',
        error: 'Error',
      },
      posture: {
        improved_title: '¡Excelente!',
        improved:
          'Tu postura de seguridad mejoró. Cada vez estás más preparado para protegerte y proteger a tu organización. ¡Sigue así!',
        worsened_title: '¡Sigue aprendiendo!',
        worsened:
          'Tu postura de seguridad disminuyó. Pero no te preocupes, ¡es parte del proceso de aprendizaje! Mira este breve video para fortalecer tus habilidades.',
        worsened_super:
          'Tu postura de seguridad disminuyó. Pero no te preocupes, ¡es parte del proceso de aprendizaje! Presta atención a estos temas en tu rutina diaria y verás la mejora.',
        video_intro: 'Este breve video te ayudará a reforzar lo que acabas de aprender.',
        video_completed:
          '¡Gracias por ver el video! Estás construyendo hábitos de seguridad más fuertes con cada paso.',
        learning_recap: 'Puntos clave',
      },
      training: {
        header: 'Capacitación',
        completed_title: '¡Capacitación completada!',
        completed_sub: 'Tu progreso fue guardado. Puedes cerrar esta ventana.',
        error_legend: 'Hubo un problema al cargar la capacitación.',
        load_error: 'No se pudo cargar el video',
      },
      super_scenario: {
        results_title: 'Tus resultados por categoría',
        result_title_singular: 'Tu resultado en esta categoría',
        generating_feedback: 'Generando recomendaciones...',
        recommendations: 'Recomendaciones',
      },
      diagnostic_results: {
        not_found: 'Escenario no encontrado',
        not_found_desc: 'El escenario solicitado no pudo ser encontrado.',
        back_to_diagnostics: 'Volver a Escenarios',
        loading_error: 'Error al cargar datos del escenario',
        export_success: 'Resultados exportados exitosamente',
        title: 'Resultados del Escenario: {{topic}}',
        created_on: 'Creado el {{date}}',
        completed_on: 'Completado el {{date}}',
        performance_records: '{{count}} registros de rendimiento',
        view_analytics: 'Ver Analíticas',
        export_results: 'Exportar Resultados',
        status_completed: 'Completado',
        status_in_progress: 'En Progreso',
        total_participants: 'Total Participantes',
        completion_rate: 'Tasa de Finalización',
        participation_rate: 'Tasa de Participación',
        stat_completed: 'Completados',
        tab_overview: 'Resumen',
        tab_participants: 'Participantes',
        tab_performance: 'Analíticas de Rendimiento',
        card_participation: 'Resumen de Participación',
        card_progress: 'Detalles de Progreso',
        no_participation_data: 'No hay datos de participación disponibles',
        label_overall_completion: 'Finalización General',
        label_completed: 'Completados',
        label_in_progress: 'En Progreso',
        label_not_started: 'No Iniciados',
        participants_count: '{{count}} participantes',
        card_diagnostic_info: 'Información del Escenario',
        label_topic: 'Tema:',
        label_client: 'Cliente:',
        label_status: 'Estado:',
        label_created: 'Creado:',
        label_started: 'Iniciado:',
        label_finished: 'Finalizado:',
        label_additional_info: 'Información Adicional:',
        no_additional_info: 'No se proporcionó información adicional.',
        card_participant_details: 'Detalles de Participantes',
        col_participant: 'Participante',
        col_status: 'Estado',
        col_score: 'Puntuación',
        col_duration: 'Duración',
        col_actions: 'Acciones',
        btn_view_results: 'Ver Resultados',
        btn_performance: 'Rendimiento',
        label_duration: 'Duración: {{minutes}}m',
        label_retries: 'Reintentos: {{count}}',
        label_videos: 'Videos: {{count}}',
        card_user_scores: 'Puntuaciones de Usuarios y Tiempos',
        chart_score: 'Puntuación (%)',
        chart_time: 'Tiempo (min)',
        card_risk_distribution: 'Distribución de Riesgo',
        no_performance_data: 'No hay datos de rendimiento disponibles',
        no_risk_data: 'No hay datos de riesgo disponibles',
        card_video_engagement: 'Interacción con Video',
        chart_videos_watched: 'Videos Vistos',
        chart_watch_time: 'Tiempo Total de Visualización (s)',
        no_video_data: 'No hay datos de interacción con video disponibles',
        card_scenario_steps: 'Análisis de Pasos del Escenario',
        chart_passed: 'Aprobado',
        chart_failed: 'Fallido',
        no_step_data: 'No hay datos de análisis de pasos disponibles',
        tab_insights: 'Insights de IA',
        card_overall_insights: 'Insights Generales del Escenario',
        card_individual_insights: 'Insights Individuales de Participantes',
        default_participant: 'Participante {{index}}',
        risk_low: 'Riesgo Bajo',
        risk_medium: 'Riesgo Medio',
        risk_high: 'Riesgo Alto',
        drawer_title: 'Detalles de Rendimiento - {{user}}',
        card_overall_performance: 'Rendimiento General',
        stat_final_score: 'Puntuación Final',
        stat_risk_level: 'Nivel de Riesgo',
        stat_completion_time: 'Tiempo de Finalización',
        card_step_performance: 'Rendimiento de Pasos',
        stat_steps_passed: 'Pasos Aprobados',
        stat_steps_failed: 'Pasos Fallidos',
        stat_success_rate: 'Tasa de Éxito',
        label_failed_steps: 'Pasos Fallidos:',
        card_engagement_metrics: 'Métricas de Interacción',
        stat_videos_watched: 'Videos Vistos',
        stat_retries: 'Reintentos',
        stat_hints_used: 'Pistas Usadas',
        card_improvement_areas: 'Áreas de Mejora',
        card_recommended_training: 'Entrenamiento Recomendado',
        modal_analytics_title: 'Tablero de Analíticas Integral',
        btn_close: 'Cerrar',
      },
      activation: {
        pending_title: 'Tu cuenta está pendiente de activación',
        pending_body: 'Un operador de Ciphia va a habilitar tu workspace y contactarte en breve.',
      },
      schedules: {
        weekly_schedules: 'Programaciones semanales',
        executed_this_week: 'Ejecutadas esta semana',
        page_helmet_title: 'Agenda',
        title: 'Agenda',
        add_schedule: 'Agregar programación',
        load_failed: 'Error al cargar las programaciones',
        update_failed: 'Error al actualizar la programación',
        update_success: 'Programación actualizada',
        create_failed: 'Error al crear la programación',
        create_success: 'Programación creada',
        delete_failed: 'Error al eliminar la programación',
        delete_success: 'Programación eliminada',
        unexpected_error: 'Ocurrió un error inesperado',
        count_schedules: '{{active}}/{{limit}} programaciones',
        executions_this_week: 'Ejecuciones esta semana: {{count}}/{{limit}}',
        delete_modal_title: 'Eliminar programación',
        delete_modal_ok: 'Eliminar',
        delete_modal_content: '¿Seguro que deseas eliminar "{{name}}"?',
        delete_modal_content_fallback: '¿Seguro que deseas eliminar esta programación?',
        run_now_confirm_title: '¿Ejecutar escenario ahora?',
        run_now_confirm_content:
          'Se ejecuta la misma entrega que dispararía el cron: un escenario adaptado por IA le llega ya a cada empleado objetivo en vez de esperar al próximo turno. El límite semanal de ejecuciones sigue aplicando.',
        run_now_confirm_ok: 'Ejecutar ahora',
        run_now_enqueued: 'Escenario en cola: los mensajes llegarán en breve.',
        run_now_failed: 'No se pudo encolar el escenario. Intentá de nuevo.',
        limit_exceeded_title: 'Se excedió el límite semanal',
        limit_exceeded_desc:
          'Algunas programaciones están en pausa. Desactiva o elimina las programaciones excedentes, o actualiza tu plan.',
        calendar: {
          columns: { day: 'Día', time: 'Hora', target: 'Objetivo', name: 'Nombre', active: 'Activo' },
          empty: 'Aún no hay escenarios programados',
          create_first: 'Crea tu primera programación',
          no_schedules: 'Sin programaciones',
          one_time_schedules: 'Ejecuciones Unicas',
          completed: 'Completado',
          scheduled_for: 'Programado para',
          no_recurring: 'Aún no hay programaciones recurrentes',
          add_recurring: 'Agregar Programación Recurrente',
          targets: {
            all_employees: 'Todos los empleados',
            groups: '{{count}} grupos',
          },
          tooltips: {
            over_weekly_limit: 'Se excedió el límite semanal',
            pause: 'Pausar',
            activate: 'Activar',
          },
        },
        modal: {
          create_title: 'Nuevo escenario programado',
          edit_title: 'Editar programación',
          schedule_type: {
            recurring: 'Recurrente (semanal)',
            once: 'Una sola vez',
          },
          fields: {
            name_label: 'Nombre (opcional)',
            name_placeholder: 'Ej.: Capacitación semanal de seguridad',
            schedule_type_label: 'Tipo de Programación',
            day_label: 'Día',
            day_placeholder: 'Seleccionar día',
            time_label: 'Hora',
            time_placeholder: 'Seleccionar hora',
            date_label: 'Fecha',
            date_placeholder: 'Seleccionar fecha',
            execute_at_label: 'Fecha y Hora de Envío',
            timezone_label: 'Zona horaria',
            timezone_placeholder: 'Seleccionar zona horaria',
            target_audience_label: 'Audiencia objetivo',
            target_groups_label: 'Grupos objetivo',
            target_employees_label: 'Empleados objetivo',
            delivery_channel_label: 'Canal de entrega',
            language_label: 'Idioma del Email',
            scenario_label: 'Escenario',
            scenario_placeholder: 'Aleatorio (selección automática)',
            scenario_tooltip: 'Selecciona un escenario específico o deja vacío para selección aleatoria',
            adapt_scenarios_label: 'Adaptación de Escenario con IA',
            adapt_scenarios_tooltip:
              'Usa IA para personalizar la introducción del escenario al rubro y departamento del grupo objetivo. Las preguntas y puntuación permanecen idénticas.',
          },
          validation: {
            select_one_group: 'Selecciona al menos un grupo',
            select_one_employee: 'Selecciona al menos un empleado',
          },
          target: {
            all: 'Todos los empleados',
            groups: 'Grupos específicos{{suffix}}',
            employees: 'Empleados específicos{{suffix}}',
            pro_only: 'Solo Pro/Enterprise',
          },
          delivery: {
            web: 'Web (link por email)',
          },
          note: {
            title: 'Nota:',
            body: 'Al momento de ejecutarse, el sistema seleccionará automáticamente un escenario que los empleados objetivo aún no hayan completado.',
          },
          actions: {
            delete: 'Eliminar',
            run_now: 'Ejecutar ahora',
            save_changes: 'Guardar cambios',
            create: 'Crear programación',
          },
          section: {
            when: 'Cuándo',
            who: 'A quién',
            what: 'Qué',
          },
          group_item: '{{name}} ({{count}} empleados)',
        },
      },
      training_page: {
        sidebar_title: 'Capacitación',
        page_helmet_title: 'Capacitación',
        title: 'Capacitación',
        groups_title: 'Grupos por Riesgo',
        employees_title: 'Empleados por Riesgo',
        group_column: 'Grupo',
        employee_column: 'Empleado',
        email_column: 'Email',
        risk_score_column: 'Puntaje de Riesgo',
        risk_level_column: 'Nivel de Riesgo',
        highest_risk_category_column: 'Categoría de Mayor Riesgo',
        employees_column: 'Empleados',
        send_training: 'Enviar Capacitación',
        no_category_data: 'Sin datos',
        no_group_data: 'Aún no hay grupos con datos de riesgo',
        no_employee_data: 'Aún no hay empleados con datos de riesgo',
        schedule_modal_title: 'Programar Capacitación',
        schedule_modal_category_label: 'Categoría',
        schedule_modal_category_placeholder: 'Seleccionar categoría',
        schedule_modal_video_label: 'Video',
        schedule_modal_video_placeholder: 'Aleatorio (auto-selección)',
        schedule_modal_video_random: 'Aleatorio (auto-selección)',
        schedule_modal_date_label: 'Fecha',
        schedule_modal_time_label: 'Hora',
        schedule_modal_name_label: 'Nombre (opcional)',
        schedule_modal_name_placeholder: 'ej. Capacitación Phishing Q1',
        schedule_modal_language_label: 'Idioma',
        schedule_modal_target_label: 'Audiencia Objetivo',
        schedule_modal_target_all: 'Todos los Empleados',
        schedule_modal_target_groups: 'Grupo Específico',
        schedule_modal_target_employees: 'Empleados Específicos',
        schedule_modal_submit: 'Programar Capacitación',
        schedule_modal_cancel: 'Cancelar',
        create_success: 'Capacitación programada exitosamente',
        create_failed: 'Error al programar capacitación',
        load_failed: 'Error al cargar datos de capacitación',
        history_title: 'Historial de Capacitaciones',
        history_name: 'Nombre',
        history_target: 'Destinatarios',
        history_category: 'Categoría',
        history_scheduled: 'Programado Para',
        history_status: 'Estado',
        history_completion: 'Completado',
        history_no_data: 'No hay capacitaciones programadas',
        history_target_all: 'Todos los Empleados',
        history_target_group: 'Grupo: {{name}}',
        history_target_employees: '{{count}} empleado(s)',
        group_completion: 'Capacitación Completada',
        group_no_training: 'Sin datos de capacitación',
        status_pending: 'Pendiente',
        status_processing: 'Procesando',
        status_sent: 'Enviado',
        status_completed: 'Completado',
        status_failed: 'Fallido',
        status_cancelled: 'Cancelado',
      },
      common: {
        send: 'Enviar',
        yes: 'Sí',
        no: 'No',
        required: 'Requerido',
        cancel: 'Cancelar',
        delete: 'Eliminar',
        ai_powered_badge: 'Con IA',
        days: {
          monday: 'Lunes',
          tuesday: 'Martes',
          wednesday: 'Miércoles',
          thursday: 'Jueves',
          friday: 'Viernes',
          saturday: 'Sábado',
          sunday: 'Domingo',
        },
      },
      addons_page: {
        title_brand: 'Ciphia',
        title: 'Complementos',
        subtitle: 'Servicios premium para llevar tu seguridad al siguiente nivel',
        services: {
          compliance: {
            title: 'Cumplimiento',
            description:
              'Haz seguimiento de tu preparación para SOC 2, ISO 27001 y GDPR con los controles Core 40 unificados.',
            features: [
              'Preparación para SOC 2 Tipo I',
              'Seguimiento de cumplimiento ISO 27001',
              'Checklist de requisitos GDPR',
              'Gestión de evidencias y documentación',
            ],
          },
          phishing: {
            title: 'Simulaciones',
            description:
              'Campañas de phishing personalizadas para tu organización para evaluar y mejorar la conciencia de los empleados.',
            features: [
              'Plantillas de emails realistas',
              'Analíticas detalladas de clics y reportes',
              'Puntaje de riesgo por empleado',
              'Personalizado para tu industria',
            ],
          },
          pentesting: {
            title: 'Pentesting',
            description:
              'Pruebas de penetración profesionales realizadas por expertos certificados para identificar vulnerabilidades.',
            features: [
              'Testing de aplicaciones web',
              'Evaluación de seguridad de red',
              'Informe detallado de vulnerabilidades',
              'Guía de remediación',
            ],
          },
          training: {
            title: 'Capacitaciones',
            description: 'Sesiones en vivo con profesionales de ciberseguridad, adaptadas a tu equipo.',
            features: [
              'Contenido personalizado',
              'Talleres interactivos',
              'Sesiones de preguntas y respuestas',
              'Ejercicios prácticos',
            ],
          },
        },
        active: 'Activo',
        contact_sales: 'Contactar Ventas',
        go_to: 'Ir a {{title}}',
      },
      phishing: {
        // Phishing messages
        load_failed: 'Error al cargar datos de phishing',
        campaign_created: 'Campaña creada exitosamente',
        email_campaign_created: 'Campaña de email creada exitosamente',
        email_campaign_create_failed: 'Error al crear campaña de email',

        // Delete campaign
        delete_title: 'Eliminar Campaña',
        delete_confirm: '¿Estás seguro de que quieres eliminar "{{name}}"? Esta acción no se puede deshacer.',
        delete_ok: 'Eliminar',
        delete_failed: 'Error al eliminar campaña',
        deleted: 'Campaña eliminada',

        // Archive campaign
        archive_title: 'Archivar Campaña',
        archive_confirm: '¿Estás seguro de que quieres archivar "{{name}}"? Puedes desarchivarla después.',
        archive_ok: 'Archivar',
        archive_failed: 'Error al archivar campaña',
        archived: 'Campaña archivada',

        // Unarchive campaign
        unarchive_failed: 'Error al desarchivar campaña',
        unarchived: 'Campaña desarchivada',

        // Finish campaign
        finish_title: 'Finalizar Campaña',
        finish_confirm:
          '¿Estás seguro de que quieres finalizar "{{name}}"? Esto detendrá el seguimiento de interacciones.',
        finish_ok: 'Finalizar Campaña',
        finish_failed: 'Error al finalizar campaña',
        finished: 'Campaña finalizada',

        // Launch campaign
        launch_title: 'Lanzar Campaña',
        launch_confirm:
          '¿Estás seguro de que quieres lanzar "{{name}}"? Esto enviará mensajes de phishing a {{count}} empleados.',
        launch_confirm_qr:
          '¿Estás seguro de que quieres lanzar "{{name}}"? Esto activará la landing page de phishing QR.',
        launch_ok: 'Lanzar',
        launch_failed: 'Error al lanzar campaña',
        launched: 'Campaña lanzada exitosamente',
        complete_failed: 'Error al finalizar campaña',
        completed: 'Campaña finalizada',

        // Domain verification
        domains_load_failed: 'Error al cargar dominios',
        domain_enter_required: 'Por favor ingresa un dominio',
        domain_add_failed: 'Error al agregar dominio',
        domain_added: 'Dominio agregado. Por favor agrega el registro TXT para verificar la propiedad.',
        domain_verify_failed: 'Error en la verificación',
        domain_verified: '¡Dominio verificado exitosamente!',
        domain_verify_check_dns: 'La verificación del dominio falló. Por favor revisa tu configuración DNS.',
        domain_delete_title: 'Eliminar Dominio',
        domain_delete_confirm: '¿Estás seguro de que quieres eliminar "{{domain}}"?',
        domain_delete_failed: 'Error al eliminar dominio',
        domain_deleted: 'Dominio eliminado',
        copied_to_clipboard: '{{label}} copiado al portapapeles',

        // Custom templates
        template_button_required: 'El HTML del landing debe contener el placeholder {{BUTTON}}',
        template_update_failed: 'Error al actualizar plantilla',
        template_updated: 'Plantilla actualizada',
        template_create_failed: 'Error al crear plantilla',
        template_created: 'Plantilla creada',
        template_delete_failed: 'Error al eliminar plantilla',
        template_deleted: 'Plantilla eliminada',

        // Bot config / slug
        slug_min_length: 'El slug debe tener al menos 3 caracteres',
        slug_update_failed: 'Error al actualizar slug',
        slug_updated: 'Slug de URL de la empresa actualizado',

        // Modal messages
        campaign_name_required: 'Por favor ingresa un nombre de campaña',
        image_only_error: '¡Solo puedes subir archivos de imagen!',
        icon_uploaded: 'Icono subido exitosamente',
        favicon_uploaded: 'Favicon subido exitosamente',
        logo_uploaded: 'Logo subido exitosamente',
        landing_button_required: 'El HTML del landing debe contener el placeholder {{BUTTON}}',
      },
      phishing_ui: {
        sender_domain_label: 'Dominio del remitente',
        sender_domain_hint:
          'El dominio por defecto de Ciphia funciona sin configuración. Verifica tu propio dominio en Configuración de Empresa para una prueba más realista.',
        // Page
        page_title: 'Simulaciones',
        page_description:
          'Hacé phishing a tu propio equipo, sin riesgo. Lanzá campañas de email o QR, vé quién cliquea y convertí cada error en un momento de capacitación.',

        // Tabs
        tab_email: 'Email',

        // Company Slug Section
        company_url_slug: 'Slug de URL de la Empresa',
        slug_description: 'Este slug aparece en las URLs de phishing para hacerlas más legítimas (ej., /t/',
        slug_placeholder: 'nombre-empresa',
        generate_from_company: 'Generar desde nombre de empresa',
        save: 'Guardar',
        slug_warning: 'Configura un slug de URL antes de lanzar simulaciones',

        // Domain Verification Section
        domain_verification_title: 'Verificación de Dominio',
        domain_verification_description:
          'Verifica la propiedad del dominio para asegurar la entregabilidad de emails en simulaciones de phishing.',
        add_domain: 'Agregar Dominio',
        domain_placeholder: 'ejemplo.com',
        domain_col: 'Dominio',
        status_col: 'Estado',
        txt_record_col: 'Registro TXT',
        status_pending: 'Pendiente',
        status_verified: 'Verificado',
        status_failed: 'Fallido',
        verify_btn: 'Verificar',
        dns_instructions_title: 'Cómo agregar Registro TXT (Instrucciones DNS)',
        dns_instructions_description:
          'Para verificar la propiedad del dominio, agrega un registro TXT a tu configuración DNS:',
        dns_general_instructions: 'Instrucciones Generales:',
        dns_name_host: 'Nombre/Host:',
        dns_type: 'Tipo:',
        dns_value: 'Valor:',
        dns_ttl: 'TTL:',
        dns_propagation_note:
          'Los cambios de DNS pueden tardar hasta 24-48 horas en propagarse, aunque a menudo se completan en minutos.',
        whitelist_title: 'Instrucciones de Lista Blanca de Email (Prevenir Filtro de Spam)',
        whitelist_warning_title: 'Configura la lista blanca de tu proveedor de email',
        whitelist_warning_description:
          'Antes de lanzar campañas de phishing por email, configura tu proveedor de email para permitir correos de notifyinbox.com.',

        // Simulations List
        simulations_title: 'Simulaciones',
        show_archived: 'Mostrar archivadas',
        new_simulation: 'Nueva Simulación',
        no_simulations: 'Sin simulaciones aún',
        create_first_simulation: 'Crea Tu Primera Simulación',
        no_archived_simulations: 'Sin simulaciones archivadas',
        col_simulation: 'Simulación',
        col_status: 'Estado',
        col_targets: 'Objetivos',
        col_launched: 'Lanzada',
        col_created: 'Creada',
        archived_tag: 'Archivada',
        status_draft: 'Borrador',
        status_scheduled: 'Programada',
        status_running: 'En Progreso',
        status_completed: 'Completada',
        action_view_stats: 'Ver Estadísticas',
        action_edit: 'Editar',
        action_launch: 'Lanzar',
        action_unarchive: 'Desarchivar',
        action_delete: 'Eliminar',
        action_finish: 'Finalizar',
        action_archive: 'Archivar',

        // Stats Modal
        campaign_statistics: 'Estadísticas de Campaña',
        stat_total: 'Total',
        stat_sent: 'Enviados',
        stat_clicked: 'Clics',
        stat_fell: 'Cayeron',
        campaign_metrics: 'Métricas de Campaña',
        click_rate: 'Tasa de Clics',
        scan_rate: 'Tasa de Escaneo',
        medium_risk: 'Riesgo Medio',
        fell_rate: 'Tasa de Caídas',
        high_risk: 'Riesgo Alto',
        template_label: 'Plantilla:',
        variant_label: 'Variante:',
        launched_label: 'Lanzada:',
        not_launched: 'No lanzada',
        status_label: 'Estado:',
        target_details: 'Detalles de Objetivos',
        col_employee: 'Empleado',
        col_sent: 'Enviado',
        col_clicked: 'Clic',
        col_outcome: 'Resultado',
        no_stats: 'No hay estadísticas disponibles',
        status_pending_label: 'Pendiente',
        status_sent_label: 'Enviado',
        status_clicked_label: 'Clic',
        status_fell_label: 'Cayó',

        // Stats Page
        stats_page_title: 'Estadísticas de Simulación',
        back_to_phishing: 'Volver a Phishing',
        launch_campaign: 'Lanzar Campaña',
        finish_campaign: 'Finalizar Campaña',
        archive: 'Archivar',
        campaign_risk: 'Riesgo de Campaña',
        total_targets: 'Total de Objetivos',
        messages_sent: 'Mensajes Enviados',
        clicked_link: 'Clic en Enlace',
        fell_for_phishing: 'Cayeron en Phishing',
        fell: 'Cayeron',
        qr_scans: 'Escaneos QR',
        risk_distribution: 'Distribución de Riesgo',
        risk_rates: 'Tasas de Riesgo',
        users_clicked_link: 'Usuarios que hicieron clic en el enlace',
        users_scanned_qr: 'Usuarios que escanearon el código QR',
        users_fell: 'Usuarios que cayeron en el phishing',
        campaign_details: 'Detalles de Campaña',
        template: 'Plantilla',
        variant: 'Variante',
        launched: 'Lanzada',
        target_results: 'Resultados de Objetivos',
        filter_all: 'Todos',
        filter_high: 'Alto',
        filter_medium: 'Medio',
        filter_low: 'Bajo',
        no_targets_filter: 'No se encontraron objetivos para el filtro seleccionado',
        campaign_not_found: 'Campaña no encontrada o sin estadísticas disponibles',
        finish_confirm_stats:
          '¿Estás seguro de que quieres finalizar esta campaña? Esto detendrá el seguimiento de interacciones.',
        launch_confirm_stats:
          '¿Estás seguro de que quieres lanzar esta campaña? Esto enviará mensajes de phishing a {{count}} empleados.',
        archive_confirm_stats: '¿Estás seguro de que quieres archivar esta campaña? Puedes desarchivarla después.',
        finish_success: 'Campaña finalizada exitosamente',

        // Campaign Modal
        create_campaign: 'Crear Campaña',
        schedule_campaign: 'Programar Campaña',
        edit_campaign: 'Editar Campaña',
        step_template: 'Plantilla',
        step_targets: 'Objetivos',
        step_review: 'Revisar',
        cancel: 'Cancelar',
        back: 'Atrás',
        next: 'Siguiente',
        schedule_date: 'Programar para',
        schedule_placeholder: 'Dejar vacío para lanzar manualmente',
        campaign_name: 'Nombre de Campaña',
        campaign_name_placeholder: 'ej., Test de Seguridad Q1 2025',
        template_type: 'Tipo de Plantilla',
        core_templates: 'Plantillas Base',
        custom_templates: 'Plantillas Personalizadas',
        select_template: 'Seleccionar Plantilla',
        select_variant: 'Seleccionar Variante',
        select_custom_template: 'Seleccionar Plantilla Personalizada',
        no_custom_templates: 'Sin plantillas personalizadas aún',
        create_custom_template: 'Crear Plantilla Personalizada',
        manage_custom_templates: 'Gestionar Plantillas Personalizadas',
        landing_tag: '+ Landing',

        // Target Step
        target_selection: 'Selección de Objetivos',
        all_employees: 'Todos los Empleados',
        specific_group: 'Grupo Específico',
        specific_groups: 'Grupos Específicos',
        specific_employees: 'Empleados Específicos',
        select_group: 'Seleccionar Grupo',
        select_groups: 'Seleccionar Grupos',
        select_employees: 'Seleccionar Empleados',
        search_employees: 'Buscar y seleccionar empleados',
        employees_targeted: '{{count}} empleado(s) serán objetivo',

        // Review Step
        campaign_summary: 'Resumen de Campaña',
        channel_label: 'Canal:',
        template_name_label: 'Plantilla:',
        variant_name_label: 'Variante:',
        bot_name_label: 'Nombre del Bot:',
        targets_label: 'Objetivos:',
        employees_count: '{{count}} empleados',
        landing_page_label: 'Página de Landing:',
        yes: 'Sí',
        no: 'No',

        // Bot Appearance
        bot_appearance: 'Apariencia del Bot',
        bot_name: 'Nombre del Bot',
        bot_name_placeholder: 'ej., Alerta de Seguridad',
        bot_icon: 'Icono del Bot (opcional)',
        upload_icon: 'Subir Icono',

        // Landing Page
        landing_page_config: 'Configuración de Página de Landing',
        language: 'Idioma',
        page_title_label: 'Título de Página',
        page_title_placeholder: 'Iniciar Sesión',
        favicon_label: 'Favicon (opcional)',
        upload_favicon: 'Subir Favicon',
        logo_label: 'Logo (opcional)',
        upload_logo: 'Subir Logo',

        // Email Campaign Modal
        create_email_simulation: 'Crear Simulación de Email',
        edit_email_simulation: 'Editar Simulación de Email',
        select_email_template: 'Seleccionar Plantilla de Email',
        select_template_placeholder: 'Selecciona una plantilla',
        sender_email_address: 'Dirección de Email del Remitente',
        sender_suggestions: 'Sugeridos: security, it-support, helpdesk, admin',
        sender_display_name: 'Nombre para Mostrar del Remitente',
        sender_display_hint: 'Este nombre aparece en el campo "De":',
        email_subject: 'Asunto del Email',
        email_subject_placeholder: 'Acción Requerida: Restablecer Contraseña',
        email_language: 'Idioma del Email',
        email_language_hint: 'Idioma para el contenido del email de phishing',
        select_recipients: 'Seleccionar Destinatarios',
        all_employees_count: 'Todos los Empleados ({{count}})',
        select_group_option: 'Seleccionar Grupo',
        select_groups_option: 'Seleccionar Grupos',
        select_employees_option: 'Seleccionar Empleados Individuales',
        employees_receive_email: '{{count}} empleado(s) recibirán el email de phishing',
        channel: 'Canal',
        from_label: 'De:',
        subject_label: 'Asunto:',
        recipients_label: 'Destinatarios:',
        email_preview: 'Vista Previa del Email',
        save_changes: 'Guardar Cambios',

        // QR Phishing
        tab_qr: 'Código QR',
        qr_description:
          'Crea simulaciones de phishing con códigos QR. Imprime y distribuye códigos QR para probar la conciencia de los empleados.',
        create_qr_simulation: 'Crear Simulación QR',
        edit_qr_simulation: 'Editar Simulación QR',
        qr_codes_title: 'Códigos QR',
        qr_codes_description:
          'Descarga e imprime códigos QR para distribución. Cada empleado recibe un código QR único para seguimiento.',
        download_all_qr: 'Descargar Todos los QR',
        download_qr: 'Descargar QR',
        qr_code_for: 'Código QR para {{name}}',
        no_qr_codes: 'No hay códigos QR generados aún',
        qr_codes_ready: 'Los códigos QR están listos para descargar',
        qr_campaign_info:
          'Las campañas QR generan un único código QR para toda la empresa. Cualquiera que lo escanee verá una página de phishing donde ingresan su correo.',
        print_qr_codes: 'Imprimir Códigos QR',
        qr_generated: '{{count}} código(s) QR generado(s)',
        view_qr_codes: 'Ver Códigos QR',
        // Company-wide QR
        qr_company_wide_title: 'QR para toda la Empresa',
        qr_company_wide_description:
          'Este código QR funcionará para cualquier persona que lo escanee. Al lanzar, obtendrás una imagen QR para descargar e imprimir/compartir. Los usuarios que lo escaneen verán una página de phishing que pide su correo.',
        landing_page_title_optional: 'Título de Página de Destino (opcional)',
        qr_landing_title_help:
          'Título personalizado mostrado en la página de destino. Si está vacío, se usará uno por defecto.',
        qr_logo_optional: 'Logo de la Empresa (opcional)',
        qr_logo_help: 'Logo mostrado en la parte superior de la página de destino. Máx 2MB.',
        qr_stats_block_title: 'Código QR',
        qr_stats_scan_hint: 'Escaneá o compartí este código. Cada escaneo se registra debajo.',
        qr_copy_url: 'Copiar URL de escaneo',
        qr_url_copied: 'URL copiada al portapapeles',
        qr_copy_url_failed: 'No se pudo copiar la URL',
        section: {
          campaign: 'Campaña',
          landing_optional: 'Página de destino (opcional)',
        },

        // Phase 109 — AI phishing admin preview namespace.
        // Plan 07 performs the full localization pass; this scaffold uses
        // UI-SPEC Copywriting Contract strings verbatim so plans 03-06 can
        // reference `t('phishing_ui.ai.*')` without runtime errors.
        ai: {
          tab_preview: 'Vista previa',
          iframe_title: 'Vista previa del email de phishing',

          mode_question: '¿Cómo se generan los emails?',
          mode_template: 'Plantilla',
          mode_template_helper: 'Enviar la misma plantilla a todos',
          mode_ai: 'Con IA',
          mode_ai_helper: 'Personalizar cada email por empleado',

          eligibility_chip_eligible: 'Atlas',
          eligibility_chip_ineligible: 'Sin Atlas',
          eligibility_tooltip_ineligible:
            '{{name}} no tiene jefe ni colaboradores en Atlas — recibirá la plantilla de respaldo',
          eligibility_counter: '{{n}} de {{total}} empleados elegibles para IA',
          eligibility_error:
            'No se pudo cargar la elegibilidad. Puedes continuar; los empleados no elegibles recibirán la plantilla de respaldo.',

          progress_counter: '{{processed}} de {{total}} procesados',
          review_counter: '{{count}} requieren revisión humana',
          status_processing: 'Procesando…',
          launch_tooltip_disabled: 'Procesando — intenta en un momento',

          admin_edited: 'Editado por admin',
          admin_edited_banner_absolute: 'Editado por admin el {{date}}',

          verdict_tone_match: 'Alineación de tono',
          verdict_leak_risk: 'Riesgo de fuga',
          verdict_injection_risk: 'Riesgo de inyección',
          verdict_language_consistency: 'Consistencia de idioma',
          verdict_personalization_overfit: 'Sobreajuste de personalización',
          verdict_quality_issues: 'Notas de calidad',
          verdict_value_aligned: 'alineado',
          verdict_value_mismatch: 'no alineado',
          verdict_value_none: 'ninguno',
          verdict_value_low: 'bajo',
          verdict_value_medium: 'medio',
          verdict_value_high: 'alto',
          verdict_value_consistent: 'consistente',
          verdict_value_inconsistent: 'inconsistente',

          status_ready: 'Listo',
          status_needs_review: 'Requiere revisión',
          status_failed: 'Fallado',
          status_fallback: 'Plantilla de respaldo',
          status_generating: 'Generando…',
          status_paused: 'Pausado',
          status_sent: 'Enviado',
          status_clicked: 'Clicado',
          status_fell: 'Cayó',

          action_regenerate: 'Regenerar',
          action_mark_ready: 'Marcar como listo',
          action_edit: 'Editar',
          action_save_approve: 'Guardar y aprobar',
          action_cancel_edit: 'Cancelar edición',
          action_close: 'Cerrar',
          action_launch: 'Lanzar campaña',
          action_regenerate_all_flagged: 'Regenerar todos los marcados',
          action_complete: 'Finalizar campaña',
          action_cancel_complete: 'Seguir activa',
          complete_confirm_title: '¿Finalizar esta campaña?',
          complete_confirm_body:
            'No se registrarán más eventos (enviado / clicado / cayó) después de esto. La campaña pasará a Completada y no se puede reabrir.',
          action_open_details: 'Ver detalles',

          subject_label: 'Asunto',
          body_label: 'Cuerpo (HTML)',
          live_preview: 'Vista previa en vivo',

          empty_pending:
            'La generación comenzará en instantes. Los destinatarios aparecerán aquí a medida que se procesen.',
          empty_no_eligible:
            'Ningún destinatario es elegible para generación con IA. Cancela esta campaña e intenta nuevamente con empleados que tengan relaciones en Atlas.',
          empty_eligibility_none:
            'Ninguno de los empleados seleccionados es elegible para IA — considera cambiar a modo Plantilla o seleccionar otros empleados.',

          error_regenerate: 'No se pudo regenerar — verifica tu conexión e intenta de nuevo',
          error_edit_save: 'No se pudo guardar — tus cambios siguen en el editor',
          error_mark_ready: 'No se pudo marcar como listo — intenta en un momento',
          error_polling_lost: 'Se perdió la conexión con la vista previa. Actualiza para reconectar.',

          launch_confirm_title: '¿Lanzar campaña?',
          launch_confirm_body: '{{flagged}} emails marcados se omitirán. ¿Lanzar {{approved}} emails aprobados?',
          regenerate_bulk_confirm_body: '¿Regenerar {{count}} emails marcados? Se descartará su contenido actual.',
          cancel_edit_confirm: '¿Descartar tus cambios?',

          skipped_no_atlas_explanation:
            'Este destinatario no tiene relaciones en Atlas y recibirá la plantilla de respaldo: {{templateName}}',

          fallback_template_label: 'Plantilla de respaldo para empleados no elegibles',

          spanish_variant_label: 'Variante de español',
          spanish_variant_neutral: 'Neutro (panhispánico, "tú")',
          spanish_variant_rioplatense: 'Rioplatense (AR/UY, "vos")',
          spanish_variant_hint:
            'Registro con el que la IA escribirá. Neutro sirve para audiencia panhispánica y España; Rioplatense usa voseo (AR/UY).',

          action_pause: 'Pausar generación',
          action_resume: 'Reanudar generación',
          pause_success: 'Generación IA pausada. Los targets en curso terminan; no se toman nuevos.',
          resume_success: 'Generación IA reanudada.',
          pause_error: 'No se pudo pausar la generación.',
          resume_error: 'No se pudo reanudar la generación.',

          verdict_pass: 'Pasa',
          verdict_fail: 'No pasa',
          verdict_pending: 'Pendiente',
          verdict_card_title: 'Verificación',
          action_back: 'Atrás',

          flagged_review_banner: 'Este email fue marcado — revísalo antes de aprobar',

          // Encabezados de columna de la tabla de vista previa (PREV-01)
          col_employee: 'Empleado',
          col_subject: 'Asunto',
          col_sender: 'Remitente',
          col_template: 'Plantilla',
          col_verdict: 'Verificación',
          col_status: 'Estado',
          col_actions: 'Acciones',

          // Barra de herramientas + contadores de encabezado
          bulk_regenerate_flagged: 'Regenerar todos los marcados',

          // Phase 110 D-01/D-03 — vocabulario de ciclo de vida derivado.
          lifecycle_not_started: 'No iniciada',
          lifecycle_generating: 'Generando contenido',
          lifecycle_in_review: 'Pendiente de revisión',
          lifecycle_ready: 'Lista para lanzar',
          lifecycle_started: 'En curso',
          lifecycle_finished: 'Finalizada',

          // Phase 110 D-05 — scheduledAt editable post-creación.
          scheduled_at_editable_label: 'Inicio programado',
          scheduled_at_save: 'Guardar',
          scheduled_at_min_hint: 'Debe ser al menos 1 minuto desde ahora',
          scheduled_at_error_started: 'No se puede reprogramar: la campaña ya está en curso',
          scheduled_at_error_finished: 'No se puede reprogramar: la campaña está finalizada',
        },
      },
      contact_modal: {
        // Enterprise/Sales
        enterprise_title: 'Contactar Ventas',
        enterprise_description: '¿Interesado en nuestro plan Enterprise? Nuestro equipo te contactará en 24 horas.',
        enterprise_success: '¡Gracias! Nuestro equipo de ventas te contactará pronto.',
        enterprise_placeholder: 'Cuéntanos sobre tus necesidades de capacitación en seguridad...',
        // Support
        support_title: 'Obtener Soporte',
        support_description: '¿Tienes un problema? Describe tu situación y nuestro equipo de soporte te ayudará.',
        support_success: 'Solicitud de soporte enviada. Te responderemos pronto.',
        support_placeholder: 'Describe tu problema...',
        // Feedback
        feedback_title: 'Enviar Comentarios',
        feedback_description: '¡Nos encantaría escucharte! Comparte tus ideas, sugerencias o comentarios.',
        feedback_success: '¡Gracias por tus comentarios!',
        feedback_placeholder: 'Comparte tus comentarios...',
        // Contact
        contact_title: 'Contáctanos',
        contact_description: '¿Tienes una pregunta? Nos encantaría saber de ti.',
        contact_success: '¡Gracias! Te responderemos pronto.',
        contact_placeholder: 'Tu mensaje...',
        // Addon
        addon_title: 'Solicitar Servicio Add-on',
        addon_description:
          '¿Interesado en este servicio premium? Nuestro equipo te contactará para discutir tus necesidades.',
        addon_success: '¡Gracias! Nuestro equipo te contactará pronto.',
        addon_placeholder: 'Cuéntanos sobre tus necesidades...',
        // Partner
        partner_title: 'Consulta de Partnership',
        partner_description:
          '¿Interesado en asociarte con Ciphia? Cuéntanos sobre tu organización e ideas de partnership.',
        partner_success: '¡Gracias! Nuestro equipo de partnerships te contactará pronto.',
        partner_placeholder: 'Cuéntanos sobre tus ideas de partnership...',
        // Sample Report
        sample_report_title: 'Ver Reporte de Ejemplo',
        sample_report_description:
          'Mira cómo es un Diagnóstico de Riesgo Humano. Ingresa tu email y te enviamos un reporte de ejemplo.',
        sample_report_success: '¡Gracias! Revisa tu bandeja de entrada para ver el reporte.',
        sample_report_placeholder: '¿Algún área específica que te gustaría ver?',
        // Form fields
        form_email: 'Email',
        form_emailRequired: 'Por favor ingresa tu email',
        form_emailInvalid: 'Por favor ingresa un email válido',
        form_name: 'Nombre (opcional)',
        form_namePlaceholder: 'Tu nombre',
        form_message: 'Mensaje',
        form_submit: 'Enviar',
        form_error: 'Error al enviar. Por favor intenta de nuevo.',
        form_companyName: 'Nombre de la Empresa',
        form_companyNameRequired: 'Por favor ingresa el nombre de tu empresa',
        form_companyNamePlaceholder: 'Tu empresa',
        form_employeeCount: 'Cantidad de Empleados',
        form_employeeCountRequired: 'Por favor ingresa la cantidad de empleados',
        form_employeeCountPlaceholder: 'ej. 50',
        // Add-on service names
        addonService_pentesting: 'Pentesting',
        addonService_training: 'Capacitación Experta',
        addonService_compliance: 'Certificación de Cumplimiento',
      },
      admin_campaigns: {
        // Campaign edit/create
        load_failed: 'Error al cargar discovery',
        logo_image_only: '¡Solo puedes subir archivos de imagen!',
        logo_uploaded: 'Logo subido exitosamente',
        logo_upload_failed: 'Error al subir logo',
        name_required: 'El nombre del discovery es requerido',
        company_name_required: 'El nombre de la empresa externa es requerido',
        contact_email_required: 'El correo de contacto es requerido',
        create_failed: 'Error al crear discovery',
        created: 'Discovery creado exitosamente',
        update_failed: 'Error al actualizar discovery',
        saved: 'Discovery guardado exitosamente',

        // User management
        user_add_failed: 'Error al agregar usuario',
        user_added: 'Usuario agregado',
        user_remove_failed: 'Error al eliminar usuario',
        user_removed: 'Usuario eliminado',
        import_failed: 'Error al importar usuarios',
        import_success: 'Importados {{created}} usuarios, {{skipped}} omitidos',

        // Public link
        link_generate_failed: 'Error al generar enlace',
        link_generated: 'Enlace público generado y copiado al portapapeles',
        link_disable_failed: 'Error al deshabilitar enlace',
        link_disabled: 'Enlace público deshabilitado',
        link_copied: 'Enlace copiado al portapapeles',

        // Campaign actions (start/complete/archive)
        start_title: 'Iniciar Discovery',
        start_confirm:
          '¿Estás seguro de que quieres iniciar este discovery? Una vez iniciado, no podrás editarlo ni agregar más usuarios. El escenario y el phishing por email se lanzarán según sus fechas programadas.',
        start_confirm_users:
          '¿Estás seguro de que quieres iniciar "{{name}}"? Los escenarios y correos de phishing se enviarán en sus horarios programados a {{count}} usuarios.',
        start_ok: 'Iniciar',
        start_failed: 'Error al iniciar discovery',
        started: 'Discovery iniciado exitosamente',

        complete_title: 'Completar Discovery',
        complete_confirm: '¿Estás seguro de que quieres marcar este discovery como completado?',
        complete_confirm_name: '¿Estás seguro de que quieres marcar "{{name}}" como completado?',
        complete_ok: 'Completar',
        complete_failed: 'Error al completar discovery',
        completed: 'Discovery completado',

        archive_title: 'Archivar Discovery',
        archive_confirm:
          '¿Estás seguro de que quieres archivar "{{name}}"? El discovery se ocultará de la lista pero los datos se conservarán.',
        archive_ok: 'Archivar',
        archive_failed: 'Error al archivar discovery',
        archived: 'Discovery archivado',

        // Additional messages
        custom_template_created: 'Plantilla personalizada creada exitosamente',
        create_template_failed: 'Error al crear plantilla',
        general_logo_uploaded: 'Logo subido',
        general_logo_upload_failed: 'Error al subir logo',
        no_valid_users: 'No hay usuarios válidos para importar',
      },
      admin_discoveries: {
        load_failed: 'Error al cargar discovery',
        logo_image_only: '¡Solo puedes subir archivos de imagen!',
        logo_uploaded: 'Logo subido exitosamente',
        logo_upload_failed: 'Error al subir logo',
        name_required: 'El nombre del discovery es requerido',
        company_name_required: 'El nombre de la empresa externa es requerido',
        contact_email_required: 'El correo de contacto es requerido',
        create_failed: 'Error al crear discovery',
        created: 'Discovery creado exitosamente',
        update_failed: 'Error al actualizar discovery',
        saved: 'Discovery guardado exitosamente',
        user_add_failed: 'Error al agregar usuario',
        user_added: 'Usuario agregado',
        user_remove_failed: 'Error al eliminar usuario',
        user_removed: 'Usuario eliminado',
        user_already_exists: 'Este email ya fue agregado.',
        import_failed: 'Error al importar usuarios',
        import_success: 'Importados {{created}} usuarios, {{skipped}} omitidos',
        link_generate_failed: 'Error al generar enlace',
        link_generated: 'Enlace público generado y copiado al portapapeles',
        link_disable_failed: 'Error al deshabilitar enlace',
        link_disabled: 'Enlace público deshabilitado',
        link_copied: 'Enlace copiado al portapapeles',
        start_title: 'Iniciar Discovery',
        start_confirm:
          '¿Estás seguro de que quieres iniciar este discovery? Una vez iniciado, no podrás editarlo ni agregar más usuarios.',
        start_confirm_users:
          '¿Estás seguro de que quieres iniciar "{{name}}"? Los escenarios y correos de phishing se enviarán en sus horarios programados a {{count}} usuarios.',
        start_ok: 'Iniciar',
        start_failed: 'Error al iniciar discovery',
        started: 'Discovery iniciado exitosamente',
        complete_title: 'Completar Discovery',
        complete_confirm: '¿Estás seguro de que quieres marcar este discovery como completado?',
        complete_confirm_name: '¿Estás seguro de que quieres marcar "{{name}}" como completado?',
        complete_ok: 'Completar',
        complete_failed: 'Error al completar discovery',
        completed: 'Discovery completado',
        archive_title: 'Archivar Discovery',
        archive_confirm:
          '¿Estás seguro de que quieres archivar "{{name}}"? El discovery se ocultará de la lista pero los datos se conservarán.',
        archive_ok: 'Archivar',
        archive_failed: 'Error al archivar discovery',
        archived: 'Discovery archivado',
        custom_template_created: 'Plantilla personalizada creada exitosamente',
        create_template_failed: 'Error al crear plantilla',
        general_logo_uploaded: 'Logo subido',
        general_logo_upload_failed: 'Error al subir logo',
        no_valid_users: 'No hay usuarios válidos para importar',
      },
      group_manager: {
        load_failed: 'Error al cargar grupos',
        create_success: 'Grupo creado',
        create_failed: 'Error al crear grupo',
        update_success: 'Grupo actualizado',
        update_failed: 'Error al actualizar grupo',
        delete_success: 'Grupo eliminado',
        delete_failed: 'Error al eliminar grupo',
        delete_title: 'Eliminar Grupo',
        delete_confirm: '¿Eliminar "{{name}}"?',
        delete_ok: 'Eliminar',
        default_cannot_delete: 'Los grupos predeterminados no pueden eliminarse',
        has_employees: 'No se puede eliminar un grupo con empleados',
        unexpected_error: 'Ocurrió un error inesperado',
      },
      admin_management: {
        title: 'Administradores ({{count}})',
        invite_admin: 'Invitar Admin',
        no_admins: 'No se encontraron administradores',
        load_failed: 'Error al cargar administradores',
        load_error: 'Ocurrió un error inesperado al cargar administradores',
        promote_title: 'Promover a Admin Manager',
        promote_confirm: '¿Estás seguro de que quieres promover a {{name}} a Admin Manager?',
        promote_note: 'Podrá gestionar otros administradores.',
        promote_ok: 'Promover',
        promote_failed: 'Error al promover administrador',
        promote_success: '{{name}} ha sido promovido a Admin Manager',
        demote_title: 'Degradar a Admin',
        demote_confirm: '¿Estás seguro de que quieres degradar a {{name}} a Admin regular?',
        demote_note: 'Perderá los privilegios de gestión de administradores.',
        demote_ok: 'Degradar',
        demote_failed: 'Error al degradar administrador',
        demote_success: '{{name}} ha sido degradado a Admin',
        remove_title: 'Eliminar Acceso de Admin',
        remove_confirm: '¿Estás seguro de que quieres eliminar el acceso de admin de {{name}}?',
        remove_note: 'Ya no podrá acceder a las funciones de administrador.',
        remove_ok: 'Eliminar',
        remove_failed: 'Error al eliminar administrador',
        remove_success: 'Acceso de admin eliminado para {{name}}',
        invite_failed: 'Error al enviar invitación',
        invite_success: 'Invitación enviada a {{email}}',
        unexpected_error: 'Ocurrió un error inesperado',
        col_name: 'Nombre',
        col_email: 'Correo',
        col_role: 'Rol',
        col_actions: 'Acciones',
      },
      compliance: {
        load_failed: 'Error al cargar datos de cumplimiento',
        status_updated: 'Estado actualizado',
        status_update_failed: 'Error al actualizar estado',
        note_added: 'Nota agregada',
        note_add_failed: 'Error al agregar nota',
      },
      compliance_wizard: {
        load_failed: 'Error al cargar preguntas del asistente',
        submit_success: '¡Evaluación completada!',
        submit_failed: 'Error al enviar evaluación',
        back_to_compliance: 'Volver a Compliance',
        title: 'Evaluación de Cumplimiento',
        subtitle: 'Responde las siguientes preguntas para evaluar tu preparación para SOC 2, ISO 27001 y GDPR',
        question_of: 'Pregunta {{current}} de {{total}}',
        saving: 'Guardando...',
        complete: '% Completado',
        answer_yes: 'Sí',
        answer_partial: 'Parcialmente',
        answer_no: 'No',
        desc_yes: 'Totalmente implementado',
        desc_partial: 'Parcialmente implementado',
        desc_no: 'No implementado',
        add_notes_evidence: 'Agregar notas o evidencia (opcional)',
        note: 'Nota',
        note_placeholder: 'Agrega notas relevantes sobre este control...',
        evidence: 'Evidencia',
        evidence_desc_placeholder: "Describe la evidencia (ej., 'Documento de política de seguridad')",
        evidence_url_placeholder: 'Link a la evidencia (opcional, ej., URL de Google Drive)',
        collapse: 'Colapsar',
        previous: 'Anterior',
        next: 'Siguiente',
        submit_assessment: 'Enviar Evaluación',
        items: '{{count}} elementos',
        item: '1 elemento',
        questions_remaining: '{{count}} preguntas restantes',
        complete_title: '¡Evaluación Completa!',
        complete_subtitle:
          'Tu evaluación de cumplimiento ha sido guardada. Ve al dashboard para ver tu progreso en todos los frameworks.',
        view_dashboard: 'Ver Dashboard',
        all_assessed: '¡Todos los controles han sido evaluados!',
        all_assessed_subtitle: 'Ya has completado el asistente de cumplimiento.',
        go_to_dashboard: 'Ir al Dashboard',
      },
      legal: {
        pdf_error: 'Error al generar PDF. Por favor intenta de nuevo.',
      },
      email_collection: {
        add_user_required: 'Por favor agrega al menos un usuario con nombre y correo',
      },
      campaign_stats: {
        load_failed: 'Error al cargar estadísticas de campaña',
        unexpected_error: 'Ocurrió un error inesperado',
        finish_confirm:
          '¿Estás seguro de que quieres finalizar esta campaña? Esto detendrá el seguimiento de interacciones.',
        finish_success: 'Campaña completada exitosamente',
        launch_confirm:
          '¿Estás seguro de que quieres lanzar esta campaña? Esto enviará mensajes de phishing a {{count}} empleados.',
        archive_confirm:
          '¿Estás seguro de que quieres archivar esta campaña? Puedes desarchivarla después desde la lista de campañas.',
      },
      diagnostic_analytics: {
        load_failed: 'Error al cargar análisis de diagnóstico',
        results_load_failed: 'Error al cargar resultados de diagnóstico',
        export_failed: 'Error al exportar datos',
        export_success: 'Datos exportados exitosamente',
      },
      csv_import: {
        validation_failed: 'Error en la validación del archivo',
        parse_failed: 'Error al procesar CSV',
        read_failed: 'Error al leer archivo',
        import_failed: 'Error al importar empleados',
      },
      // Diagnostic Insights Modal
      diagnostic_insights: {
        category_breakdown: 'Riesgo por categoría',
        title: 'Insights del Escenario',
        analyzing: 'Analizando Resultados',
        analyzing_desc: 'Esto puede tomar un momento mientras procesamos los datos de la evaluación...',
        no_insights: 'Sin insights disponibles',
        completion_rate: 'Tasa de Completitud',
        participation: 'Participación',
        avg_risk_score: 'Puntuación de Riesgo Promedio',
        summary: 'Resumen',
        no_summary: 'Sin resumen disponible',
        areas_to_improve: 'Áreas a Mejorar',
        strengths: 'Fortalezas',
        total_participants: 'Total de Participantes',
        completed: 'Completados',
        in_progress: 'En Progreso',
        not_started: 'No Iniciados',
        high_risk: 'Riesgo Alto',
        medium_risk: 'Riesgo Medio',
        low_risk: 'Riesgo Bajo',
        employees: 'empleados',
        no_completed_yet: 'Aún no hay evaluaciones completadas',
        risk_not_available: 'Distribución de riesgo no disponible',
      },
      // Risk Level tags
      risk_level: {
        high: 'Alto',
        medium: 'Medio',
        low: 'Bajo',
        not_assessed: 'No Evaluado',
      },
      // Avatar menu
      avatar_menu: {
        support: 'Soporte',
        feedback: 'Comentarios',
        contact: 'Contacto',
        language: 'Idioma',
      },
      // Compliance page
      compliance_page: {
        title: 'Compliance',
        dashboard: 'Dashboard',
        checklist: 'Lista de Control',
        status_done: 'Hecho',
        status_partial: 'Parcial',
        status_pending: 'Pendiente',
        status_not_assessed: 'No Evaluado',
        risk_level: 'Nivel de Riesgo',
        risk_high: 'Alto',
        risk_medium: 'Medio',
        risk_low: 'Bajo',
        overall_compliance: 'Cumplimiento General',
        controls_assessed: 'Controles Evaluados',
        high_risk_count: 'Riesgo Alto',
        filter_all: 'Todos',
        filter_compliant: 'Hecho',
        filter_partial: 'Parcial',
        filter_non_compliant: 'Pendiente',
        filter_not_assessed: 'No Evaluado',
        no_controls: 'No se encontraron controles',
        add_evidence: 'Agregar Evidencia',
        add_note: 'Agregar Nota',
        evidence_description: 'Descripción',
        evidence_url: 'URL',
        evidence_url_optional: 'URL (opcional)',
        evidence_placeholder: 'Describe la evidencia...',
        url_placeholder: 'https://drive.google.com/...',
        example: 'Ejemplo:',
        note_placeholder: 'Ingresa tu nota...',
        note_add_placeholder: 'Agregar una nota...',
        save: 'Guardar',
        cancel: 'Cancelar',
        view_details: 'Ver Detalles',
        mark_as: 'Marcar como',
        framework: 'Marco',
        category: 'Categoría',
        control: 'Control',
        description: 'Descripción',
        description_text:
          'Rastrea tu preparación de cumplimiento para SOC 2, ISO 27001 y GDPR con los 40 controles unificados',
        status: 'Estado',
        actions: 'Acciones',
        evidence: 'Evidencia',
        notes: 'Notas',
        no_evidence: 'Sin evidencia agregada',
        no_notes: 'Sin notas agregadas',
        start_wizard: 'Iniciar Asistente',
        compliance_score: 'Puntuación de Cumplimiento',
        controls: 'controles',
        of: 'de',
        assessed: 'evaluados',
        assessment: 'Evaluación',
        resume_assessment: 'Continuar Evaluación',
        start_assessment: 'Iniciar Evaluación',
        loading: 'Cargando datos de cumplimiento...',
        compliance_label: 'CUMPLIMIENTO',
        compliant_label: 'CUMPLE',
        partial_label: 'PARCIAL',
        pending_label: 'PENDIENTE',
        docs: 'Docs',
        progress_by_category: 'Progreso por Categoría',
        chat_with_assistant: 'Chat con Asistente',
        human_risk_title: 'Compliance para Riesgo Humano',
        human_risk_toggle: 'Solo Controles de Riesgo Humano',
        human_risk_stats_label: 'RIESGO HUMANO',
        human_risk_description:
          'Controles relacionados con la conciencia y comportamiento de seguridad de los empleados',
        all_controls: 'Todos los Controles',
      },
      // Compliance chat
      compliance_chat: {
        title: 'Asistente de Cumplimiento',
        greeting: `Hola **{{name}}**
Soy tu Asistente de Cumplimiento. Puedo ayudarte a entender frameworks de cumplimiento como SOC 2, ISO 27001 y GDPR.

Pregúntame sobre controles específicos, mejores prácticas, o cómo implementar medidas de cumplimiento en tu organización.

**¿Cómo puedo ayudarte hoy?**`,
      },
      // Interview chat UI
      interview: {
        header: 'Entrevista',
        title: 'Entrevista de Seguridad',
        type_message: 'Escribe tu respuesta...',
        send: 'Enviar',
        thinking: 'Pensando...',
        progress: 'Pregunta {{current}} de {{total}}',
        wrapping_up: 'Cerrando',
        completed_title: 'Entrevista Completada',
        completed_message:
          'Gracias por completar esta entrevista. Tu colaboración es muy valiosa para mejorar la seguridad de la organización.',
        error_generic: 'Algo salió mal. Por favor intenta de nuevo.',
        error_too_fast: 'Por favor espera la respuesta anterior antes de enviar otro mensaje.',
        error_expired: 'Este enlace de entrevista ha expirado o es inválido.',
        error_already_complete: 'Esta entrevista ya ha sido completada.',
        avatar_you: 'Tú',
      },
      // Admin discoveries - columns and labels
      admin_discoveries_ui: {
        title: 'Discovery',
        legend:
          'Ejecuta evaluaciones de seguridad completas combinando escenarios, simulaciones de phishing y análisis de procesos en un solo discovery. Obtén una visión integral de la postura de seguridad de tu organización.',
        create: 'Crear Discovery',
        col_name: 'Nombre',
        col_external_company: 'Empresa Externa',
        col_contact: 'Contacto',
        col_status: 'Estado',
        col_users: 'Usuarios',
        col_scenario: 'Escenario',
        col_email_template: 'Plantilla de Email',
        col_paid: 'Pagado',
        col_actions: 'Acciones',
        status_not_started: 'No Iniciado',
        status_in_progress: 'En Progreso',
        status_completed: 'Completado',
        not_selected: 'No Seleccionado',
        yes: 'Sí',
        no: 'No',
        tooltip_view: 'Ver Detalles',
        tooltip_edit: 'Editar',
        tooltip_start: 'Iniciar Discovery',
        tooltip_complete: 'Completar Discovery',
        tooltip_archive: 'Archivar',
        filter_all: 'Todos los Estados',
        // Detail page
        detail_title: 'Discovery Details',
        detail_subtitle: 'Detalles',
        back: 'Volver',
        edit: 'Editar',
        start_campaign: 'Iniciar Discovery',
        complete_campaign: 'Completar Discovery',
        campaign_details: 'Detalles de Discovery',
        discovery_details: 'Detalles de Discovery',
        external_company: 'Empresa Externa',
        contact_email: 'Email de Contacto',
        language: 'Idioma',
        language_spanish: 'Español',
        language_english: 'Inglés',
        paid: 'Pagado',
        scenario: 'Escenario',
        created: 'Creado',
        launched: 'Lanzado',
        completed: 'Completado',
        internal_notes: 'Notas Internas',
        email_phishing: 'Email Phishing',
        email_template: 'Plantilla de Email',
        target_departments: 'Departamentos Objetivo',
        all_departments: 'Todos los Departamentos',
        scheduled: 'Programado',
        not_scheduled: 'No programado',
        public_link: 'Enlace Público',
        copy_link: 'Copiar enlace',
        share_link_desc: 'Comparte este enlace para recolectar emails de participantes',
        disable_link: 'Deshabilitar Enlace',
        generate_link_desc: 'Genera un enlace público para recolectar emails de participantes',
        generate_public_link: 'Generar Enlace Público',
        statistics: 'Estadísticas',
        total_users: 'Total de Usuarios',
        scenario_progress: 'Progreso del Escenario',
        finished: 'Terminado',
        in_progress: 'En Progreso',
        pending: 'Pendiente',
        average_risk_score: 'Puntuación de Riesgo Promedio',
        email_phishing_progress: 'Progreso de Email Phishing',
        fell: 'Cayó',
        clicked: 'Clickeó',
        sent: 'Enviado',
        by_department: 'Por Departamento',
        participants: 'Participantes',
        add_user: 'Agregar Usuario',
        import_csv: 'Importar CSV',
        overview: 'Resumen',
        users: 'Usuarios',
        scenario_results: 'Resultados del Escenario',
        phishing_results: 'Resultados de Phishing',
        // Table columns
        name: 'Nombre',
        email: 'Email',
        department: 'Departamento',
        source: 'Origen',
        scenario_status: 'Estado del Escenario',
        phishing_status: 'Estado de Phishing',
        actions: 'Acciones',
        risk: 'Riesgo',
        remove_user: '¿Eliminar usuario?',
        remove: 'Eliminar',
        cancel: 'Cancelar',
        discovery_not_found: 'Discovery no encontrado',
        campaign_not_found: 'Campaña no encontrada',
        // Alerts
        alert_configure_email: 'Configura la plantilla de email en Editar para habilitar phishing',
        alert_set_launch_date: 'Establece una fecha de lanzamiento en Editar para programar phishing',
        alert_will_launch: 'El email phishing se lanzará automáticamente en la fecha programada',
        alert_launched: 'El email phishing ha sido lanzado',
        // Blocked reasons
        blocked_no_users: 'Agrega al menos un usuario para iniciar el discovery',
        blocked_no_config: 'Selecciona un escenario o plantilla de email para iniciar el discovery',
        blocked_no_scenario_date: 'Establece una fecha de lanzamiento del escenario antes de iniciar el discovery',
        blocked_no_email_date: 'Establece una fecha de lanzamiento del email antes de iniciar el discovery',
        // Form
        full_name: 'Nombre completo',
        please_enter_name: 'Por favor ingresa el nombre',
        please_enter_email: 'Por favor ingresa el email',
        please_enter_valid_email: 'Por favor ingresa un email válido',
        department_optional: 'Departamento (opcional)',
        // Edit page
        create_title: 'Nueva',
        edit_title: 'Editar',
        save: 'Guardar',
        saving: 'Guardando...',
        basic_info: 'Información Básica',
        campaign_name: 'Nombre de Discovery',
        campaign_name_placeholder: 'Ingresa el nombre del discovery',
        external_company_name: 'Nombre de Empresa Externa',
        external_company_placeholder: 'Nombre de la empresa cliente',
        contact_email_placeholder: 'cliente@empresa.com',
        select_language: 'Selecciona idioma',
        mark_paid: 'Marcar como Pagado',
        internal_notes_placeholder: 'Notas visibles solo para admins...',
        scenario_config: 'Configuración del Escenario',
        select_scenario: 'Seleccionar Escenario',
        no_scenario: 'Sin escenario (omitir)',
        scenario_launch_date: 'Fecha de Lanzamiento del Escenario',
        email_phishing_config: 'Configuración de Email Phishing',
        select_email_template: 'Seleccionar Plantilla de Email',
        no_email_template: 'Sin plantilla de email (omitir)',
        email_launch_date: 'Fecha de Lanzamiento del Email',
        select_departments: 'Seleccionar Departamentos',
        all_users: 'Todos los usuarios',
        // Edit page alerts
        alert_in_progress_edit: 'Este discovery está en progreso y no puede ser editado.',
        alert_completed_edit: 'Este discovery está completado y no puede ser editado.',
        alert_unsaved_changes: 'Tienes cambios sin guardar',
        // Domain verification
        domain_verification: 'Verificación de Dominio (Opcional)',
        domain_verification_optional: 'La verificación de dominio es opcional para discoveries',
        domain_verification_desc:
          'Si deseas enviar emails desde un dominio personalizado en lugar de notifyinbox.com, puedes verificar tu dominio aquí. Esta es la misma configuración usada en todos los discoveries.',
        // Import modal
        import_title: 'Importar Usuarios desde CSV',
        import_download_template: 'Descargar Plantilla',
        import_users: 'Importar {{count}} Usuarios',
        import_csv_format: 'Formato CSV',
        import_csv_desc:
          'El archivo CSV debe tener columnas: nombre, email, departamento (opcional). La primera fila puede ser encabezado o datos.',
        import_valid_departments: 'Departamentos válidos',
        import_drag_text: 'Haz clic o arrastra un archivo CSV para subir',
        import_drag_hint: 'Soporte para un solo archivo CSV',
        import_valid_users: 'usuarios válidos',
        import_invalid_rows: 'filas inválidas',
        import_file_empty: 'El archivo está vacío',
        import_invalid_row: 'Formato de fila inválido',
        import_missing_name: 'Falta el nombre',
        import_invalid_email: 'Email inválido',
        import_no_valid_users: 'No se encontraron usuarios válidos en el archivo',
        import_parse_failed: 'Error al procesar el archivo CSV',
        import_read_failed: 'Error al leer el archivo',
        import_valid: 'Válido',
        // List page
        filter_by_status: 'Filtrar por estado',
        new_discovery: 'Nuevo Discovery',
        new_campaign: 'Nueva Campaña',
        no_discoveries_found: 'No se encontraron discoveries',
        no_campaigns_found: 'No se encontraron campañas',
        // General info section
        general_info: 'Información General',
        campaign_name_label: 'Nombre de Discovery',
        external_company_label: 'Nombre de Empresa Externa',
        contact_email_label: 'Email de Contacto',
        external_company_industry_label: 'Rubro de la Empresa',
        external_company_industry_placeholder: 'Seleccionar rubro...',
        company_logo: 'Logo de Empresa',
        change_logo: 'Cambiar Logo',
        upload_logo: 'Subir Logo',
        logo_recommendation: 'Recomendado: 200x200px, PNG o JPG, máx 2MB',
        // Scenario section
        scenario_config_title: 'Escenario',
        select_scenario_label: 'Seleccionar Escenario',
        no_scenarios_available: 'No hay escenarios disponibles',
        scenario_launch_date_label: 'Fecha de Lanzamiento del Escenario',
        select_launch_date: 'Seleccionar fecha de lanzamiento',
        required_when_scenario: 'Requerido cuando se selecciona un escenario',
        select_scenario_hint: 'Selecciona un escenario para configurar la evaluación de este discovery.',
        launched_at: 'Lanzado el',
        // AI Scenario Adaptation
        adapt_scenarios_label: 'Adaptacion de Escenario con IA',
        adapt_scenarios_desc: 'Adaptar el contenido del escenario al contexto del departamento',
        adapt_scenarios_tooltip:
          'Usa IA para personalizar la introduccion del escenario. Las preguntas y puntuacion permanecen identicas.',
        adaptation_department_label: 'Rol / Departamento Objetivo',
        adaptation_department_placeholder: 'ej. Ingenieria, RRHH, Finanzas...',
        adaptation_department_hint:
          'El escenario se adaptara para este departamento. Deja vacio para una adaptacion general.',
        // Email phishing section
        email_phishing_config_title: 'Email Phishing',
        select_email_template_label: 'Seleccionar Plantilla de Email',
        create_custom: 'Crear Personalizado',
        no_email_templates: 'No hay plantillas de email disponibles',
        subject_label: 'Asunto',
        from_label: 'De',
        target_departments_label: 'Departamentos Objetivo (dejar vacío para todos)',
        add_users_to_see_departments: 'Agrega usuarios al discovery para ver los departamentos disponibles',
        email_launch_date_label: 'Fecha de Lanzamiento de Email Phishing',
        required_when_email: 'Requerido cuando se selecciona una plantilla de email',
        select_email_hint:
          'Selecciona una plantilla de email para configurar la simulación de phishing de este discovery.',
        // Users section
        campaign_participants: 'Participantes de Discovery',
        users_count: '{{count}} usuarios',
        public_link_title: 'Enlace Público',
        share_link_client: 'Comparte este enlace con el cliente para recolectar emails de participantes',
        generate_link_client: 'Genera un enlace público para que el cliente agregue participantes directamente',
        disable: 'Deshabilitar',
        download_template: 'Descargar Plantilla',
        no_participants_yet: 'No se han agregado participantes aún',
        select_department_optional: 'Seleccionar departamento (opcional)',
        // Assessment config section
        assessment_config_title: 'Evaluación de Procesos',
        assessment_config_description: 'Selecciona los procesos a evaluar y configura los ajustes de la entrevista.',
        process_jml: 'Altas, Bajas y Cambios (JML)',
        process_privileged_access: 'Gestión de Acceso Privilegiado',
        process_account_recovery: 'Recuperación de Cuentas',
        process_change_to_prod: 'Gestión de Cambios a Producción',
        process_external_sharing: 'Compartición Externa de Datos',
        process_incident_reporting: 'Reporte de Incidentes',
        process_payment_processing: 'Procesamiento de Pagos',
        process_vendor_management: 'Gestión de Proveedores',
        process_data_privacy: 'Privacidad y Datos Personales',
        assessment_language: 'Idioma de la Entrevista',
        assessment_launch_date: 'Fecha de Lanzamiento de Evaluación',
        assessment_launched_info: 'La evaluación ha sido lanzada y ya no puede ser modificada.',
        // Assessment results tab
        assessment_results: 'Resultados de Evaluación',
        assessment_progress: 'Progreso de Evaluación',
        assessment_not_started: 'Sin Iniciar',
        assessment_in_progress: 'En Progreso',
        assessment_completed: 'Completado',
        assessment_total: 'Asignaciones Totales',
        assessment_completion_rate: 'Tasa de Completitud',
        assessment_per_process_chart: 'Completitud por Proceso',
        assessment_view_transcript: 'Ver Transcripción',
        assessment_reassign: 'Reasignar',
        assessment_reassign_title: 'Reasignar Proceso',
        assessment_reassign_confirm:
          'Esto eliminará todos los datos de entrevista existentes para esta asignación y comenzará de nuevo. Continuar?',
        assessment_reassign_success: 'Proceso reasignado exitosamente',
        assessment_reassign_select_user: 'Seleccionar nuevo participante',
        assessment_transcript_title: 'Transcripción de Entrevista',
        assessment_no_transcript: 'No hay transcripción disponible para esta entrevista.',
        assessment_no_results: 'Aún no hay resultados de evaluación. Lanza la evaluación primero.',
        assessment_add_assignment: 'Agregar Asignación',
        assessment_select_employee: 'Seleccionar empleado',
        assessment_select_process: 'Seleccionar proceso',
        assessment_assign_button: 'Asignar',
        assessment_assigned_success: 'Asignación creada exitosamente',
        assessment_already_assigned: 'Este empleado ya está asignado a este proceso',
        // Findings placeholder
        assessment_findings: 'Evaluación de Seguridad',
        assessment_findings_placeholder:
          'La generación de hallazgos estará disponible después de configurar el servicio de evaluación.',
        assessment_generate_findings: 'Analizar Proceso',
        assessment_regenerate_findings: 'Re-analizar',
        assessment_findings_instructions: 'Informacion adicional sobre este proceso (opcional)',
        assessment_additional_info_title: 'Informacion Adicional',
        assessment_additional_info_description:
          'Proporciona cualquier contexto adicional sobre este proceso que no se haya capturado durante la entrevista. Esta informacion sera considerada en el analisis.',
        assessment_additional_info_placeholder:
          'Ej: El proceso de aprobacion tambien involucra una segunda revision por el gerente de TI para solicitudes de acceso privilegiado...',
        assessment_findings_not_available:
          'La generación de hallazgos aún no está disponible. Esta funcionalidad será habilitada en una futura actualización.',
        assessment_findings_summary: 'Resumen Ejecutivo',
        assessment_findings_gaps: 'Evaluación de Vulnerabilidades de Seguridad por Etapa del Proceso',
        assessment_findings_recommendations: 'Recomendaciones',
        assessment_findings_evidence: 'Evidencia',
        assessment_findings_observation: 'Observado',
        assessment_findings_gap: 'Brecha',
        assessment_findings_severity: 'Severidad',
        assessment_findings_generated_at: 'Generado',
        assessment_findings_generated_with: 'Generado con instrucciones',
        assessment_findings_generating: 'Analizando vulnerabilidades de seguridad...',
        assessment_findings_error: 'Error al generar hallazgos',
        assessment_findings_select_assignment: 'Selecciona una asignación completada para generar hallazgos',
        assessment_findings_no_completed: 'No hay asignaciones completadas disponibles para generar hallazgos',
        assessment_findings_vulnerability: 'Vulnerabilidad',
        assessment_findings_threat: 'Amenaza',
        assessment_findings_risk_score: 'Puntaje de Riesgo',
        assessment_findings_likelihood: 'Probabilidad',
        assessment_findings_impact: 'Impacto',
        assessment_findings_process: 'Proceso Analizado',
        assessment_findings_overall_risk: 'Nivel de Riesgo General',
        assessment_findings_top_vulnerabilities: 'Vulnerabilidades Principales',
        assessment_findings_mitigated_threats: 'Amenazas Mitigadas',
        severity_critical: 'Crítico',
        severity_high: 'Alto',
        severity_medium: 'Medio',
        severity_low: 'Bajo',
        severity_not_described: 'No descrito',
        likelihood_very_likely: 'Muy Probable',
        likelihood_likely: 'Probable',
        likelihood_possible: 'Posible',
        likelihood_unlikely: 'Improbable',
        likelihood_na: 'N/A',
        impact_critical: 'Crítico',
        impact_high: 'Alto',
        impact_medium: 'Medio',
        impact_low: 'Bajo',
        impact_na: 'N/A',
        // canStart assessment
        blocked_no_assessment_date: 'Establece una fecha de lanzamiento de evaluación para iniciar',
        // Arm toggle UI (OPTA-01/02/03/04)
        arm_scenario_enabled: 'Escenario',
        arm_phishing_enabled: 'Email Phishing',
        arm_assessment_enabled: 'Evaluación de Procesos',
        arm_disabled_hint: 'Este brazo está deshabilitado y no se ejecutará en este discovery.',
        arm_no_date_warning: 'Sin fecha de lanzamiento — este brazo no se ejecutará automáticamente sin una fecha.',
        blocked_no_arms:
          'Configura al menos un brazo (Escenario, Email Phishing, QR Phishing o Evaluación) para iniciar el discovery.',
        start_blocked_no_arms: 'Configura al menos un brazo para iniciar el discovery.',
        // QR Phishing
        qr_phishing_config_title: 'QR Phishing',
        qr_phishing_config_description:
          'Habilita para generar un código QR al lanzar el discovery. No requiere configuración adicional.',
        qr_phishing_launch_date: 'Fecha de Lanzamiento de QR Phishing',
        qr_phishing_launched_info: 'El QR phishing ha sido lanzado y ya no puede ser modificado.',
        qr_phishing: 'QR Phishing',
        qr_phishing_progress: 'Progreso de QR Phishing',
        qr_phishing_results: 'Resultados de QR Phishing',
        scans: 'Escaneos',
        qr_code: 'Código QR',
        download_qr: 'Descargar Código QR',
        qr_scan_count: 'Escaneos QR',
        captured_email: 'Email Capturado',
        qr_total_targets: 'Objetivos Totales',
        qr_fell: 'Cayeron en QR Phishing',
        qr_status: 'Estado',
        // Missing keys
        start_discovery: 'Iniciar Discovery',
        complete_discovery: 'Completar Discovery',
        discovery_participants: 'Participantes del Discovery',
        // Source tag translations
        source_manual: 'Manual',
        source_csv: 'CSV',
        source_public_link: 'Enlace Público',
        // Scenario section super tags
        discovery_assessment: 'Discovery',
        discovery_description: '6 categorías de seguridad',
        // Assessment section process/user assignment
        assessment_processes_label: 'Procesos y Asignaciones',
        assessment_assign_users_hint:
          'Selecciona controles y asigna usuarios. Si no se asignan usuarios, todos serán evaluados al lanzar.',
        assessment_select_user: 'Seleccionar usuario...',
        assessment_add_users_first: 'Agrega participantes para asignarlos',
      },
      control_assessment: {
        compliance_label: 'Cumplimiento',
        compliance_no_data: 'Cumplimiento: sin evaluar',
        compliance_criteria_breakdown: 'Desglose de criterios',
        compliance_popover_title: 'Evaluación de cumplimiento',
        page_title: 'Auditorías',
        legend:
          'Asigná un control a alguien que lo conozca. Responde una entrevista corta con IA desde su bandeja. Ciphia genera hallazgos que podés accionar.',
        empty_title: 'Todavía no hay auditorías',
        empty_body:
          'Elegí un control (SOC 2, ISO 27001 o NIST), asignalo a quien sepa del tema, y Ciphia se encarga del resto.',
        empty_cta: 'Crear primera auditoría',
        section: {
          basics: 'Datos básicos',
          interviews: 'Entrevistas',
          delivery: 'Entrega',
        },
        next_step: {
          launch_title: 'Enviá las entrevistas',
          launch_body: 'Faltan enviar {{count}} asignación(es). Lanzá para que reciban el link de la entrevista.',
          wait_title: 'Esperando al equipo',
          wait_body: '{{done}} de {{total}} entrevistas completas. Recordale a los que faltan o esperá.',
          analyze_title: 'Analizá las entrevistas terminadas',
          analyze_body: '{{count}} entrevista(s) listas. Tocá el ícono de matraz en la fila para generar hallazgos.',
          refine_title: 'Refiná con el auditor',
          refine_body:
            '{{count}} asignación(es) todavía tienen criterios que no cumplen. Abrí el drawer del auditor para iterar.',
          done_title: 'Auditoría completa',
          done_body: 'Todos los criterios están cumplidos. Podés archivar esta auditoría o pasar a la próxima.',
        },
        new_assessment: 'Nueva auditoría',
        name: 'Nombre',
        name_placeholder: 'Ej: Auditoría Q1 2026 JML',
        processes: 'Controles',
        select_processes: 'Seleccionar control',
        employees: 'Empleados',
        employee: 'Empleado',
        assigned_to: 'Asignado a',
        select_employees: 'Seleccionar empleados',
        select_employee: 'Seleccionar empleado',
        // Tabla de asignaciones por par (Phase 134+).
        assignments_label: 'Entrevistas a asignar',
        assignments_help:
          'Cada fila crea una entrevista. Podés asignar distintos controles a distintas personas, o el mismo control a varias personas.',
        assignments_required: 'Agregá al menos una entrevista.',
        assignments_duplicate: 'Asignaste el mismo control a la misma persona dos veces. Eliminá el duplicado.',
        col_control: 'Control',
        col_employee: 'Persona',
        add_assignment: 'Agregar entrevista',
        remove_assignment: 'Eliminar esta fila',
        language: 'Idioma',
        status: 'Estado',
        created: 'Creado',
        launch_date: 'Fecha de lanzamiento',
        actions: 'Acciones',
        launch: 'Lanzar',
        schedule: 'Programar',
        view: 'Ver detalle',
        not_started: 'Sin iniciar',
        in_progress: 'En progreso',
        completed: 'Completada',
        total_assignments: 'Asignaciones totales',
        completed_assignments: 'Completadas',
        create_success: 'Auditoria creada exitosamente',
        launch_success: 'Auditoria lanzada exitosamente',
        launch_confirm: 'Se enviaran emails de entrevista a los empleados seleccionados. Continuar?',
        no_assessments: 'No hay auditorias creadas',
        findings: 'Hallazgos',
        no_findings: 'Aún no se analizó la entrevista',
        no_findings_auto_hint:
          'Los hallazgos se calculan automáticamente al completarse la entrevista y luego de cada cambio en la evidencia.',
        no_findings_no_interview: 'La entrevista todavía no se completó.',
        no_findings_ready_to_generate: 'La entrevista ya está completa. Generá los hallazgos para ver los resultados.',
        no_findings_generating: 'Generando hallazgos, puede tardar hasta un minuto.',
        generate_findings_button: 'Generar hallazgos',
        regenerate_findings_button: 'Regenerar hallazgos',
        regenerate_timeout: 'La generación está tardando más de lo esperado. Refrescá en un minuto.',
        generate_findings: 'Analizar entrevista',
        back: 'Volver',
        finding_open: 'Abierto',
        finding_fixed: 'Corregido',
        mark_fixed: 'Marcar corregido',
        reopen: 'Reabrir',
        severity: 'Severidad',
        observation: 'Observacion',
        gap: 'Brecha',
        finding_status: 'Estado',
        overall_risk: 'Riesgo General',
        unfixed_count: 'Hallazgos sin corregir',
        toggle_success: 'Estado del hallazgo actualizado',
        schedule_date: 'Programar para',
        schedule_placeholder: 'Dejar vacio para lanzar ahora',
        scheduled_success: 'Auditoria programada exitosamente',
        scheduled: 'Programada',
        delete: 'Eliminar',
        delete_confirm_title: 'Eliminar auditoria',
        delete_confirm_content: '¿Estas seguro que quieres eliminar "{{name}}"? Esta accion no se puede deshacer.',
        delete_confirm_content_fallback:
          '¿Estas seguro que quieres eliminar esta auditoria? Esta accion no se puede deshacer.',
        delete_success: 'Auditoria eliminada',
        delete_error: 'Error al eliminar la auditoria',
        scheduled_info: 'Esta auditoria esta programada para lanzarse el {{date}}',
        pending_launch: 'Esta auditoria aun no ha sido lanzada',
        view_transcript: 'Ver entrevista',
        no_transcript: 'No hay transcripcion disponible',
        transcript_employee: 'Empleado',
        transcript_interviewer: 'Entrevistador',
        findings_confirm_title: 'Analizar entrevista',
        findings_confirm_content:
          'Se revisará la entrevista para identificar hallazgos. Este proceso puede tardar un momento. ¿Continuar?',
        recommendation: 'Recomendacion',
        refine_with_auditor_button: 'Refinar con auditor',
        refine_with_auditor_aria_label: 'Abrir dialogo del auditor para refinar hallazgos',
        view_findings_tooltip: 'Ver hallazgos',
        generate_findings_tooltip: 'Analizar entrevista',
        bulk_generate_button_aria: 'Analizar todas las entrevistas pendientes',
        bulk_generate_tooltip: 'Analizar todas las pendientes',
        bulk_generate_title: 'Analizar entrevistas en bloque',
        bulk_generate_intro: 'Se analizarán {{count}} entrevistas pendientes. Puede tardar varios minutos.',
        bulk_generate_no_pending: 'No hay entrevistas completas para analizar.',
        bulk_generate_action: 'Analizar {{count}} entrevistas',
        bulk_reanalyze_intro:
          'Todas las entrevistas ya están analizadas. Volver a analizarlas sobrescribirá los hallazgos existentes de {{count}} entrevistas.',
        bulk_reanalyze_action: 'Volver a analizar {{count}} entrevistas',
        bulk_reanalyze_confirm_title: '¿Volver a analizar las entrevistas?',
        bulk_reanalyze_confirm_body:
          'Esto descartará los hallazgos actuales de {{count}} entrevistas y los reemplazará con un nuevo análisis del LLM. El cambio es permanente.',
        bulk_reanalyze_confirm_ok: 'Sí, volver a analizar',
        bulk_reanalyze_confirm_cancel: 'Cancelar',
        bulk_generate_in_progress: 'Analizando ({{completed}}/{{total}})…',
        bulk_generate_current: 'En curso: {{name}}',
        bulk_generate_done: 'Listo. {{succeeded}} analizadas, {{failed}} con error.',
        bulk_generate_close: 'Cerrar',
        bulk_generate_already_label: 'Ya analizada',
        bulk_generate_pending_label: 'Pendiente',
        bulk_generate_state_queued: 'En cola',
        bulk_generate_state_generating: 'Analizando',
        bulk_generate_state_done: 'Listo',
        bulk_generate_state_failed: 'Error',
        bulk_generate_queue_hint:
          'Las entrevistas se analizan una por vez. La lista se actualiza a medida que cada una termina. El análisis continúa aunque cierres esta pestaña.',
        bulk_generate_enqueue_error: 'No se pudo iniciar el análisis en bloque. Intentá de nuevo.',
        status_awaiting_findings: 'Pendiente de hallazgos',
        status_findings_ready: 'Hallazgos listos',
        status_awaiting_findings_tooltip: '{{pending}} de {{total}} entrevistas completadas aún necesitan hallazgos',
        findings_language_label: 'Idioma de los hallazgos',
        add_interviews_tooltip: 'Agregar más entrevistas',
        add_interviews_title: 'Agregar entrevistas a esta auditoría',
        add_interviews_description:
          'Sumá más empleados a los controles ya seleccionados de esta auditoría. Cada nuevo empleado recibe el email de entrevista.',
        add_interviews_controls_label: 'Controles en esta auditoría',
        add_interviews_employee_placeholder: 'Elegí los empleados a sumar',
        add_interviews_submit: 'Agregar {{count}} entrevista(s)',
        add_interviews_success: 'Entrevistas agregadas',
        add_interviews_error: 'No se pudieron agregar las entrevistas. Intentá de nuevo.',
        // Phase 135 — modal por par de AddInterviews (Form.List de {control,persona}).
        add_interviews_assignments_label: 'Entrevistas a enviar',
        add_interviews_assignments_help:
          'Cada fila envía una entrevista. Combiná controles y personas con libertad; no se permite repetir el mismo par.',
        add_interviews_assignments_required: 'Agregá al menos una entrevista.',
        add_interviews_assignments_duplicate:
          'Agregaste el mismo control para la misma persona dos veces. Eliminá el duplicado.',
        add_interviews_control_placeholder: 'Seleccionar control',
        add_interviews_add_row: 'Agregar entrevista',
        add_interviews_scheduled_at_label: 'Programar para (opcional)',
        add_interviews_submit_now: 'Enviar tanda',
        add_interviews_schedule: 'Programar tanda',
        // Phase 135 — tabla interna de asignaciones: Switch por fila + columna Tanda.
        assignments_active_label: 'Activa',
        assignments_batch_label: 'Tanda',
        assignments_sent_at_label: 'Enviada',
        criteria_progress_label: 'Criterios',
        criteria_progress_tooltip: 'Criterios cumplidos sobre el total de criterios del control.',
        toggle_active_confirm_title: '¿Reemplazar la entrevista activa actual?',
        toggle_active_confirm_body:
          'Activar esta fila va a desactivar la otra entrevista de la misma persona sobre el mismo control.',
        toggle_active_confirm_ok: 'Activar',
        toggle_active_error: 'No se pudo actualizar el estado activo. Intentá de nuevo.',
        // Phase 135 — listado padre: flujo archivar / desarchivar + toggle de mostrar archivadas.
        show_archived_label: 'Mostrar archivadas',
        archived_tag: 'Archivada',
        archive: 'Archivar',
        archive_tooltip: 'Archivar esta auditoría',
        archive_confirm_title: '¿Archivar esta auditoría?',
        archive_confirm_body:
          'Va a quedar oculta del listado activo, pero se conserva legible en reportes pasados para auditoría.',
        archive_success: 'Auditoría archivada',
        archive_error: 'No se pudo archivar la auditoría. Intentá de nuevo.',
        unarchive: 'Desarchivar',
        unarchive_tooltip: 'Volver a sumar esta auditoría al listado activo',
        unarchive_confirm_title: '¿Desarchivar esta auditoría?',
        unarchive_confirm_body: 'Va a volver al listado activo.',
        unarchive_success: 'Auditoría restaurada',
        unarchive_error: 'No se pudo restaurar la auditoría. Intentá de nuevo.',
      },
      compliance_reports: {
        builder: {
          cover_section_title: 'Portada',
          cover_field_prepared_by: 'Preparado por',
          cover_field_prepared_for: 'Preparado para',
          cover_field_confidentiality: 'Confidencialidad',
          page_title: 'Reportes',
          legend:
            'Convertí una auditoría en un reporte listo para cumplimiento. Ciphia redacta la narrativa, cita la evidencia y marca lo que falta.',
          create_draft_button: 'Nuevo reporte',
          create_draft_submit: 'Crear reporte',
          list_col_title: 'Título',
          list_col_period: 'Período',
          list_col_audit: 'Auditoría',
          list_audit_unknown: 'Sin auditoría',
          list_col_progress: 'Cobertura',
          list_action_edit: 'Editar',
          list_empty: 'Aún no hay reportes',
          list_empty_desc:
            'Elegí una auditoría completa y Ciphia arma todo el reporte: narrativa, citas de evidencia y registro de desvíos.',
          create_draft_modal_title: 'Nuevo reporte',
          create_draft_modal_help: 'Elegí una auditoría. Ciphia arma el reporte a partir de su evidencia y entrevista.',
          field_period_start: 'Inicio del período',
          field_period_end: 'Fin del período',
          field_title: 'Título del reporte',
          field_language: 'Idioma',
          field_language_option_es: 'Español',
          field_language_option_en: 'Inglés',
          period_preset_today: 'Hoy',
          period_preset_last_30: 'Últimos 30 días',
          period_preset_last_90: 'Últimos 90 días',
          period_preset_this_quarter: 'Este trimestre',
          period_preset_this_year: 'Este año',
          period_preset_last_year: 'Año anterior',
          field_source_assessment: 'Auditoría fuente',
          field_source_assessment_tooltip:
            'El reporte va a leer evidencia y hallazgos de esta auditoría. Cualquier control sin cobertura queda en el registro de desvíos.',
          field_source_assessment_placeholder: 'Elegí la auditoría en la que se basa este reporte',
          field_source_assessments: 'Auditorías de seguridad fuente',
          field_source_assessments_tooltip:
            'El reporte analizará la evidencia de estas auditorías. Los controles sin auditoría cubierta aparecen en el registro de desvíos.',
          field_source_assessments_placeholder: 'Seleccioná las auditorías que alimentan este reporte',
          field_source_assessments_empty_title: 'Todavía no hay auditorías disponibles',
          field_source_assessments_empty_desc:
            'Corré al menos una auditoría desde la página de Auditorías antes de crear un reporte.',
          validation_period_required: 'Las fechas de inicio y fin son obligatorias',
          validation_assessments_required: 'Seleccioná al menos una auditoría de control para basar el reporte',
          validation_assessment_required: 'Elegí una auditoría para basar el reporte.',
          validation_title_min: 'Ponele un nombre al reporte.',
          validation_title_max: 'El título no puede superar los 200 caracteres',
          version_editing_label: 'Editando v{{version}}',
          section_narrative: 'Narrativa',
          section_exception_log: 'Registro de excepciones y desvíos',
          button_save_edit: 'Guardar edición',
          button_preview: 'Vista previa',
          button_versions: 'Versiones',
          autosave_pending: 'Guardando…',
          autosave_saved: 'Guardado',
          autosave_failed: 'Falló el guardado',
          button_edit_narrative: 'Editar',
          button_save_narrative: 'Guardar',
          button_cancel_edit: 'Cancelar',
          // Phase 143 Wave 4 (D-10) :: cuerpo de tarjeta para controles con findings
          // (drawer-mode :: aún consumido por SectionFindingsBody).
          findings_criteria_met_heading: 'Criterios cumplidos',
          findings_criteria_breakdown_heading: 'Detalle por criterio',
          findings_status_met: 'Cumplido',
          findings_status_partial: 'Parcial',
          findings_status_failed: 'No cumplido',
          findings_status_not_applicable: 'No aplica',
          // Phase 143 Wave 4 (D-03) :: tarjeta de metodología (determinística, read-only).
          methodology_section_title: 'Metodología',
          methodology_sampling_approach_label: 'Enfoque de muestreo',
          methodology_subservice_orgs_label: 'Sub-organizaciones de servicio',
          meta_field_empty: 'Aún no provisto',
          quality_badge_pass: 'Verificación IA: aprobada',
          quality_badge_warning: 'Verificación IA: revisar',
          quality_badge_fail: 'Verificación IA: requiere atención',
          quality_badge_none: 'Sin verificar',
          quality_popover_title: 'Detalle de la verificación de IA',
          quality_popover_description: 'La IA revisó esta narrativa en seis dimensiones antes de guardar el borrador.',
          quality_dim_unfounded_claims: 'Afirmaciones respaldadas por evidencia',
          quality_dim_missing_citations: 'Las citas coinciden con la evidencia',
          quality_dim_softening_language: 'No suaviza riesgos',
          quality_dim_tone_marketing: 'Tono profesional (sin lenguaje de marketing)',
          quality_dim_contradicts_facts: 'Coherente con la evidencia',
          quality_dim_hallucinated_entities: 'Sin entidades inventadas',
          quality_status_pass: 'OK',
          quality_status_warning: 'Atención',
          quality_status_fail: 'Falla',
          breadcrumb_root: 'Reportes de cumplimiento',
          citations_section_title: 'Referencias',
          citations_aria_label: 'Cita {{index}}',
          section_number_aria: 'Sección {{number}}',
          exception_log_section_title: 'Excepciones y desvíos',
          exception_log_complete_title: 'Sin desvíos registrados',
          exception_log_complete_description: 'Ningún control fue ocultado o excluido del reporte para este período.',
          no_evidence_for_control: 'Aún no se ha adjuntado evidencia para este control.',
          exception_log_empty: 'Ningún control ocultado o excluido en este período.',
          exception_log_reason_no_audit: 'No se realizó una auditoría para este control.',
          exception_log_reason_no_risk_data: 'No hay métricas de riesgo disponibles para este control.',
          // Phase 143 Wave 5 (D-16) :: razón hidden-by-admin del log de excepciones.
          exception_log_reason_hidden_by_admin:
            'Ocultado por el administrador del cuerpo principal. Se lista aquí para mantener la trazabilidad.',
          // Phase 143 Wave 5 (D-04 + D-07) :: botón "Analizar Reporte" del header + máquina de estados.
          generate_ai_button_label: 'Analizar Reporte',
          generate_ai_button_loading: 'Analizando...',
          generate_ai_button_tooltip_ready:
            'Genera el resumen ejecutivo, la evaluación de riesgo y las narrativas con IA. Solo regenera secciones nuevas o modificadas.',
          generate_ai_button_tooltip_fresh: 'Todas las secciones están al día con la evidencia más reciente.',
          reanalyze_confirm_title: '¿Volver a analizar?',
          reanalyze_confirm_body:
            'El análisis anterior se va a reemplazar. Las prosas y recomendaciones actuales se pierden.',
          reanalyze_confirm_ok: 'Sí, volver a analizar',
          reanalyze_confirm_cancel: 'Cancelar',
          header_analyzed_at: 'Analizado el {{date}}',
          header_not_analyzed: 'Sin analizar',
          generate_ai_toast_success: 'Secciones de IA generadas correctamente.',
          generate_ai_toast_error: 'No se pudo terminar la generación. Algunas secciones podrían requerir reintento.',
          generate_ai_error_network: 'Error de red al contactar el servicio de IA. Volvé a intentarlo.',
          generate_ai_error_throttled: 'El servicio de IA está ocupado. Esperá un momento y volvé a intentarlo.',
          // Phase 143 Wave 5 (D-15) :: toasts de mostrar/ocultar control.
          section_hidden_toast: 'Control ocultado del cuerpo principal. Aparece en el registro de desviaciones.',
          section_unhidden_toast: 'Control restablecido en el cuerpo principal.',
          section_regenerate_error: 'No se pudo regenerar esta sección. Volvé a intentarlo.',
          section_hide_error: 'No se pudo cambiar la visibilidad de la sección. Volvé a intentarlo.',
          exception_log_column_control: 'Control',
          exception_log_column_reason: 'Por qué está en alcance pero sin evidencia',
          exception_log_column_action: 'Acción',
          exception_log_action_start_audit: 'Iniciar entrevista',
          exception_log_no_action_for_control:
            'Este control no se evidencia por entrevista de proceso. Subí un archivo de evidencia o capturá datos de entrenamiento.',
          exception_log_no_risk_data_tooltip:
            'Las métricas de riesgo vienen de campañas de phishing y escenarios. Ejecutá una campaña para poblar este control.',
          preview_pdf_button: 'Generar PDF',
          preview_pdf_error: 'No se pudo generar la previsualización del PDF. Probá de nuevo o revisá el borrador.',
          welcome_mat_title: 'Antes de generar tu primer reporte de cumplimiento',
          welcome_mat_description:
            'Los narrativos del reporte se construyen a partir de entrevistas de proceso (donde describís cómo opera cada control). Sin al menos una entrevista hecha, el reporte va a quedar prácticamente vacío. Te recomendamos hacer tu primera entrevista ahora: lleva pocos minutos por proceso.',
          welcome_mat_primary_cta: 'Hacer mi primera entrevista de proceso',
          welcome_mat_secondary_cta: 'Crear borrador vacío de todas formas',
          field_state_option_draft: 'Borrador',
          field_state_option_published: 'Publicado',
          versions_modal_title: 'Historial de versiones',
          versions_modal_empty: 'Aún no hay versiones anteriores.',
          versions_entry_archived_at: 'Archivada el {{date}}',
          preview_iframe_title: 'Vista previa del reporte',
          // Phase 145 Wave 1 :: 5-KPI lead matching PDF Sect 1 verbatim
          // (D-07). Orden: Riesgo humano global / Empleados evaluados /
          // Tasa de clic phishing / Tasa de caída phishing / Cobertura.
          kpi: {
            human_risk_score_label: 'Riesgo humano global',
            human_risk_score_subtitle: 'Nivel: {{level}}',
            employees_evaluated_label: 'Empleados evaluados',
            employees_evaluated_subtitle: 'Total en el alcance',
            phishing_click_rate_label: 'Tasa de clic phishing',
            phishing_click_rate_short: 'Tasa de clic',
            phishing_click_rate_subtitle: 'Sobre el total de la campaña',
            phishing_fell_rate_label: 'Tasa de caída phishing',
            phishing_fell_rate_short: 'Tasa de caída',
            phishing_fell_rate_subtitle: 'Ingresaron credenciales',
            phishing_exposure_label: 'Exposición a phishing',
            coverage_label: 'Cobertura de controles',
            coverage_subtitle: 'Criterios mandatorios cumplidos en los procesos auditados',
            empty_value: 'Sin datos',
          },
          rationale: {
            edit_hint: 'Clic para editar',
            save: 'Guardar',
            cancel: 'Cancelar',
            save_error: 'No se pudo guardar la edición',
            cannot_be_empty: 'El texto no puede estar vacío',
            empty: 'Ejecutá Analizar Reporte para generar esta sección.',
          },
          section_visibility: {
            show_in_pdf: 'Mostrar en PDF',
            hide_from_pdf: 'Ocultar del PDF',
            hidden_badge: 'Oculto del PDF',
            toggle_error: 'No se pudo cambiar la visibilidad de la sección',
          },
          // Phase 144 :: section headers (1.2 / 1.3)
          section: {
            executive_overview_title: '1. Resumen Ejecutivo',
            control_audits_title: 'Auditoría de Controles',
            exception_log_title: 'Registro de Excepciones',
            toc_aria_label: 'Tabla de contenidos',
            // Phase 145 §4 :: Process Security Assessment wrapper (PDF Sect 3).
            // ProcessSecurityAssessmentSection composes ControlAuditsSection
            // (variant='embedded') y aporta el título alineado al PDF + intro.
            process_security_assessment: {
              title: '7. Evaluación de seguridad de procesos',
              intro: 'Estado de los controles de proceso evaluados durante el período del informe.',
              empty: 'No hay controles evaluados aún.',
            },
            // Phase 145 §2 :: Organizational Risk Posture (replaces v1 Risk Analysis)
            organizational_risk_posture: {
              title: '2. Postura de riesgo organizacional',
              score_header: 'Riesgo de la empresa',
              level_label: 'Nivel: {{level}}',
              distribution: 'Distribución por banda de riesgo',
              band: {
                high: 'Alto',
                medium: 'Medio',
                low: 'Bajo',
              },
              empty: 'Sin datos suficientes para evaluar la postura.',
              bands_as_pct: '{{pct}}%',
              bands_as_count: '{{count}} ({{pct}}%)',
            },
            // Phase 145 §6 :: Behavioral Risk Categories (PDF demo Sect 6).
            // Data-only table sourced from CompanyModelEntity.categoryRisks.
            behavioral_risk_categories: {
              title: '4. Categorías de riesgo conductual',
              col_category: 'Categoría',
              col_score: 'Puntaje',
              col_level: 'Nivel',
              empty: 'Aún no hay categorías evaluadas.',
              level_high: 'Alto',
              level_medium: 'Medio',
              level_low: 'Bajo',
            },
            // Phase 145 §5 :: Department Risk Analysis (PDF demo Sect 4).
            // Tabla de 3 columnas alimentada por EmployeeService
            // .getGroupRiskBreakdown vía la transformación del orquestador.
            // Los conteos por banda NUNCA llegan acá (T-145-05 / D-11).
            department_risk: {
              title: '3. Riesgo por departamento',
              col_group: 'Departamento',
              col_score: 'Puntaje promedio',
              col_top_category: 'Categoría más expuesta',
              no_category: 'Sin categoría destacada',
              empty: 'Aún no hay departamentos evaluados.',
            },
            // Phase 145 §6 :: Phishing Simulation Results (PDF demo Sect 7,
            // unificado por D-06 a través de los vectores email + QR + Slack).
            // Tarjetas KPI agregadas + insight determinista por banda.
            // Bandas según fellRate: alta >= 10%, moderada >= 5%, baja < 5%.
            phishing_simulation_results: {
              title: '5. Resultados de simulaciones de phishing',
              kpi: {
                campaigns: 'Campañas en el período',
                targets: 'Objetivos totales',
                clicked: 'Total de clics',
                fell: 'Total de caídas',
              },
              insight: {
                high: 'Una tasa de caída de {{pct}}% indica alta exposición. Una sola cuenta comprometida puede abrir el resto del entorno.',
                moderate:
                  'Una tasa de caída de {{pct}}% señala exposición moderada. Reforzar entrenamiento y simulaciones reduce el riesgo.',
                low: 'Una tasa de caída de {{pct}}% refleja exposición controlada. Mantener la cadencia de simulaciones sostiene el nivel.',
              },
              empty: 'Sin campañas en el período.',
            },
            // Phase 146 W3 §7 :: QR Phishing Simulation (sección NUEVA, solo v3).
            // Prosa del composer hasta que W4 conecte el header de 4 stats + 2 barras.
            qr_phishing_simulation: {
              title: '6. Simulación de Phishing por QR',
              intro: 'Indicadores agregados de la campaña de phishing por QR durante el periodo del reporte.',
              empty: 'Aún no se capturaron datos de campañas QR para este período.',
            },
            // Phase 145 §7 (plan 07b) :: Expert Review (PDF demo Sect 9).
            // 3 tarjetas con chip que respaldan el sentinel de narrativa
            // `__expert_review__`. Los títulos están fijados (D-14); el
            // cuerpo es editable por el admin vía finalEdited (D-16).
            expert_review: {
              title: '8. Revisión experta',
              empty: 'La revisión experta aparecerá cuando se genere.',
              card: {
                training: {
                  title: 'Entrenamiento conductual dirigido',
                },
                simulations: {
                  title: 'Campañas de simulación continuas',
                },
                process_controls: {
                  title: 'Controles de verificación de procesos',
                },
              },
            },
            // Phase 147 v2 :: Recomendaciones Finales (4ta card de Expert Review).
            // Editable; data del catálogo de policies + motivation LLM.
            // Title/clauses/frameworks vienen del catálogo (resueltos por
            // idioma); solo motivation lo emite el LLM.
            policy_recommendations: {
              title: 'Recomendaciones Finales',
              empty: 'No se activaron recomendaciones de políticas para este período.',
              motivation_label: 'Por qué para esta organización',
              clauses_label: 'Cláusulas clave',
              frameworks_label: 'Marcos de referencia',
            },
          },
          // Phase 145 §6 :: localized category labels. Keys are the slugs
          // emitted por CategoryRiskService.slugifyCategoryKey; los slugs no
          // mapeados caen al nombre crudo vía defaultValue de i18next.
          category: {
            ai_and_emerging_threats: 'IA y amenazas emergentes',
            ai_emerging_threats: 'IA y amenazas emergentes',
            email_and_phishing_security: 'Seguridad de email y phishing',
            phishing_and_email_safety: 'Phishing y seguridad de email',
            phishing_email: 'Phishing y seguridad de email',
            phishing_awareness: 'Comportamiento ante simulaciones de phishing',
            device_security: 'Seguridad de dispositivos',
            data_handling_and_privacy: 'Manejo de datos y privacidad',
            data_privacy: 'Manejo de datos y privacidad',
            secure_navigation: 'Navegación segura y uso de SaaS',
            safe_browsing_saas: 'Navegación segura y uso de SaaS',
            account_and_password_security: 'Cuentas y contraseñas',
            account_password_security: 'Cuentas y contraseñas',
          },
          // Phase 144 / Phase 146 :: tarjetas de AI insight. El par
          // Síntesis ejecutiva + Síntesis de riesgo se eliminó (el
          // composer v3 emite rationale por sección que los componentes
          // dedicados renderizan).
          ai_insight: {
            control_drawer_card_title: 'Insight de IA',
            edit_button_aria: 'Editar este insight',
            cancel_button_label: 'Cancelar',
            save_button_label: 'Guardar',
            empty_organizational_risk_posture_title: 'Análisis pendiente',
            empty_organizational_risk_posture_body:
              'Hace click en "Analizar Reporte" arriba para sintetizar la postura de riesgo organizacional del periodo.',
            empty_control_drawer_title: 'Insight pendiente',
            empty_control_drawer_body:
              'Hace click en "Analizar Reporte" arriba para sintetizar un insight breve de este control.',
            zero_evidence_control_drawer_title: 'Sin evidencia capturada para este control',
            zero_evidence_control_drawer_body:
              'No hay transcripciones de entrevistas, hallazgos ni evaluaciones de criterios de este control dentro del periodo del reporte. Corré una entrevista de auditoría sobre este control para generar el insight.',
          },
          // Phase 144 :: charts (2.2)
          chart: {
            atlas_title: 'Riesgo por Equipo',
            atlas_caption:
              'Los equipos más grandes ocupan más espacio. Rojo es alto riesgo, amarillo medio, verde bajo.',
            atlas_legend_size: 'Tamaño = empleados del equipo',
            atlas_legend_color: 'Color = riesgo del equipo',
            atlas_empty: 'Aún no hay grupos organizacionales modelados. Carga la estructura en Atlas.',
            employee_risk_title: 'Riesgo por Empleado',
            employee_risk_caption: 'Distribución de empleados por nivel de riesgo durante el periodo.',
            employee_risk_x_axis: 'Nivel de riesgo',
            employee_risk_y_axis: 'Empleados',
            employee_risk_empty: 'Aún no hay datos de riesgo por empleado en este periodo.',
            risk_level_low: 'Bajo',
            risk_level_medium: 'Medio',
            risk_level_high: 'Alto',
            phishing_title: 'Concientización ante Phishing',
            phishing_caption: 'Tasa de caída en campañas de phishing simuladas durante el periodo.',
            phishing_value_label: 'Tasa de caída',
            phishing_reference_label: 'Periodo anterior',
            phishing_empty: 'Aún no se ejecutaron campañas de phishing en este periodo.',
          },
          // Phase 144 :: control audit tiles (3.1)
          tile: {
            criteria_count: '{{met}}/{{total}} criterios',
            status_met: 'Cumplido',
            status_partial: 'Parcial',
            status_failed: 'Falló',
            status_pending: 'Pendiente',
            status_hidden: 'Oculto',
            body_pending: 'Sin analizar',
            body_hidden: 'Oculto',
            body_all_met_one: 'Criterio cumplido',
            body_all_met_other: 'Los {{count}} criterios cumplidos',
            body_failed_evidence_one: '1 criterio sin evidencia',
            body_failed_evidence_other: '{{count}} criterios sin evidencia',
            body_partial_mix: '{{met}} de {{total}} cumplidos',
            ratio_caption: '{{met}}/{{total}} criterios',
            hide_action_aria: 'Ocultar del cuerpo principal',
            unhide_action_aria: 'Restaurar al cuerpo principal',
          },
          // Phase 144 :: drill-down drawer (3.2)
          drawer: {
            criteria_met_label_one: '1 de 1 criterio cumplido',
            criteria_met_label_other: '{{met}} de {{total}} criterios cumplidos',
            criteria_met_label_all: 'Los {{total}} criterios cumplidos',
            criteria_met_label_none: '{{total}} criterios sin evidencia',
            criteria_met_label: '{{met}}/{{total}} criterios cumplidos',
            compliance_label: 'Cumplimiento: {{percent}}%',
            description_heading: 'Descripción del control',
            evidence_heading: 'Evidencia vinculada',
            evidence_more: '+{{count}} más',
            evidence_empty: 'Sin evidencia vinculada todavía.',
            close_aria: 'Cerrar',
          },
        },
      },
      atlas_onboarding: {
        title: 'Mapeo Organizacional',
        description:
          'Has sido invitado a completar tu perfil organizacional. Este proceso te tomará unos minutos y nos ayudará a entender mejor la estructura de la organización.',
        optin_line1:
          'Ciphia es una plataforma de análisis de riesgo operativo y humano que ayuda a las organizaciones a fortalecer su postura de seguridad.',
        optin_line2:
          'Al continuar, aceptas que tus respuestas serán procesadas y analizadas mediante inteligencia artificial con el único fin de evaluar y mejorar la seguridad de la organización.',
        optin_line3: 'Tus datos serán tratados de forma confidencial y no serán compartidos con terceros.',
        cta: 'Aceptar y comenzar',
        expired_title: 'Enlace expirado',
        expired_subtitle: 'Este enlace ha expirado. Solicita una nueva invitación a tu administrador.',
        invalid_title: 'Enlace inválido',
        invalid_subtitle: 'Este enlace no es válido. Verifica que la URL sea correcta o solicita una nueva invitación.',
        completed_title: 'Completado',
        completed_subtitle:
          'Gracias por completar la entrevista. Esto ayudará a mejorar la postura de seguridad de la organización.',
        interview_completed: 'Entrevista completada',
        interview_completed_hint: 'Puedes finalizar cuando estés listo.',
        finalize: 'Finalizar',
        confirm_and_finish: 'Confirmar y finalizar',
        findings: 'Hallazgos',
        people: 'Personas',
        groups: 'Grupos',
        relations: 'Relaciones',
        avatar_you: 'Tú',
        self_label: 'Yo',
        input_placeholder: 'Escribe tu respuesta...',
        send_sr: 'Enviar',
        block_role: 'Rol',
        block_hierarchy: 'Jerarquía',
        block_relations: 'Relaciones',
        review_title: 'Resumen de la entrevista',
        review_subtitle: 'Revisá la información extraída. Si algo no es correcto, escribí abajo para corregir.',
        review_your_info: 'Tu información',
        review_department: 'Departamento',
        review_responsibilities: 'Responsabilidades',
        review_people: 'Personas mencionadas',
        review_departments: 'Departamentos mencionados',
        review_relations: 'Relaciones',
        review_correction_hint: '¿Algo incorrecto? Escribí la corrección y la incorporamos.',
        review_correction_placeholder: 'Ej: Renata es COO, no CTO...',
        rel_reports_to_first: 'reporto a',
        rel_reports_to_third: 'reporta a',
        rel_works_in_first: 'trabajo en',
        rel_works_in_third: 'trabaja en',
        rel_works_with_first: 'trabajo con',
        rel_works_with_third: 'trabaja con',
        rel_collaborates_with_first: 'colaboro con',
        rel_collaborates_with_third: 'colabora con',
        rel_manages_first: 'gestiono a',
        rel_manages_third: 'gestiona a',
        rel_belongs_to_first: 'pertenezco a',
        rel_belongs_to_third: 'pertenece a',
        rel_has_role_first: 'tengo rol',
        rel_has_role_third: 'tiene rol',
        rel_member_of_first: 'soy miembro de',
        rel_member_of_third: 'es miembro de',
      },
      atlas: {
        send_onboarding: 'Enviar onboarding',
        col_consent: 'Consentimiento',
        col_status: 'Estado Atlas',
        col_relations: 'Relaciones',
        status_merged: 'Completado',
        status_in_progress: 'En progreso',
        status_pending: 'Pendiente',
        status_not_started: 'Sin iniciar',
        consent: {
          title: 'Atlas: Mapa Organizacional',
          accept: 'Aceptar y comenzar',
          decline: 'Declinar',
          understood: 'Entendido',
          declined_title: 'Atlas no activado',
          declined_message: 'Puedes cambiar tu decisión desde tu perfil en cualquier momento.',
        },
        send_invitations: 'Enviar Invitaciones',
        pending_changes: 'Hay cambios pendientes en el grafo',
        discard: 'Descartar',
        apply_changes: 'Aplicar cambios',
        relations: {
          REPORTS_TO: { out: 'reporta a', in: 'es jefe de' },
          COLLABORATES_WITH: { out: 'colabora con', in: 'colabora con' },
          BELONGS_TO: { out: 'pertenece a', in: 'incluye a' },
        },
        status: {
          completed: 'Completado',
          not_started: 'Sin iniciar',
        },
        card: {
          relations: 'Relaciones',
          role: 'Rol',
          department: 'Departamento',
          risk: 'Riesgo',
          consent: 'Consentimiento',
          onboarding: 'Onboarding',
          type: 'Tipo',
          type_employee: 'Empleado',
          type_group: 'Grupo',
          type_company: 'Empresa',
          type_candidate: 'Candidato',
          type_department: 'Grupo/Departamento',
          undefined: 'Sin definir',
          yes: 'Sí',
          no: 'No',
          link_to_employee: 'Vincular a empleado existente',
          search_employee: 'Buscar empleado...',
          link: 'Vincular',
        },
      },
      auditor_dialog: {
        title: 'Auditor interno',
        subtitle:
          'Consultá al auditor sobre criterios, evidencia y hallazgos. Subí o eliminá evidencia desde la lista de evidencias en esta página.',
        language_hint: 'Conversación en {{language}}',
        language_hint_label: { en: 'Inglés', es: 'Español' },
        empty_state: {
          title: 'Aún no hay mensajes',
          body: 'Enviá un mensaje para iniciar la conversación. El auditor responde automáticamente.',
        },
        role: {
          admin: 'Yo',
          auditor: 'Auditor',
        },
        input: {
          placeholder: 'Escribí tu consulta para el auditor...',
          send: 'Enviar',
        },
        soft_cap: {
          warning_30: '{{count}} de {{cap}} respuestas usadas. Cerrá la conversación pronto.',
          warning_50: 'Límite de respuestas alcanzado. Cerrá el panel y seguí desde la lista de evidencias.',
        },
        error: {
          send_failed: 'No se pudo enviar el mensaje. Intentá de nuevo.',
        },
      },
      control_findings_card: {
        empty_state: {
          description:
            'Los hallazgos se organizan por criterio, no por pasos del proceso. Cada tarjeta es un criterio que el auditor revisa contra tu entrevista.',
        },
        description_label: 'Qué verifica este criterio',
        rationale_label: 'Por qué este estado',
        rationale_pending: 'Todavía no se registró una justificación para este criterio.',
        evidence_quote_label: 'Lo que dijo la persona entrevistada',
        expand_details: 'Ver detalle',
        status: {
          met: 'Cumplido',
          partial: 'Parcial',
          failed: 'No cumplido',
          not_applicable: 'N/A',
          insufficient_evidence: 'Evidencia insuficiente',
        },
        severity: {
          mandatory: 'Obligatorio',
          customary: 'Habitual',
          nice_to_have: 'Recomendable',
        },
        framework_label_soc2: 'SOC 2',
        framework_label_iso27001: 'ISO 27001',
        framework_label_nist_csf: 'NIST CSF',
        manual_override_badge: 'Manual',
        override_button: 'Override',
        override_set_met: 'Marcar como Cumplido',
        override_set_partial: 'Marcar como Parcial',
        override_set_failed: 'Marcar como No cumplido',
        override_set_na: 'Marcar como N/A',
        override_clear: 'Quitar override',
        override_apply_success: 'Override manual aplicado',
        override_clear_success: 'Override quitado',
        override_failure: 'No se pudo aplicar el override',
        override_modal: {
          title: 'Cambiar estado del criterio',
          status_label: 'Estado a aplicar',
          status_met: 'Cumplido',
          status_partial: 'Parcial',
          status_failed: 'No cumplido',
          status_not_applicable: 'No aplica',
          status_clear: 'Quitar (volver al sistema)',
          justification_label: 'Justificación (requerida)',
          justification_placeholder: 'Por ejemplo: control compensatorio X cubre este punto',
          justification_min: 'Ingresá al menos 5 caracteres',
          submit: 'Confirmar',
          cancel: 'Cancelar',
        },
        override_history: {
          title: 'Historial de overrides',
          empty: 'Sin overrides previos',
          action_set: 'Estado aplicado',
          action_clear: 'Estado revertido al sistema',
          actor_label: 'Por',
          timestamp_label: 'Fecha',
          justification_label: 'Justificación',
        },
      },
      findings_summary_card: {
        overall_status: {
          compliant: 'Cumple',
          partial: 'Parcial',
          non_compliant: 'No cumple',
          pending: 'Pendiente',
        },
        kpi_met: 'Cumple',
        kpi_partial: 'Parcial',
        kpi_failed: 'Falla',
        kpi_not_applicable: 'No aplica',
        score_label: 'Puntaje de cumplimiento',
        score_unavailable: 'Sin puntos aún',
        criteria_label: 'Puntos de evidencia',
        last_evaluated_at: 'Última evaluación: {{date}}',
        framework_refs_label: 'Marcos de referencia',
        what_this_means_label: 'Qué significa este control',
      },
      auditor_drawer: {
        empty_state_heading: 'Preguntale al auditor',
        empty_state_bullet_ask: '¿Qué cerraría los criterios que fallan?',
        empty_state_bullet_clarify: '¿Qué hallazgo debería arreglar primero, y por qué?',
      },
      findings: {
        view_interview_tooltip: 'Ver entrevista',
      },
    },
  },
}
